import { Component, OnInit, OnDestroy, HostListener, effect, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { ResponseAnalyticsService, TrendsSummaryQuestionSelection } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { ScoreDropdownMenuComponent } from '../score-dropdown-menu/score-dropdown-menu.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ScoreWidgetComponent } from '../score-widget/score-widget.component';
import { LtmsErrorComponent } from '../../ltms-error/ltms-error.component';
import { ScoreTableComponent } from '../score-table/score-table.component';
import { ScoreLineChartComponent } from '../score-line-chart/score-line-chart.component';
import { ScoreBarChartComponent } from '../score-bar-chart/score-bar-chart.component';
import { ScoreDrilldownBarChartComponent } from '../score-drilldown-bar-chart/score-drilldown-bar-chart.component';
import { ScoreComparisonToggleComponent } from '../score-comparison-toggle/score-comparison-toggle.component';
import {
  attachMetricDeviations,
  attachRatingResponseDeviations,
  extractComparisonDistributionsFromRatingEntry,
  getAccountSummaryMetrics,
  getComparisonPeriodLabel,
  getComparisonDetailedRatingResult,
  getNumericMetricsFromRatingResult,
  getShowComparisonFlag,
  isComparisonAvailable,
  setShowComparisonFlag,
} from 'src/app/shared/utils/score-deviation.util';
import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-score-trends',
  templateUrl: './score-trends.component.html',
  styleUrls: ['./score-trends.component.scss'],
  imports: [NgIf, LtmsLoaderComponent, NgClass, ScoreDropdownMenuComponent, NgbTooltip, ScoreWidgetComponent, NgStyle, LtmsErrorComponent, ScoreTableComponent, ScoreLineChartComponent, NgFor, ScoreBarChartComponent, ScoreDrilldownBarChartComponent, ScoreComparisonToggleComponent]
})

export class ScoreTrendsComponent implements OnInit, OnDestroy {
  mainDiscription = 'Analyze the primary score, its components, and score distribution over time, with adjustable detail across multiple dimensions. Get a quick overview of the score and total responses for the selected period.';
  scoreDiscription = 'Gain insights into the overall score and response breakdown across various dimensions. Click the launch icon to navigate, or select a row to filter the trend charts.';
  projectLevelScoreDescription = 'Explore detailed insights into the overall score and response distribution across different dimensions. Click the plus icon to expand a row, or select a row to filter the trend charts.';
  scoreTrendsDiscription = 'Track score trends with adjustable time views (daily, weekly, etc.), showing overall data or data for a selected row. Hover to view scores and distribution for specific time intervals.';
  responseTrendDiscription = 'Analyze the overtime response trend with adjustable time views (daily, weekly, etc.), displaying overall data or data for a selected row. Hover to see details for specific time intervals.';
  topandBottomPerformers = 'Identify high and low-performing cohorts, along with key areas for improvement. Hover over bars for detailed values, or click to drill down into specific cohort data.';

  showComparisonFlag = false;
  readonly trendsTablePlugins = { deviationAlignment: true };
  isComparisonAvailable = true;
  dateType = 'period';
  comparisonPeriodLabel = '';

  fullScreenComponent = '';
  isFullScreen = false;
  isAccountLevel = false;
  helpersResponse: any = {};
  helpersResponseCame = false;
  scalerRaterType: any = null;
  scalerRaterTypeCache: any = null;
  scalerRaterTypeCame = false;

  viewTypeDropdown: any = { config: { width: '128px', isDisabled: true, tab: 'scoreViewtype' }, selectedOption: '', options: [] };
  @ViewChild('viewTypeDropdownMenu') viewTypeDropdownMenu?: ScoreDropdownMenuComponent;
  viewTypeDropdownSelectedName = '';
  viewTypeDropdownSelectedFieldId = '';
  viewTypeDropdownSelectedFieldType = '';
  viewTypeDropdownSelectedDataType: any = '';
  viewTypeDropdownProcessedChild: any = [];

  lhsBoxLoader = true;
  lhsBoxError = false;
  overallTable: any = { header: [], row: [] };
  overallTableDataCache: any = {};

  hierarchyTableLoader = true;
  hierarchyTableError = false;
  subAccountTable: any = { header: [], row: [] };
  subAccountFilter: any = [];

  isHierarchyTableVisible = true;
  hierarchyTable: any = { header: [], row: [] };
  hierarchyTableCache: any = { header: [], row: [] };

  cohortsFilter: any = [];
  updateChartEvent: any = [];
  datePickerCache: any = {};
  hierarchyStackCache: any = {};
  projectTypeCache: any = null;

  raterTypeDetails: any = {
    // '0-10': { min: -100, max: 100 },
    // '1-5': { min: -100, max: 100 },
    '1-10': { min: 0, max: 10 },
    '-5 to 5': { min: -5, max: 5 },
    '-5 to +5': { min: -5, max: 5 },
    '1': { min: -5, max: 5 },
    // '3': { min: -100, max: 100 },
    '4': { min: 0, max: 5 },
    '5': { min: 0, max: 5 },
    '6': { min: 0, max: 10 },
    '7': { min: 0, max: 6 },
    '8': { min: -3, max: 3 },
    '9': { min: 0, max: 4 }
  }
  lineChartPlugins: any = {
    lineColor: '#2CA02C',
    gradientStartColor: '#2CA02C',
    gradientEndColor: '#2CA02C0F',
    borderWidth: 2,
    pointBorderWidth: 2,
    pointRadius: 6,
    pointBorderColor: '#ffffff',
  };
  lineChartLoader = true;
  lineChartError = false;
  lineChartDisplayName = '';
  lineChartDisplay = '';
  lineChartName = '';
  chartName = '';
  lineChartTrendType: any = '';
  lineChartData: any = {};
  lineChartDataCache: any = {};

  isBarChartTypePercentage = false;
  barChartLoader = true;
  barChartError = false;
  barChartDisplay = '';
  barChartName = '';
  barChartTrendType: any = '';
  barChartPlugins: any = {
    yText: 'Responses'
  };
  barChartData: any = {};
  barChartDataCache: any = {};

  performerTypeDropdown: any = { config: { width: '128px', isDisabled: true, tab: 'scoreViewtype' }, selectedOption: '', options: [] };
  performerTypeDropdownSelectedName = '';
  performerTypeDropdownSelectedFieldId = '';
  performerTypeDropdownSelectedFieldType = '';
  performerTypeDropdownSelectedDataType = '';
  performerTypeDropdownProcessedChild: any = [];
  isTopPerformers = true;
  isBottomPerformers = false;
  perfomerChartLoader = true;
  perfomerChartError = false;
  performerChartData: any = {};
  performerChartDataCache: any = {};
  topandbottomperformersortedData: any = [];
  cohortsFilterChart: any = [];
  drilldownChartCache: any = [];
  performerChartDataForDownload: any = [];
  downloadPerformerDataFromJob = false;
  performerPayload: any = null;
  performerDrilldownPayloads: any = [];

  downloadTableDataFromJob = false;
  overallPayload: any = {};
  hierarchyPayload: any = {};
  textHighLightId: any = 'overallTable';

  /** Project Trends: rating question from "View by" row (primary_rating vs is_displayed_on_summary) */
  trendsSummarySelectedFieldId = 'primary_rating';
  trendsSummarySelectedScaleRaterType: string | undefined;
  trendsQuestionSelected: string | undefined;

  private static readonly TRENDS_SUMMARY_LABEL_MAX = 30;
  trendsSummaryQuestionDropdownVisible = false;
  trendsSummaryQuestionDropdown: any = {
    config: {
      width: '250px',
      isDisabled: false,
      tab: 'trends-summary-question',
      margin: '0',
      selectedFullTitle: '',
    },
    selectedOption: '',
    options: [] as any[],
  };

  scoreWidget(type): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: type === 'lineChart' || type === 'barChart' ? true : false,
      isAbsoluteChartShow: type === 'barChart' ? true : false,
      isPercenttageChartShow: type === 'barChart' ? true : false,
    };
  }

  onFullScreen(event, cardName) {
    this.isFullScreen = !this.isFullScreen;
    this.fullScreenComponent = this.isFullScreen ? cardName : '';
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(_event: Event): void {
    this.isFullScreen = false;
    this.fullScreenComponent = '';
  }

  onOverlayClick() {
    this.isFullScreen = false;
    this.fullScreenComponent = '';
  }

  onOptionChange(event, cardName) {
    if (cardName === 'viewType') {
      this.textHighLightId = 'overallTable';
      this.cohortsFilter = [];
      this.subAccountFilter = [];
      this.updateChartEvent = {};
      this.lineChartTrigger$.next();
      this.barChartTrigger$.next();

      this.hierarchyTableCache.header = [];
      this.hierarchyTableCache.row = [];
      this.viewTypeDropdown.selectedOption = event?.labelShort ?? event?.name ?? '';
      this.viewTypeDropdownSelectedName = event?.name || '';
      this.viewTypeDropdownSelectedFieldId = event?.field_id || null;
      this.viewTypeDropdownSelectedFieldType = event?.field_type || 'tag';
      this.viewTypeDropdownProcessedChild = event?.child || null;
      this.viewTypeDropdownSelectedDataType = event?.data_type || null;
      this.callApiForHierarchyTable();
      this.callApiForOverallTab();
    }

    if (cardName === 'performerChart') {
      this.resetUniversalFilter();
      this.drilldownChartCache = [];
      this.downloadPerformerDataFromJob = false;
      this.performerPayload = null;
      this.performerDrilldownPayloads = [];
      this.cohortsFilterChart = [];
      this.performerTypeDropdownSelectedName = event?.name || '';
      this.performerTypeDropdownSelectedFieldId = event?.field_id || null;
      this.performerTypeDropdownSelectedFieldType = event?.field_type || 'tag';
      this.performerTypeDropdownProcessedChild = event?.child || null;
      this.performerTypeDropdownSelectedDataType = event?.data_type || null;
    }
  }

  onGraphDataPointClick(event, cardName, index) {
    if (cardName === 'performerChartData') {
      if (this.isAccountLevel) {
        if (index == null) {
          this.drilldownChartCache = [];
          this.cohortsFilterChart = [];
          this.performerChartDataForDownload.splice(1);
          let filters: any = [];
          let filter: any = {
            field_id: event?.data?.fieldId,
            type: 'tag',
            value: event?.data?.labels[event?.clickedIndex],
            field_type: "tag",
            field_value: event?.data?.labels[event?.clickedIndex]
          }
          filters.push(filter);
          this.cohortsFilterChart.push({
            cohorts_filter: filters,
            currentName: event?.data?.labels[event?.clickedIndex],
            currentFieldId: event?.data?.fieldId,
            currentFieldType: 'tag',
            nextName: this.performerTypeDropdownProcessedChild && this.performerTypeDropdownProcessedChild.length > 0 && this.performerTypeDropdownProcessedChild[1]?.name ? `${this.performerTypeDropdownProcessedChild[1]?.name} (${event?.data?.labels[event?.clickedIndex]})` : null,
            nextFieldId: this.performerTypeDropdownProcessedChild && this.performerTypeDropdownProcessedChild.length > 0 && this.performerTypeDropdownProcessedChild[1]?.field_id ? this.performerTypeDropdownProcessedChild[1]?.field_id : null,
            nextFieldType: 'tag'
          })
        } else {
          this.cohortsFilterChart.splice(index + 1);
          this.drilldownChartCache.splice(index + 1);
          this.performerChartDataForDownload.splice(index + 2);
          let filters: any = _.cloneDeep(this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.cohorts_filter);
          let filter: any = {
            field_id: event?.data?.fieldId,
            type: 'tag',
            value: event?.data?.labels[event?.clickedIndex],
            field_type: "tag",
            field_value: event?.data?.labels[event?.clickedIndex]
          }
          filters.push(filter);
          this.cohortsFilterChart.push({
            cohorts_filter: filters,
            currentName: event?.data?.labels[event?.clickedIndex],
            currentFieldId: event?.data?.fieldId,
            currentFieldType: 'tag',
            nextName: `${this.performerTypeDropdownProcessedChild[index + 2]?.name} (${event?.data?.labels[event?.clickedIndex]})`,
            nextFieldId: this.performerTypeDropdownProcessedChild[index + 2]?.field_id,
            nextFieldType: 'tag'
          })
        }
        this.setUniversalFilter('tag_filter');
      } else if (this.isAccountLevel === false) {
        if (index == null) {
          this.drilldownChartCache = [];
          this.cohortsFilterChart = [];
          this.performerChartDataForDownload.splice(1);
          let filters: any = [];
          const { fieldId, fieldType, values } = event?.data;
          if (fieldType === 'response') {
            let detailedFeedbackItems = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', null);
            let detailedFeedbackItem = _.find(detailedFeedbackItems, { field_id: fieldId }, null);
            if (detailedFeedbackItem?.type === 'multi-select') {
              let multiSelectFieldIds = detailedFeedbackItems
                .filter(item => item?.group_id === this.performerTypeDropdownSelectedFieldId)
                .map(item => ({ field_id: item?.field_id, value: item?.value }));
              const result = _.find(multiSelectFieldIds, { value: Number(values[event?.clickedIndex]) });
              filters.push({ field_id: result?.field_id, field_type: 'response', field_value: Number(values[event?.clickedIndex]) });
            } else {
              filters.push({ field_id: fieldId, field_type: 'response', field_value: Number(values[event?.clickedIndex]) });
            }
          } else if (fieldType === 'tag' || fieldType === 'interaction') {
            filters.push({ field_id: fieldId, field_type: 'tag', field_value: values[event?.clickedIndex] });
          }
          this.cohortsFilterChart.push({
            cohorts_filter: filters,
            currentName: event?.data?.labels[event?.clickedIndex],
            currentFieldId: event?.data?.fieldId,
            currentFieldType: fieldType,
            currentValue: values[event?.clickedIndex],
            nextName: this.performerTypeDropdownProcessedChild && this.performerTypeDropdownProcessedChild.length > 0 && this.performerTypeDropdownProcessedChild[1]?.name ? `${this.performerTypeDropdownProcessedChild[1]?.name} (${event?.data?.labels[event?.clickedIndex]})` : null,
            nextFieldId: this.performerTypeDropdownProcessedChild && this.performerTypeDropdownProcessedChild.length > 0 && this.performerTypeDropdownProcessedChild[1]?.field_id ? this.performerTypeDropdownProcessedChild[1]?.field_id : null,
            nextFieldType: this.performerTypeDropdownProcessedChild && this.performerTypeDropdownProcessedChild.length > 0 && this.performerTypeDropdownProcessedChild[1]?.field_type ? this.performerTypeDropdownProcessedChild[1]?.field_type === 'response' ? 'response' : 'tag' : null
          })
          if (fieldType === 'response') {
            this.setUniversalFilter('question_filter');
          } else {
            this.setUniversalFilter('tag_filter');
          }
        } else {
          this.cohortsFilterChart.splice(index + 1);
          this.drilldownChartCache.splice(index + 1);
          this.performerChartDataForDownload.splice(index + 2);
          let filters: any = _.cloneDeep(this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.cohorts_filter);
          const { fieldId, fieldType, values } = event?.data;
          if (fieldType === 'response') {
            let detailedFeedbackItems = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', null);
            let detailedFeedbackItem = _.find(detailedFeedbackItems, { field_id: fieldId }, null);
            if (detailedFeedbackItem?.type === 'multi-select') {
              let multiSelectFieldIds = detailedFeedbackItems
                .filter(item => item?.group_id === this.performerTypeDropdownSelectedFieldId)
                .map(item => ({ field_id: item?.field_id, value: item?.value }));
              const result = _.find(multiSelectFieldIds, { value: Number(values[event?.clickedIndex]) });
              filters.push({ field_id: result?.field_id, field_type: 'response', field_value: Number(values[event?.clickedIndex]) });
            } else {
              filters.push({ field_id: fieldId, field_type: 'response', field_value: Number(values[event?.clickedIndex]) });
            }
          } else if (fieldType === 'tag' || fieldType === 'interaction') {
            filters.push({ field_id: fieldId, field_type: 'tag', field_value: values[event?.clickedIndex] });
          }
          this.cohortsFilterChart.push({
            cohorts_filter: filters,
            currentName: event?.data?.labels[event?.clickedIndex],
            currentFieldId: event?.data?.fieldId,
            currentFieldType: fieldType,
            currentValue: values[event?.clickedIndex],
            nextName: `${this.performerTypeDropdownProcessedChild[index + 2]?.name} (${event?.data?.labels[event?.clickedIndex]})`,
            nextFieldId: this.performerTypeDropdownProcessedChild && this.performerTypeDropdownProcessedChild.length > 0 && this.performerTypeDropdownProcessedChild[index + 2]?.field_id ? this.performerTypeDropdownProcessedChild[index + 2]?.field_id : null,
            nextFieldType: this.performerTypeDropdownProcessedChild && this.performerTypeDropdownProcessedChild.length > 0 && this.performerTypeDropdownProcessedChild[index + 2]?.field_type ? this.performerTypeDropdownProcessedChild[index + 2]?.field_type === 'response' ? 'response' : 'tag' : null
          })
          if (fieldType === 'response') {
            this.setUniversalFilter('question_filter');
          } else {
            this.setUniversalFilter('tag_filter');
          }
        }
      }
    } else if (cardName === 'lineChart' || cardName === 'barChart') {
      if (moment(event).isValid()) {
        const trendTypes = cardName === 'barChart' ? this.barChartName : this.lineChartName;
        const dateRange = this.getDateRange(event, trendTypes);
        const dateRangeObj = {
          "formatedStartDate": moment(dateRange?.startDate, "YYYYMMDD").format("DD MMM 'YY"),
          "formatedEndDate": moment(dateRange?.endDate, "YYYYMMDD").format("DD MMM 'YY"),
          "startDate": dateRange?.startDate,
          "endDate": dateRange?.endDate,
          "isCustomDateRangeSelected": true,
          "isPresetActive": false,
          "isRequestDate": Helpers?.datePicker?.isRequestDate,
          "selectedTrend": Helpers?.datePicker?.selectedTrend,
          "trendType": this.lineChartName.toLowerCase(),
          "dateFilterType": Helpers?.datePicker?.dateFilterType,
          "is_brand_creation_date_range": Helpers?.datePicker?.is_brand_creation_date_range
        };
        this.helpersService.setDatePicker(dateRangeObj)
      }
    }
  }

  setUniversalFilter(filterType) {
    let data = {
      count: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.cohorts_filter.length,
      tag_name: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.currentFieldId,
      value: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.currentName,
      child: this.performerTypeDropdownProcessedChild
    };
    if (this.isAccountLevel === false) {
      data['values'] = this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.currentValue;
    } else if (this.isAccountLevel) {
      data['values'] = this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.currentName;
    }
    this.helpersService.setUniversalFilter(filterType, 'set', data);
  }

  resetUniversalFilter() {
    this.helpersService.setUniversalFilter('tag_filter', 'reset', 'reset');
    this.helpersService.setUniversalFilter('question_filter', 'reset', 'reset');
  }

  checkUniversalFilter(): any {
    const universalFilter = _.get(Helpers, 'universalFilter', null);
    if (!universalFilter) return false;
    if (this.isAccountLevel) {
      const tagFilter = _.get(universalFilter, 'tag_filter', null);
      if (!tagFilter || Object.keys(tagFilter).length === 0) return false;
      const lastKey = Object.keys(tagFilter).pop();
      const lastObj = tagFilter[lastKey!];
      return lastObj?.applied_from === 'rhs_cohorts';
    } else if (this.isAccountLevel === false) {
      const tagKeys = Object.keys(universalFilter);
      for (const item of tagKeys) {
        const data = universalFilter[item];
        const tagKey = Object.keys(data);
        const lastTagKey = tagKey[tagKey.length - 1];
        if (data[lastTagKey]?.applied_from === 'rhs_cohorts') {
          return true;
        }
      }
      return false;
    }
  }

  filterUniversalFilter(): any {
    const universalFilter = _.get(Helpers, 'universalFilter', null);
    if (!universalFilter) return false;
    if (this.isAccountLevel) {
      const tagFilter = _.get(universalFilter, 'tag_filter', null);
      if (!tagFilter || Object.keys(tagFilter).length === 0) return null;
      const filtered = Object.fromEntries(
        Object.entries(tagFilter).filter(([_, value]) => {
          return (value as any)?.applied_from !== 'rhs_cohorts';
        })
      );
      return filtered;
    } else if (this.isAccountLevel === false) {
      return (universalFilter && !_.isEmpty(universalFilter)) ? universalFilter : null;
    }
    return null;
  }

  updateChart(event, cardName) {
    this.textHighLightId = event.key;
    if (cardName === 'overallTable') {
      this.chartName = event?.name;
      this.cohortsFilter = [];
      this.subAccountFilter = [];
      this.updateChartEvent = {};
      this.cohortsFilterChart = [];
      this.drilldownChartCache = [];
      this.resetUniversalFilter();
      this.lineChartTrigger$.next();
      this.barChartTrigger$.next();
      if (this.subAccountTable.row.length > 0) {
        const filteredRow = _.filter(this.subAccountTable.row, { isExpanded: true });
        if (filteredRow.length > 0) {
          filteredRow[0].drillDown = [];
          filteredRow[0].isExpanded = false;
        }
      }
      if (this.hierarchyTable.row.length > 0) {
        const filteredRow = _.filter(this.hierarchyTable.row, { isExpanded: true });
        if (filteredRow.length > 0) {
          filteredRow[0].drillDown = [];
          filteredRow[0].isExpanded = false;
        }
      }
    }

    if (cardName === 'subAccountTable') {
      const { sub_account_id, projectId, key, name } = event || {};
      if (sub_account_id || projectId) {
        this.updateChartEvent = {
          ...(sub_account_id && { subAccountId: sub_account_id }),
          ...(projectId && { projectId }),
          key,
          name
        };
      }
      this.callApiForPerformerChart();
      this.lineChartTrigger$.next();
      this.barChartTrigger$.next();
    }

    if (cardName === 'hierarchyTable') {
      if (this.isAccountLevel) {
        const { projectId, key, name, field_id, field_type, cohorts_filter } = event || {};
        if (projectId) {
          this.updateChartEvent = { projectId, key, name };
        } else {
          const filter = Array.isArray(cohorts_filter) ? [...cohorts_filter] : [];
          filter.push({
            field_id,
            type: field_type,
            value: name,
          });

          this.updateChartEvent = {
            cohorts_filter: filter,
            currentFieldId: field_id,
            currentFieldType: field_type,
            currentValueName: name,
            key,
            through: 'clickevent',
          };
        }
        this.callApiForPerformerChart();
        this.lineChartTrigger$.next();
        this.barChartTrigger$.next();
      } else if (this.isAccountLevel === false) {
        if (event?.field_type === 'tag' || event?.field_type === 'interaction' || event?.field_type === 'response') {
          const { field_id, field_sub_type, field_type, field_value, possible_values, field_data_type, name, key, upComingFieldType, filters = [], drillDown = [] } = event;
          const filter = [...filters];
          if (field_type === 'tag') {
            if (field_sub_type === 'multi-select' && Array.isArray(possible_values)) {
              filter.push({
                field_id: this.resolveMultiSelectFieldId(field_id, field_value, possible_values),
                field_type: 'tag',
                field_value,
                field_sub_type,
              });
            } else {
              filter.push({ field_id, field_type: 'tag', field_value: name, field_data_type });
            }
          } else if (field_type === 'interaction') {
            filter.push({ field_id, field_type: 'tag', field_value, field_data_type });
          } else if (field_type === 'response') {
            if (field_sub_type === 'multi-select') {
              filter.push({
                field_id: this.resolveMultiSelectFieldId(field_id, field_value, possible_values),
                field_type,
                field_value,
                field_sub_type,
              });
            } else {
              filter.push({ field_id, field_type, field_value, field_sub_type });
            }
          }
          this.updateChartEvent = {
            cohorts_filter: filter,
            currentFieldId: field_id,
            currentFieldType: field_type,
            currentValueName: name,
            key,
            through: 'clickevent',
          };
        } else if (event.field_type === "hierarchy") {
          const { field_id, field_type, name, key, filters = [] } = event;
          const filter = Array.isArray(filters) ? [...filters] : [];
          filter.push({
            field_id,
            field_type,
            field_value: name,
          });
          this.updateChartEvent = {
            cohorts_filter: filter,
            currentFieldId: field_id,
            currentFieldType: field_type,
            currentValueName: name,
            key,
            through: 'clickevent',
          };
        }
        this.callApiForPerformerChart();
        this.lineChartTrigger$.next();
        this.barChartTrigger$.next();
      }
    }
  }

  onDrillDownClick(event, cardName) {
    this.textHighLightId = event.key;
    if (cardName === 'subAccountTable') {
      const { sub_account_id, key, name } = event;
      const [currentFilter] = this.subAccountFilter;
      const isSameSubAccount = currentFilter?.subAccountId === sub_account_id;
      this.subAccountFilter = isSameSubAccount ? [] : [{ subAccountId: sub_account_id, key, name }];
      this.updateChartEvent = {
        subAccountId: event?.sub_account_id,
        key: event?.key,
        name: event?.name
      };
      this.callApiForSubAccount();
      this.lineChartTrigger$.next();
      this.barChartTrigger$.next();
    }

    if (cardName === 'hierarchyTable') {
      if (this.isAccountLevel) {
        this.getAccountUserCohortDetails(event);
      } else if (this.isAccountLevel === false) {
        this.getProjectUserCohortDetails(event);
      }
    }
  }

  getAccountUserCohortDetails(event) {
    const { field_id, field_type, name, key, cohorts_filter = [], drillDown = [] } = event || {};
    this.clearDrillDownByKey(_.cloneDeep(this.hierarchyTableCache.row), key);
    const buildFilter = (): any[] => [...cohorts_filter, { field_id, type: field_type, value: name }];
    const getDropdownContext = (fieldId: string) => {
      const index = _.findIndex(this.viewTypeDropdownProcessedChild, { field_id: fieldId });
      const next = this.viewTypeDropdownProcessedChild[index + 1];
      return {
        currentIndex: index,
        nextFieldId: next?.field_id,
        nextFieldType: next?.field_type,
        nextValueName: next?.name,
        isNextDrilldownAvailable: !!this.viewTypeDropdownProcessedChild[index + 2],
      };
    };
    const filter = buildFilter();
    const dropdownContext = getDropdownContext(field_id);
    const existingIndex = this.cohortsFilter.findIndex(
      item => item.currentFieldId === field_id && item.currentValueName === name
    );
    const sameFieldIndex = this.cohortsFilter.findIndex(item => item.currentFieldId === field_id);
    const newFilterEntry = {
      ...dropdownContext,
      cohorts_filter: filter,
      currentFieldId: field_id,
      currentFieldType: field_type,
      currentValueName: name,
      key,
      through: 'drilldown',
    };
    if (existingIndex > -1) {
      this.cohortsFilter.splice(existingIndex, this.cohortsFilter.length);
      this.updateChartEvent = newFilterEntry;
    } else {
      if (sameFieldIndex > -1) {
        this.cohortsFilter.splice(sameFieldIndex, this.cohortsFilter.length);
      }
      this.cohortsFilter.push(newFilterEntry);
      this.cohortsFilter = Array.from(
        new Map(this.cohortsFilter.map(item => [item.currentFieldId, item])).values()
      );
      this.updateChartEvent = _.cloneDeep(this.cohortsFilter.at(-1));
      if (drillDown.length === 0) {
        this.callApiForDrilldownTable();
      }
    }
    this.callApiForPerformerChart();
    this.lineChartTrigger$.next();
    this.barChartTrigger$.next();
  }

  getProjectUserCohortDetails(event) {
    if (event?.upComingFieldType) {
      this.prepareOtherCohortFilter(event);
    } else if (event.field_type === "hierarchy") {
      this.prepareHierarchyCohortFilter(event);
    }
  }

  prepareHierarchyCohortFilter(event) {
    const { field_id, field_type, name, key, filters = [], drillDown = [] } = event;
    const hierarchyListAlias = _.get(Helpers, 'brandDetails.hierarchy_list_alias', {});
    const valuesArray = hierarchyListAlias?.[Object.keys(hierarchyListAlias)[0]]?.values || [];
    const hierarchyMapping = _.get(Helpers, 'hierarchyMapping', {});
    const nextFieldId = valuesArray[valuesArray.indexOf(field_id) + 1];
    const nextValueName = hierarchyMapping?.[nextFieldId];
    const isNextDrilldownAvailable = Boolean(valuesArray[valuesArray.indexOf(field_id) + 3]);
    const baseFilter = [...filters, { field_id, field_type, field_value: name }];
    const chartEvent = {
      cohorts_filter: baseFilter,
      currentFieldId: field_id,
      currentFieldType: field_type,
      currentValueName: name,
      nextFieldId,
      nextFieldType: 'hierarchy',
      nextValueName,
      key,
      isNextDrilldownAvailable,
      through: 'drilldown'
    };
    this.clearDrillDownByKey(_.cloneDeep(this.hierarchyTableCache.row), key);
    const keyIndex = this.cohortsFilter.findIndex(item =>
      item.currentFieldId === field_id && item.currentValueName === name);
    const isFieldIdSame = this.cohortsFilter.findIndex(item =>
      item.currentFieldId === field_id);
    if (keyIndex > -1) {
      this.cohortsFilter.splice(keyIndex, this.cohortsFilter.length);
      this.updateChartEvent = chartEvent;
    } else {
      if (isFieldIdSame > -1) {
        this.cohortsFilter.splice(isFieldIdSame, this.cohortsFilter.length);
      }
      this.cohortsFilter.push(chartEvent);
      this.cohortsFilter = Array.from(
        new Map(this.cohortsFilter.map(item => [item.currentFieldId, item])).values()
      );
      this.updateChartEvent = _.cloneDeep(this.cohortsFilter[this.cohortsFilter.length - 1]);
      if (drillDown.length === 0) {
        this.callApiForDrilldownTable();
      }
    }
    this.callApiForPerformerChart();
    this.lineChartTrigger$.next();
    this.barChartTrigger$.next();
  }

  prepareOtherCohortFilter(event) {
    const { field_id, field_sub_type, field_type, field_value, possible_values, field_data_type, name, key, upComingFieldType, filters = [], drillDown = [] } = event;
    this.clearDrillDownByKey(_.cloneDeep(this.hierarchyTableCache.row), key);
    const buildFilter = () => {
      const filter = [...filters];
      if (field_type === 'tag') {
        if (field_sub_type === 'multi-select' && Array.isArray(possible_values)) {
          filter.push({
            field_id: this.resolveMultiSelectFieldId(field_id, field_value, possible_values),
            field_type: 'tag',
            field_value,
            field_sub_type,
          });
        } else {
          filter.push({ field_id, field_type: 'tag', field_value: name, field_data_type });
        }
      } else if (field_type === 'interaction') {
        filter.push({ field_id, field_type: 'tag', field_value, field_data_type });
      } else if (field_type === 'response') {
        if (field_sub_type === 'multi-select') {
          filter.push({
            field_id: this.resolveMultiSelectFieldId(field_id, field_value, possible_values),
            field_type,
            field_value,
            field_sub_type,
          });
        } else {
          filter.push({ field_id, field_type, field_value, field_sub_type });
        }
      }
      return filter;
    };
    const index = _.findIndex(this.viewTypeDropdownProcessedChild, { field_id });
    const getDropdownContext = () => {
      if (upComingFieldType === 'response') {
        return {
          currentInfo: event,
          currentIndex: index,
          nextFieldId: this.viewTypeDropdownProcessedChild[index + 1]?.field_id,
          nextFieldType: this.viewTypeDropdownProcessedChild[index + 1]?.field_type,
          nextValueName: this.viewTypeDropdownProcessedChild[index + 1]?.name,
          isNextDrilldownAvailable: !!this.viewTypeDropdownProcessedChild[index + 2],
          nextFieldSubType: this.viewTypeDropdownProcessedChild[index + 1]?.field_sub_type,
          nextPossibleValue: this.viewTypeDropdownProcessedChild[index + 1]?.possible_values
        };
      } else {
        return {
          currentInfo: event,
          currentIndex: index,
          nextFieldId: this.viewTypeDropdownProcessedChild[index + 1]?.field_id,
          nextFieldType: this.viewTypeDropdownProcessedChild[index + 1]?.field_type,
          nextValueName: this.viewTypeDropdownProcessedChild[index + 1]?.name,
          isNextDrilldownAvailable: !!this.viewTypeDropdownProcessedChild[index + 2],
        };
      }
    };
    const keyIndex = this.cohortsFilter.findIndex(item => item.currentFieldId === field_id && item.currentValueName === name);
    const fieldIdIndex = this.cohortsFilter.findIndex(item => item.currentFieldId === field_id);
    const filter = buildFilter();
    const dropdownContext = getDropdownContext();
    if (dropdownContext && this.viewTypeDropdownProcessedChild[index + 1]?.data_type) {
      dropdownContext['nextDataType'] = this.viewTypeDropdownProcessedChild[index + 1]?.data_type;
    }
    if (keyIndex > -1) {
      this.cohortsFilter.splice(keyIndex, this.cohortsFilter.length);
      this.updateChartEvent = {
        ...dropdownContext,
        cohorts_filter: filter,
        currentFieldId: field_id,
        currentFieldType: field_type,
        currentValueName: name,
        key,
        through: 'drilldown',
      };
    } else {
      if (fieldIdIndex > -1) {
        this.cohortsFilter.splice(fieldIdIndex, this.cohortsFilter.length);
      }
      const newFilter = {
        ...dropdownContext,
        cohorts_filter: filter,
        currentFieldId: field_id,
        currentFieldType: field_type,
        currentValueName: name,
        key,
        through: 'drilldown',
      };
      this.cohortsFilter.push(newFilter);
      this.cohortsFilter = Array.from(new Map(
        this.cohortsFilter.map(item => [item.currentFieldId, item])
      ).values());
      this.updateChartEvent = _.cloneDeep(this.cohortsFilter[this.cohortsFilter.length - 1]);
      if (drillDown.length === 0) {
        this.callApiForDrilldownTable();
      }
    }
    this.callApiForPerformerChart();
    this.lineChartTrigger$.next();
    this.barChartTrigger$.next();
  }

  clearDrillDownByKey(data, targetKey) {
    if (Array.isArray(data)) {
      data.forEach(item => this.clearDrillDownByKey(item, targetKey));
    } else if (typeof data === 'object' && data !== null) {
      if (data.key === targetKey) {
        data.drillDown = [];
        data.isExpanded = false;
        data.isLoading = false;
      }
      for (const key in data) {
        if (typeof data[key] === 'object') {
          this.clearDrillDownByKey(data[key], targetKey);
        }
      }
    }
  }

  onPerformerButtonClick(type: string): void {
    this.cohortsFilterChart = [];
    this.drilldownChartCache = [];
    this.downloadPerformerDataFromJob = false;
    this.performerPayload = null;
    this.performerDrilldownPayloads = [];
    if (type === 'topPerformer') {
      this.isTopPerformers = true;
      this.isBottomPerformers = false;
    } else if (type === 'bottomPerformer') {
      this.isTopPerformers = false;
      this.isBottomPerformers = true;
    }
    this.resetUniversalFilter();
    this.preparePerformerChart();
  }

  onDownload(cardName) {
    if (cardName === 'drillDownTable') {
      this.generateDrilldownReport();
    } else if (cardName === 'lineChart') {
      this.generateChartReport(cardName);
    } else if (cardName === 'barChart') {
      this.generateChartReport(cardName);
    } else if (cardName === 'performerType') {
      this.generatePerformerChartReport();
    }
  }

  onTrendChange(event, cardName) {
    if (cardName === 'lineChart') {
      this.lineChartDisplay = event?.display || '';
      this.lineChartName = event?.name || '';
      this.lineChartTrendType = event?.trend_type;
      this.lineChartTrigger$.next();
    }
    if (cardName === 'barChart') {
      this.barChartDisplay = event?.display || '';
      this.barChartName = event?.name || '';
      this.barChartTrendType = event?.trend_type;
      this.barChartTrigger$.next();
    }
  }

  onBarChartTypeChange(event: any): void {
    this.isBarChartTypePercentage = event;
    this.changeBarChart();
  }

  getDateRange(dateString, trendType) {
    let startDate = moment(dateString).startOf('day')
    let endDate: any = ''
    switch (trendType) {
      case 'Weekly':
        endDate = moment(startDate).endOf('week').add(1, 'day')
        break;
      case 'Monthly':
        startDate = moment(dateString, "MMM 'YY").startOf('month');
        endDate = moment(startDate).endOf('month');
        break;
      case 'Quarterly':
        const [monthsPart, yearPart] = dateString.split(' ');
        const startMonthAbbrev = monthsPart.split('-')[0];
        const fullDateString = `${startMonthAbbrev} ${yearPart}`;
        startDate = moment(fullDateString, "MMM 'YYYY").startOf('month');
        endDate = moment(startDate).endOf('quarter');
        break;
      case 'Yearly':
        endDate = moment(startDate).endOf('year');
        break;
      case 'Hourly':
      case 'Daily':
      default:
        endDate = moment(startDate).endOf('day')
        break;
    }
    return {
      startDate: moment(startDate).format('YYYYMMDD'),
      endDate: moment(endDate).format('YYYYMMDD')
    }
  }

  constructor(
    private appStateService: AppStateService,
    private responseAnalyticsService: ResponseAnalyticsService,
    private helpersService: HelpersService,
    private toastService: ToastService,
    private actionService: ActionService,
    private route: ActivatedRoute
  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        this.helpersResponse = _.cloneDeep(this.appStateService.appState());
        this.helpersResponseCame = true;
        this.execute();
      }
    })
  }

  private destroy$ = new Subject<void>();
  private lineChartTrigger$ = new Subject<void>();
  private barChartTrigger$ = new Subject<void>();

  ngOnInit(): void {
    this.lineChartTrigger$.pipe(debounceTime(100)).subscribe(() => {
      this.callApiForLineChart();
    })
    this.barChartTrigger$.pipe(debounceTime(100)).subscribe(() => {
      this.callApiForBarChart();
    })
    this.viewTypeDropdown.config.width = this.calculateViewButtonWidth();
    this.isAccountLevel = _.get(Helpers, 'isAccount', null);
    this.refreshComparisonLabels();
    if (this.isAccountLevel) {
      this.responseAnalyticsService.ratingInfo.pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response && response?.scalerType != this.scalerRaterType) {
          this.scalerRaterType = response?.scalerType;
          this.scalerRaterTypeCame = true;
          this.execute();
        }
      })
    } else {
      this.scoreDiscription = this.projectLevelScoreDescription;
    }

    this.responseAnalyticsService.trendsSummaryQuestionSelection
      .pipe(takeUntil(this.destroy$))
      .subscribe((sel) => {
        if (this.isAccountLevel) return;
        const fieldId = sel?.fieldId ?? 'primary_rating';
        const scale = sel?.scale_rater_type;
        this.trendsQuestionSelected = sel?.name;
        if (fieldId === this.trendsSummarySelectedFieldId && scale === this.trendsSummarySelectedScaleRaterType) return;
        this.trendsSummarySelectedFieldId = fieldId;
        this.trendsSummarySelectedScaleRaterType = scale;
        this.applyTrendLineChartScaleFromSelectedQuestion();
        if (!this.helpersResponseCame) return;
        this.resetViewTypeDropdownOnQuestionChange();
        this.cohortsFilter = [];
        this.subAccountFilter = [];
        this.updateChartEvent = {};
        this.callApiForOverallTab();
        this.callApiForHierarchyTable();
        this.lineChartTrigger$.next();
        this.barChartTrigger$.next();
      });

    if (!this.isAccountLevel) {
      this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
        if (params['account_id'] && params['project_id']) {
          this.refreshTrendsSummaryQuestionDropdown();
        }
      });
    }
  }

  private refreshTrendsSummaryQuestionDropdown(): void {
    const mainRaterType = _.get(Helpers, 'brandDetails.main_rater_type');
    if (mainRaterType == 2 || mainRaterType === '2') {
      this.trendsSummaryQuestionDropdownVisible = false;
      this.trendsQuestionSelected = undefined;
      this.trendsSummaryQuestionDropdown.options = [];
      this.trendsSummaryQuestionDropdown.config = {
        ...this.trendsSummaryQuestionDropdown.config,
        selectedFullTitle: '',
      };
      return;
    }
    const items: any[] = _.get(Helpers, 'brandDetails.detailed_feedback_items', []) || [];
    const hasSummaryFlag = items.some((q: any) => q?.is_displayed_on_summary === true);
    if (!hasSummaryFlag) {
      this.trendsSummaryQuestionDropdownVisible = false;
      this.trendsQuestionSelected = undefined;
      this.trendsSummaryQuestionDropdown.options = [];
      this.trendsSummaryQuestionDropdown.config = {
        ...this.trendsSummaryQuestionDropdown.config,
        selectedFullTitle: '',
      };
      this.responseAnalyticsService.setTrendsSummaryQuestionSelection(null);
      return;
    }
    const sorted = [...items].sort((a: any, b: any) => (a.seq_no ?? 0) - (b.seq_no ?? 0));
    const options: any[] = [];
    for (const q of sorted) {
      if (q?.is_deleted) continue;
      if (q?.type !== 'rating') continue;
      const isPrimary = q?.field_id === 'primary_rating' || q?.is_primary_rating === true;
      if (!isPrimary && !q?.is_displayed_on_summary) continue;
      const name = q.question && String(q.question).trim() ? q.question : q.text || q.field_id;
      const labelShort = this.truncateTrendsSummaryLabel(name);
      const scaleRaterType = q.scale_rater_type || this.inferScaleRaterTypeFromPossibleValues(q.possible_values);
      const mainRater = q.main_rater_type ?? _.get(Helpers, 'brandDetails.main_rater_type');
      options.push({
        name,
        labelShort,
        field_id: q.field_id,
        isPrefix: isPrimary,
        is_primary_rating: isPrimary,
        main_rater_type: mainRater,
        scale_rater_type: scaleRaterType,
      });
    }
    this.trendsSummaryQuestionDropdownVisible = options.length > 1;
    this.trendsSummaryQuestionDropdown.options = options;
    const primary =
      options.find((o: any) => o.field_id === 'primary_rating' || o.is_primary_rating) || options[0];
    if (primary) {
      this.trendsSummaryQuestionDropdown.selectedOption = this.formatTrendsSummaryDropdownSelection(primary);
      this.trendsSummaryQuestionDropdown.config = {
        ...this.trendsSummaryQuestionDropdown.config,
        selectedFullTitle: primary.name,
      };
      this.emitTrendsSummarySelection(primary);
    } else {
      this.trendsQuestionSelected = undefined;
      this.responseAnalyticsService.setTrendsSummaryQuestionSelection(null);
    }
  }

  private resetViewTypeDropdownOnQuestionChange(): void {
    this.textHighLightId = 'overallTable';
    this.hierarchyTableCache.header = [];
    this.hierarchyTableCache.row = [];
    if (this.viewTypeDropdown.options?.length > 0) {
      this.applyViewTypeDropdownDefaultSelection();
    }
  }

  private applyViewTypeDropdownDefaultSelection(): void {
    const defaultOption = this.viewTypeDropdown.options[0];
    if (!defaultOption) {
      return;
    }
    const defaultLabel = defaultOption.labelShort ?? defaultOption.name;
    this.viewTypeDropdown.config.isDisabled = false;
    this.viewTypeDropdown.selectedOption = defaultLabel;
    this.viewTypeDropdownSelectedName = defaultOption.name;
    this.viewTypeDropdownSelectedFieldId = defaultOption.field_id;
    this.viewTypeDropdownSelectedFieldType = defaultOption.field_type;
    this.viewTypeDropdownSelectedDataType = defaultOption.data_type;
    this.viewTypeDropdownProcessedChild = defaultOption.child;
    const menu = this.viewTypeDropdownMenu;
    if (menu) {
      menu.selectedOption = defaultLabel;
      menu.selectedField = defaultOption.field_id;
      menu.rawSelectedName = defaultOption.name;
    }
  }

  private refreshTrendsSummaryQuestionDropdownIfNeeded(): void {
    if (this.isAccountLevel || this.trendsSummaryQuestionDropdown.options.length > 0) {
      return;
    }
    this.refreshTrendsSummaryQuestionDropdown();
  }

  private truncateTrendsSummaryLabel(full: string): string {
    const s = full == null ? '' : String(full);
    if (s.length <= ScoreTrendsComponent.TRENDS_SUMMARY_LABEL_MAX) return s;
    return s.slice(0, ScoreTrendsComponent.TRENDS_SUMMARY_LABEL_MAX) + '...';
  }

  private formatTrendsSummaryDropdownSelection(option: any): string {
    const label = option?.labelShort ?? option?.name ?? '';
    if (option?.isPrefix && (option?.is_primary_rating || option?.field_id === 'primary_rating')) {
      return '<span><b>Primary question • </b></span>' + label;
    }
    return label;
  }

  private inferScaleRaterTypeFromPossibleValues(possibleValues: any): string | undefined {
    if (!possibleValues?.length) return undefined;
    const first = possibleValues[0];
    const last = possibleValues[possibleValues.length - 1];
    if (first == -5 && last == 5) return '-5 to 5';
    if (first == 0 && last == 10) return '0-10';
    if (first == 1 && last == 10) return '1-10';
    if (first == 1 && last == 6) return '7';
    if (first == 1 && last == 5) return '5';
    if (first == -3 && last == 3) return '8';
    if (first == 1 && last == 4) return '9';
    return undefined;
  }

  private emitTrendsSummarySelection(option: any): void {
    this.trendsQuestionSelected = option?.name;
    const sel: TrendsSummaryQuestionSelection = {
      fieldId: option.field_id,
      name: option.name,
      main_rater_type: option.main_rater_type,
      scale_rater_type: option.scale_rater_type,
    };
    this.responseAnalyticsService.setTrendsSummaryQuestionSelection(sel);
    const ext = _.get(Helpers, 'brandDetails.extender_rater_type');
    const scaler = option.main_rater_type ?? ext ?? _.get(Helpers, 'brandDetails.main_rater_type');
    if (scaler != null && scaler !== '') {
      this.responseAnalyticsService.setRatingInfo(Number(scaler));
    }
  }

  onTrendsSummaryQuestionSelected(option: any): void {
    if (!option?.field_id || option.disabled) return;
    this.trendsSummaryQuestionDropdown.selectedOption =
      option.labelShort ?? this.truncateTrendsSummaryLabel(option.name);
    this.trendsSummaryQuestionDropdown.config = {
      ...this.trendsSummaryQuestionDropdown.config,
      selectedFullTitle: option.name,
    };
    this.refreshComparisonLabels();
    this.emitTrendsSummarySelection(option);
  }

  private trendsQuestionIdsPayloadFragment(): { question_ids?: string[] } {
    // Rating summary pills: do not send question_ids (same as Comparison tab / old UI).
    // Alternate questions are read from detailed_rating_by_type[fieldId] in the response.
    return {};
  }

  private resolveTrendsSummaryFieldIdForCurrentBrand(): string {
    const fieldId = this.trendsSummarySelectedFieldId || 'primary_rating';
    if (fieldId === 'primary_rating') {
      return fieldId;
    }
    const items =
      _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', []) ||
      _.get(Helpers, 'brandDetails.detailed_feedback_items', []) ||
      [];
    if (items.some((q: any) => q.field_id === fieldId)) {
      return fieldId;
    }
    const primary = items.find((q: any) => q.is_primary_rating);
    return primary?.field_id || 'primary_rating';
  }

  private buildProjectComparisonBasePayload(overrides: Record<string, any> = {}): any {
    const base = this.helpersService.getInitialQueryParameters();
    const payload: any = {
      ...base,
      shop_id_list: base.shop_id_list ?? [],
      from: _.get(this.helpersResponse, 'datePicker.startDate', null),
      to: _.get(this.helpersResponse, 'datePicker.endDate', null),
      question_aggs: true,
      is_custom_date_range_selected: _.get(this.helpersResponse, 'datePicker.isCustomDateRangeSelected', null),
      date_filter_type: _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
      universal_filter: _.get(Helpers, 'universalFilter', null),
      ...this.trendsQuestionIdsPayloadFragment(),
      ...overrides,
    };
    if (payload.group_id || payload.shop_id) {
      payload.brand_id = null;
    }
    // On reload the global Helpers.hierarchyStack can lag behind the component's appState
    // snapshot, so getInitialQueryParameters() falls back to a wrong group_alias_key and
    // omits hierarchy_stack. Derive both from this.helpersResponse (the same snapshot the
    // component renders with) when the base payload is missing them.
    let hierarchyStack = _.get(this.helpersResponse, 'hierarchyStack', []) || [];
    hierarchyStack = hierarchyStack.filter(stack => stack?.field_id != 'touchpoints');
    if (hierarchyStack?.length) {
      if (!payload.hierarchy_stack?.length) {
        payload.hierarchy_stack = hierarchyStack;
      }
    }
    const groupAliasKey = this.getGroupAliasKey();
    if (groupAliasKey) {
      payload.group_alias_key = groupAliasKey;
    }
    return _.omitBy(payload, _.isNil);
  }

  private getEffectiveScaleRaterTypeForProject(): string {
    const items =
      _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', []) ||
      _.get(Helpers, 'brandDetails.detailed_feedback_items', []) ||
      [];
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    const matched = items.find((q: any) => q.field_id === fieldId);
    if (matched?.scale_rater_type) {
      return matched.scale_rater_type;
    }
    return items.find((item: any) => item.is_primary_rating)?.scale_rater_type ?? '';
  }

  private getSelectedTrendsSummaryQuestion(): any {
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    const items =
      _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', []) ||
      _.get(Helpers, 'brandDetails.detailed_feedback_items', []) ||
      [];
    return (
      items.find((q: any) => q.field_id === fieldId) ||
      items.find((q: any) => q.is_primary_rating) ||
      { field_id: 'primary_rating', type: 'rating', scale_rater_type: this.getEffectiveScaleRaterTypeForProject() }
    );
  }

  private getSelectedInteractionForDownload(): string {
    if (this.trendsQuestionSelected) {
      return this.trendsQuestionSelected;
    }
    const selectedQuestion = this.getSelectedTrendsSummaryQuestion();
    const name = selectedQuestion?.question || selectedQuestion?.text || selectedQuestion?.name;
    return name && String(name).trim() ? String(name).trim() : '';
  }

  private getComparisonEntryCurrentNode(entry: any): any {
    const normalized = this.normalizeComparisonEntry(entry);
    return normalized?.current ?? normalized;
  }

  private parseComparisonAverageRating(node: any): number | null {
    if (!node) {
      return null;
    }
    const candidates = [
      node.average_rating,
      node.avg_rating?.value,
      node.avg_rating,
      _.get(node, 'detailed_rating_by_type.primary_rating.average_rating'),
      _.get(node, 'detailed_rating_by_type.primary_rating.avg_rating.value'),
    ];
    for (const raw of candidates) {
      if (raw == null || raw === '' || raw === 'N/A') {
        continue;
      }
      const num = Number(raw);
      if (Number.isFinite(num)) {
        return num;
      }
    }
    return null;
  }

  private calculateWeightedRatingFromPrimaryDetails(details: any): string | null {
    const items = Array.isArray(details)
      ? details
      : Array.isArray(details?.buckets)
        ? details.buckets
        : details && typeof details === 'object'
          ? Object.values(details)
          : [];
    if (!items.length) {
      return null;
    }
    let sum = 0;
    let total = 0;
    for (const item of items) {
      const count = Number(
        item?.number_of_users_rated ?? item?.number_of_user_rated ?? item?.doc_count ?? 0
      );
      const ratingVal = item?.rating ?? item?.primary_rating ?? item?.key;
      if (!count || ratingVal == null) {
        continue;
      }
      sum += Number(ratingVal) * count;
      total += count;
    }
    return total > 0 ? (sum / total).toFixed(2) : null;
  }

  private resolvePrimaryComparisonRating(entry: any, currentNode: any, scalerRaterType: string): string | number | null {
    const fromApi =
      this.parseComparisonAverageRating(currentNode) ?? this.parseComparisonAverageRating(entry);
    if (fromApi != null) {
      return fromApi.toFixed(2);
    }
    const details = currentNode?.primary_rating_details ?? entry?.primary_rating_details;
    const fromDetails = this.calculateWeightedRatingFromPrimaryDetails(details);
    if (fromDetails != null) {
      return fromDetails;
    }
    const chartCalc = this.calculateDataForProjectChart(details);
    if (chartCalc?.rating != null && chartCalc.rating !== 'N/A' && chartCalc.rawResponse > 0) {
      return chartCalc.rating;
    }
    const distribution =
      currentNode?.primary_rating_distribution ?? entry?.primary_rating_distribution;
    if (distribution && !_.isEmpty(distribution)) {
      let sum = 0;
      let total = 0;
      Object.entries(distribution).forEach(([score, count]) => {
        total += Number(count) || 0;
        sum += Number(score) * (Number(count) || 0);
      });
      if (total > 0) {
        return (sum / total).toFixed(2);
      }
    }
    return null;
  }

  private calculateDataFromRatingNumber(
    ratingNumber: Record<string, number>,
    totalResponse: number,
    scalerRaterType: string
  ) {
    let totalTop = 0;
    let totalMid = 0;
    let totalBottom = 0;
    let sumOfPrimaryRating = 0;
    const category = this.responseAnalyticsService.getRatingBandsByRaterType(scalerRaterType);
    Object.entries(ratingNumber || {}).forEach(([key, count]) => {
      const numberOfUsersRated = count || 0;
      const numKey = Number(key);
      if (category.bottom?.includes(numKey)) {
        totalBottom += numberOfUsersRated;
        sumOfPrimaryRating += numberOfUsersRated * numKey;
      } else if (category.mid?.includes(numKey)) {
        totalMid += numberOfUsersRated;
        sumOfPrimaryRating += numberOfUsersRated * numKey;
      } else if (category.top?.includes(numKey)) {
        totalTop += numberOfUsersRated;
        sumOfPrimaryRating += numberOfUsersRated * numKey;
      }
    });
    const response = totalResponse || totalTop + totalMid + totalBottom;
    let rating: string | number = 'N/A';
    if (response > 0) {
      if (scalerRaterType === '0-10' || scalerRaterType === '1-5') {
        let netScore = ((totalTop - totalBottom) / response) * 100;
        if (netScore % 1 === 0.5 || netScore % 1 === -0.5) {
          netScore = netScore < 0 ? Math.floor(netScore) : Math.ceil(netScore);
        } else {
          netScore = Math.round(netScore);
        }
        rating = netScore;
      } else {
        rating = (sumOfPrimaryRating / response).toFixed(2);
      }
    }
    const [topPercent, midPercent, bottomPercent] = this.calculatePercentages(response, totalTop, totalMid, totalBottom);
    return {
      response: this.responseAnalyticsService.formatNumber(response),
      rating,
      top: this.responseAnalyticsService.formatNumber(totalTop),
      mid: this.responseAnalyticsService.formatNumber(totalMid),
      bottom: this.responseAnalyticsService.formatNumber(totalBottom),
      topPercent,
      midPercent,
      bottomPercent,
      rawResponse: response,
      rawTop: totalTop,
      rawMid: totalMid,
      rawBottom: totalBottom,
      sumOfPrimaryRating,
    };
  }

  private calculateProjectRowMetricsFromComparisonEntry(entry: any) {
    const currentNode = this.getComparisonEntryCurrentNode(entry);
    const question = this.getSelectedTrendsSummaryQuestion();
    const fieldId = question?.field_id || 'primary_rating';
    const scalerRaterType = question?.scale_rater_type || this.getEffectiveScaleRaterTypeForProject();

    if (question?.type === 'rating') {
      const questionData = _.get(currentNode, `detailed_rating_by_type.${fieldId}`, null);
      let ratingNumber: Record<string, number> | null = questionData?.rating_number || null;
      let totalResponse = questionData?.doc_count ?? 0;

      if (fieldId === 'primary_rating' || question?.is_primary_rating) {
        if (currentNode?.primary_rating_distribution && !_.isEmpty(currentNode.primary_rating_distribution)) {
          ratingNumber = currentNode.primary_rating_distribution;
        }
        if (currentNode?.number_of_users_rated_primary_rating != null) {
          totalResponse = currentNode.number_of_users_rated_primary_rating;
        } else if (!totalResponse && ratingNumber) {
          totalResponse = Object.values(ratingNumber).reduce((sum: number, val: any) => sum + (Number(val) || 0), 0);
        }
      } else if (!ratingNumber || _.isEmpty(ratingNumber)) {
        const altDist = this.extractAlternateQuestionDistribution(currentNode, fieldId);
        if (altDist && !_.isEmpty(altDist)) {
          ratingNumber = altDist;
          if (!totalResponse) {
            totalResponse = Object.values(altDist).reduce((sum: number, val: any) => sum + (Number(val) || 0), 0);
          }
        }
      }

      if (!ratingNumber || _.isEmpty(ratingNumber)) {
        const isPrimaryEmpty = fieldId === 'primary_rating' || question?.is_primary_rating;
        if (isPrimaryEmpty) {
          const emptyMetrics = this.calculateDataForProject(null);
          if (currentNode?.number_of_users_rated_primary_rating != null) {
            emptyMetrics.response = this.responseAnalyticsService.formatNumber(
              currentNode.number_of_users_rated_primary_rating
            );
            emptyMetrics.rawResponse = currentNode.number_of_users_rated_primary_rating;
          }
          if (emptyMetrics.rawResponse > 0) {
            const resolvedRating = this.resolvePrimaryComparisonRating(entry, currentNode, scalerRaterType);
            if (resolvedRating != null) {
              emptyMetrics.rating = resolvedRating;
            }
          }
          return emptyMetrics;
        }
        return this.calculateDataForProject(null);
      }

      const metrics = this.calculateDataFromRatingNumber(ratingNumber, totalResponse, scalerRaterType);
      const isPrimary = fieldId === 'primary_rating' || question?.is_primary_rating;
      if (isPrimary && metrics.rawResponse > 0 && !this.isProjectNpsScale()) {
        const resolvedRating = this.resolvePrimaryComparisonRating(entry, currentNode, scalerRaterType);
        if (resolvedRating != null) {
          metrics.rating = resolvedRating;
        }
      } else if (isPrimary && metrics.rawResponse > 0 && this.isProjectNpsScale()) {
        const resolvedRating = this.resolvePrimaryComparisonRating(entry, currentNode, scalerRaterType);
        if (resolvedRating != null && metrics.rating === 'N/A') {
          metrics.rating = resolvedRating;
        }
      }
      return metrics;
    }

    const dist = this.getProjectRowRatingDistribution(currentNode);
    return this.calculateDataForProject(dist ?? {});
  }

  private extractAlternateQuestionDistribution(obj: any, fieldId: string): Record<string, number> | null {
    if (!obj || !fieldId || fieldId === 'primary_rating') return null;
    const tryFlat = (node: any) => this.flattenRatingDistributionMap(node);
    const questionData = obj?.detailed_rating_by_type?.[fieldId];
    const candidates = [
      questionData?.rating_number,
      obj[`${fieldId}_rating_distribution`],
      obj[`${fieldId}_distribution`],
      obj.detailed_rating?.[fieldId],
      obj.detailed_rating?.[fieldId]?.rating_number,
    ];
    for (const c of candidates) {
      const flat = tryFlat(c);
      if (flat && Object.keys(flat).length) return flat;
    }
    if (Array.isArray(obj.detailed_rating)) {
      const match = obj.detailed_rating.find((d: any) => d.field_id === fieldId);
      if (match) {
        const inner = match.detailed_rating || match.detailed_rating_details;
        if (Array.isArray(inner)) {
          const rec: Record<string, number> = {};
          inner.forEach((row: any) => {
            const rk = row.rating ?? row.primary_rating;
            if (rk !== undefined && row.number_of_users_rated != null) {
              rec[String(rk)] = row.number_of_users_rated;
            }
          });
          if (Object.keys(rec).length) return rec;
        }
      }
    }
    return null;
  }

  private flattenRatingDistributionMap(node: any): Record<string, number> | null {
    if (!node || typeof node !== 'object') return null;
    const out: Record<string, number> = {};
    if (Array.isArray(node.buckets)) {
      node.buckets.forEach((b: any) => {
        if (b && (b.key !== undefined && b.key !== null) && typeof b.doc_count === 'number') {
          out[String(b.key)] = b.doc_count;
        }
      });
    }
    for (const k of Object.keys(node)) {
      if (k === 'buckets') continue;
      const v = (node as any)[k];
      if (typeof v === 'number' && !Number.isNaN(Number(k))) {
        out[String(k)] = v;
      } else if (v && typeof v === 'object' && typeof v.doc_count === 'number') {
        out[String(k)] = v.doc_count;
      }
    }
    return Object.keys(out).length ? out : null;
  }

  private getProjectRowRatingDistribution(row: any): Record<string, number> | undefined {
    if (!row) return undefined;
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    if (!fieldId || fieldId === 'primary_rating') {
      return row.primary_rating_distribution;
    }
    const alt = this.extractAlternateQuestionDistribution(row, fieldId);
    return alt || row.primary_rating_distribution;
  }

  private getOverviewDistributionForTrendsQuestion(data: any): Record<string, number> | undefined {
    if (!data) return undefined;
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    if (!fieldId || fieldId === 'primary_rating') {
      return data.primary_rating_distribution;
    }
    return this.extractAlternateQuestionDistribution(data, fieldId) || data.primary_rating_distribution;
  }

  private isSelectedTrendsSummaryRatingQuestion(): boolean {
    const question = this.getSelectedTrendsSummaryQuestion();
    if (question?.type === 'rating') {
      return true;
    }
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    return this.trendsSummaryQuestionDropdown.options.some((o: any) => o.field_id === fieldId);
  }

  private applyTrendLineChartScaleFromSelectedQuestion(): void {
    if (this.isAccountLevel) {
      return;
    }
    this.setMinMaxValueForLineChart(this.getProjectPrimaryRatingScaleType());
  }

  private getTrendChartRatingDetails(item: any): any {
    if (!item) {
      return undefined;
    }
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    const detailed = item.detailed_rating;
    if (fieldId === 'primary_rating') {
      if (Array.isArray(detailed)) {
        const primaryDetails = detailed.find((d: any) => d.field_id == 'primary_rating')?.detailed_rating;
        if (primaryDetails) {
          return primaryDetails;
        }
      }
      return item.primary_rating_details;
    }
    const byType = item?.detailed_rating_by_type?.[fieldId];
    if (byType?.rating_number && !_.isEmpty(byType.rating_number)) {
      return byType.rating_number;
    }
    if (Array.isArray(detailed)) {
      const match = detailed.find((d: any) => d.field_id == fieldId);
      if (match) {
        return match.detailed_rating_details || match.detailed_rating || match.rating_number;
      }
    }
    return this.extractAlternateQuestionDistribution(item, fieldId) ?? undefined;
  }

  private hasTrendChartDataForSelectedQuestion(item: any): boolean {
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    if (fieldId === 'primary_rating') {
      return (item?.number_of_users_rated_primary_rating ?? 0) > 0;
    }
    return this.getTrendChartItemResponseCount(item) > 0;
  }

  private getTrendChartItemResponseCount(item: any): number {
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    if (!item || fieldId === 'primary_rating') {
      return item?.number_of_users_rated_primary_rating ?? 0;
    }
    const byType = item?.detailed_rating_by_type?.[fieldId];
    if (byType?.doc_count != null) {
      return Number(byType.doc_count) || 0;
    }
    const details = this.getTrendChartRatingDetails(item);
    if (!details) {
      return 0;
    }
    if (typeof details === 'object' && !Array.isArray(details)) {
      const flat = this.flattenRatingDistributionMap(details);
      if (flat) {
        return Object.values(flat).reduce((sum: number, val) => sum + (Number(val) || 0), 0);
      }
    }
    if (Array.isArray(details)) {
      return details.reduce(
        (sum: number, row: any) =>
          sum + (Number(row?.number_of_users_rated ?? row?.number_of_user_rated ?? row?.doc_count ?? 0) || 0),
        0
      );
    }
    return 0;
  }

  private getChartDownloadScaleHeaders(): { abs: any[]; per: any[] } {
    const selectedQuestion = this.getSelectedTrendsSummaryQuestion();
    const propItems = selectedQuestion?.prop || {};
    const scaleValues = Object.keys(propItems).map(Number);
    const abs = scaleValues.map((value) => {
      const { label } = propItems[value] || {};
      return { uniqueId: `#${value}`, header: `${label} (${value})` };
    });
    const per = scaleValues.map((value) => {
      const { label } = propItems[value] || {};
      return { uniqueId: `${value}%`, header: `${label} (${value})%` };
    });
    return { abs, per };
  }

  private getChartDownloadDistributionCounts(entry: any): Record<string, number> {
    const details = this.getTrendChartRatingDetails(entry);
    const flat = this.flattenRatingDistributionMap(details);
    if (flat) {
      return flat;
    }
    if (Array.isArray(details)) {
      const out: Record<string, number> = {};
      details.forEach((row: any) => {
        const ratingKey = row?.rating ?? row?.primary_rating ?? row?.key;
        const count = Number(row?.number_of_users_rated ?? row?.number_of_user_rated ?? row?.doc_count ?? 0);
        if (ratingKey != null && count) {
          out[String(ratingKey)] = count;
        }
      });
      return out;
    }
    return {};
  }

  private calculateChartDownloadMetrics(entry: any) {
    const details = this.getTrendChartRatingDetails(entry);
    const scalerRaterType = this.getProjectPrimaryRatingScaleType() || '';
    const distribution = this.getChartDownloadDistributionCounts(entry);
    const total = Object.values(distribution).reduce((sum, val) => sum + (Number(val) || 0), 0);
    if (total > 0) {
      return this.calculateDataFromRatingNumber(distribution, total, scalerRaterType);
    }
    return this.calculateDataForProjectChart(details, scalerRaterType);
  }

  private calculateTrendLineChartRating(details: any): string | number | null {
    if (details == null) {
      return null;
    }
    const scalerRaterType = this.getEffectiveScaleRaterTypeForProject();
    if (typeof details === 'object' && !Array.isArray(details)) {
      const values = Object.values(details);
      const isFlatCountMap =
        values.length > 0 &&
        values.every((v) => typeof v === 'number' || (typeof v === 'string' && v !== '' && !isNaN(Number(v))));
      if (isFlatCountMap && details.rating == null && details.key == null && details.doc_count == null) {
        const calc = this.calculateDataFromRatingNumber(details as Record<string, number>, 0, scalerRaterType);
        if (calc.rating === 'N/A' || !calc.rawResponse) {
          return null;
        }
        return calc.rating;
      }
    }
    const calc = this.calculateDataForProjectChart(details, scalerRaterType);
    if (calc.rating === 'N/A' || calc.rating == null || !calc.rawResponse) {
      return null;
    }
    return calc.rating;
  }

  calculateViewButtonWidth() {
    const minScreen = 1366;
    const maxScreen = 1920;
    const minWidth = 128;
    const maxWidth = 280;
    const screenWidth = window.innerWidth;
    if (screenWidth <= minScreen) {
      return `${minWidth}px`;
    } else if (screenWidth >= maxScreen) {
      return `${maxWidth}px`;
    } else {
      const width = minWidth + ((screenWidth - minScreen) * (maxWidth - minWidth)) / (maxScreen - minScreen);
      return `${Math.round(width)}px`;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.viewTypeDropdown.config.width = this.calculateViewButtonWidth();
  }

  execute() {
    if (this.isAccountLevel && this.helpersResponseCame && this.scalerRaterTypeCame) {
      this.refreshComparisonLabels();
      if (!_.isEqual(this.scalerRaterType, this.scalerRaterTypeCache)) {
        this.scalerRaterTypeCache = this.scalerRaterType;
        this.setMinMaxValueForLineChart(this.scalerRaterType);
        this.prepareDropdowns();
        this.cohortsFilter = [];
        this.subAccountFilter = [];
        this.updateChartEvent = {};
      }
      const datePicker: any = _.cloneDeep(_.get(this.helpersResponse, 'datePicker', null));
      if (!_.isEqual(_.cloneDeep(datePicker), _.cloneDeep(this.datePickerCache))) {
        this.datePickerCache = _.cloneDeep(datePicker);
        if (this.hierarchyTable.row.length > 0 && (this.cohortsFilter.length > 0 || _.size(this.updateChartEvent) > 0)) {
          this.saveHierarchyTableRow();
        }
      }
      const projectType: any = _.cloneDeep(_.get(this.helpersResponse, 'projectType.project_type', null));
      if (!_.isEqual(_.cloneDeep(projectType), _.cloneDeep(this.projectTypeCache))) {
        this.projectTypeCache = _.cloneDeep(projectType);
        this.cohortsFilter = [];
        this.subAccountFilter = [];
        this.updateChartEvent = {};
      }
      this.callApiForOverallTab();
      this.callApiForHierarchyTable();
      this.lineChartTrigger$.next();
      this.barChartTrigger$.next();
    } else if (this.isAccountLevel === false && this.helpersResponseCame) {
      this.refreshComparisonLabels();
      this.refreshTrendsSummaryQuestionDropdownIfNeeded();
      const hierarchyStack: any = _.get(this.helpersResponse, 'hierarchyStack', null);
      if (!_.isEqual(hierarchyStack, this.hierarchyStackCache)) {
        this.hierarchyStackCache = _.cloneDeep(hierarchyStack);
        this.cohortsFilter = [];
        this.updateChartEvent = {};
        this.prepareDropdowns();
      }
      const datePicker: any = _.cloneDeep(_.get(this.helpersResponse, 'datePicker', null));
      if (!_.isEqual(_.cloneDeep(datePicker), _.cloneDeep(this.datePickerCache))) {
        this.datePickerCache = _.cloneDeep(datePicker);
        if (this.hierarchyTable.row.length > 0 && (this.cohortsFilter.length > 0 || _.size(this.updateChartEvent) > 0)) {
          this.saveHierarchyTableRow();
        }
      }
      this.callApiForOverallTab();
      this.callApiForHierarchyTable();
      this.lineChartTrigger$.next();
      this.barChartTrigger$.next();
    }
  }

  setMinMaxValueForLineChart(raterType: any) {
    if (raterType && this.raterTypeDetails[raterType]) {
      this.lineChartPlugins.min = this.raterTypeDetails[raterType]['min']
      this.lineChartPlugins.max = this.raterTypeDetails[raterType]['max']
    } else {
      this.lineChartPlugins.min = null;
      this.lineChartPlugins.max = null;
    }
  }

  prepareDropdowns() {
    this.resetDropdowns();
    if (this.isAccountLevel) {
      this.populateDropdownsForAccountUser();
    } else if (this.isAccountLevel === false) {
      this.populateDropdownsForProjectUser();
    }
    // When dropdown don't have options then hide second drilldown table which are hirearchy table
    if (this.viewTypeDropdown.options.length == 0) {
      const hierarchyMapping = this.getHierarchyMapping();
      this.viewTypeDropdown.options.push(hierarchyMapping[hierarchyMapping.length - 1]);
      this.isHierarchyTableVisible = false;
    } else {
      this.isHierarchyTableVisible = true;
    }
    this.setDefaultDropdownSelection(this.viewTypeDropdown, 'viewType');
    this.setDefaultDropdownSelection(this.performerTypeDropdown, 'performerType');
  }

  resetDropdowns() {
    const reset = (dropdown) => {
      dropdown.config.isDisabled = true;
      dropdown.options = [];
      dropdown.selectedOption = '';
    };
    reset(this.viewTypeDropdown);
    reset(this.performerTypeDropdown);

    this.viewTypeDropdownSelectedName = '';
    this.viewTypeDropdownSelectedFieldId = '';
    this.viewTypeDropdownSelectedFieldType = '';
    this.viewTypeDropdownSelectedDataType = '';
    this.viewTypeDropdownProcessedChild = [];

    this.performerTypeDropdownSelectedName = '';
    this.performerTypeDropdownSelectedFieldId = '';
    this.performerTypeDropdownSelectedFieldType = '';
    this.performerTypeDropdownSelectedDataType = '';
    this.performerTypeDropdownProcessedChild = [];
  }

  populateDropdownsForAccountUser() {
    this.viewTypeDropdown.options.push({ name: 'Projects', field_id: 'project', field_type: 'project' });
    const fieldDefs = _.get(this.helpersResponse, 'accountDetails.field_definitions', []);
    if (fieldDefs.length > 0) {
      fieldDefs.forEach(field => {
        if (field?.compare_filter) {
          const option = this.createFieldOption(field, 'Cohorts');
          this.viewTypeDropdown.options.push(option);
          this.performerTypeDropdown.options.push(option);
        }
      });
    }
  }

  populateDropdownsForProjectUser() {
    this.buildHierarchyDropdownOptions().forEach((option) => {
      this.viewTypeDropdown.options.push(option);
    });
    this.getFieldDefinitionDropdown();
  }

  private buildHierarchyDropdownOptions(): any[] {
    const hierarchyList = _.get(this.helpersResponse, 'brandDetails.hierarchy_list', {});
    const hierarchyListAlias = _.get(this.helpersResponse, 'brandDetails.hierarchy_list_alias', {});
    if (!Object.keys(hierarchyList || {}).length || !Object.keys(hierarchyListAlias || {}).length) {
      return [];
    }
    const hierarchyMapping = this.getHierarchyMapping();
    if (!hierarchyMapping?.length) {
      return [];
    }
    const groupAliasKey = this.getGroupAliasKey();
    if (groupAliasKey) {
      const groupAliasKeyIndex = _.findIndex(hierarchyMapping, { field_id: groupAliasKey });
      return groupAliasKeyIndex !== -1
        ? hierarchyMapping.filter((_, index) => index >= groupAliasKeyIndex)
        : [];
    }
    return [...hierarchyMapping];
  }

  getTheHierarchyDropdown() {
    this.viewTypeDropdown.options = this.buildHierarchyDropdownOptions();
  }

  getGroupAliasKey() {
    let hierarchyStack = _.get(this.helpersResponse, 'hierarchyStack', []) || [];
    hierarchyStack = hierarchyStack.filter(stack => stack?.field_id != 'touchpoints');
    if (hierarchyStack?.length) {
      const currentLevel = hierarchyStack[hierarchyStack.length - 1]?.field_id;
      if (currentLevel) {
        const hierarchyListAlias = _.get(this.helpersResponse, 'brandDetails.hierarchy_list_alias', {});
        const alias = _.find(hierarchyListAlias, (item: any) => item?.values?.includes(currentLevel));
        if (alias) {
          const values = alias.values;
          const nextLevelIndex = values.indexOf(currentLevel) + 1;
          return values[nextLevelIndex] || null;
        }
      }
      return null;
    }
    // No drill-down stack: scope "View by" options to the user's access level (e.g. Branch Code)
    const hierarchyFilterMapping = _.get(Helpers, 'hierarchyFilterMapping', null);
    return hierarchyFilterMapping?.[1]?.key ?? null;
  }

  getHierarchyMapping() {
    const hierarchyList = _.get(this.helpersResponse, 'brandDetails.hierarchy_list', {});
    const hierarchyListKeys = Object.keys(hierarchyList);
    const hierarchyListKey = hierarchyListKeys[hierarchyListKeys.length - 1];
    const hierarchyListKeyValues = hierarchyList[hierarchyListKey];
    const hierarchyListAlias = _.get(this.helpersResponse, 'brandDetails.hierarchy_list_alias', {});
    const hierarchyListAliasKeys = Object.keys(hierarchyListAlias);
    const hierarchyListAliasKey = hierarchyListAliasKeys[hierarchyListAliasKeys.length - 1];
    const hierarchyListAliasValues = hierarchyListAlias[hierarchyListAliasKey]?.values;
    return hierarchyListKeyValues.map((name, index) => ({
      name: name,
      field_id: hierarchyListAliasValues[index],
      field_type: 'hierarchy',
      category: 'Hierarchy'
    }));
  }

  getFieldDefinitionDropdown() {
    const fieldDefs = _.get(this.helpersResponse, 'brandDetails.field_definitions', []);
    const feedbackItems = _.get(Helpers, 'brandDetails.detailed_feedback_items', []);
    if (fieldDefs.length > 0) {
      fieldDefs.forEach(field => {
        if (field?.compare_filter || field?.field_type === 'response') {
          const nameSource = _.find(feedbackItems, item => item.field_id === field.field_id);
          const option = this.createFieldOption(field, 'Cohorts', nameSource);
          this.viewTypeDropdown.options.push(option);
          this.performerTypeDropdown.options.push(option);
        }
      });
    }
  }

  createFieldOption(field, category = '', overrideItem: { question?: string; text?: string } | null = null) {
    let hasChildField = field?.child ? this.processedChild(field) : null;
    const name = overrideItem?.question || overrideItem?.text || field.name || field.text || field.question || field.label || field.field_id;
    return {
      name,
      field_id: field.field_id,
      field_type: field.field_type || 'tag',
      category,
      child: hasChildField,
      data_type: field.data_type || null,
      view_type: field.view_type || null
    };
  }

  processedChild(childObj) {
    let child: any = [];
    const fieldDefinitions = _.get(Helpers, this.isAccountLevel ? 'accountDetails.field_definitions' : 'brandDetails.field_definitions', []);
    const filteredFieldDefinition = fieldDefinitions.find(item => item.field_id === childObj.field_id) || {};
    let newChild = {
      field_id: childObj.field_id,
      field_type: this.isAccountLevel ? 'tag' : (childObj?.field_type ?? null),
      data_type: filteredFieldDefinition?.data_type ?? null,
      name: filteredFieldDefinition?.name
        ?? filteredFieldDefinition?.text
        ?? filteredFieldDefinition?.question
        ?? filteredFieldDefinition?.label
        ?? filteredFieldDefinition?.field_id,
      view_type: filteredFieldDefinition?.view_type ?? null
    }
    let detailedFeedbackItems = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', null);
    let detailedFeedbackItem = _.find(detailedFeedbackItems, { field_id: childObj.field_id }, null);
    if (!newChild?.field_type) {
      newChild.field_type = detailedFeedbackItem?.field_type || 'tag';
    }
    if (childObj?.field_type === 'response') {
      newChild.name = detailedFeedbackItem?.question || detailedFeedbackItem?.text || '';
      newChild['field_sub_type'] = detailedFeedbackItem?.type;
      if (detailedFeedbackItem?.type === 'rating' || detailedFeedbackItem?.type === 'text' || detailedFeedbackItem?.type === 'single-select') {
        newChild['possible_values'] = detailedFeedbackItem?.possible_values;
      } else if (detailedFeedbackItem?.type === 'multi-select') {
        newChild['possible_values'] = detailedFeedbackItems
          .filter(item => item?.group_id === childObj.field_id)
          .map(item => ({ field_id: item?.field_id, value: item?.value }));
      }
    }
    child.push(newChild);
    if (childObj.child) {
      child = child.concat(this.processedChild(childObj.child));
    }
    return child;
  }

  setDefaultDropdownSelection(dropdown, type) {
    if (dropdown.options.length > 0) {
      dropdown.config.isDisabled = false;
      dropdown.selectedOption = dropdown.options[0].labelShort ?? dropdown.options[0].name;
      if (type === 'viewType') {
        this.viewTypeDropdownSelectedName = dropdown.options[0].name;
        this.viewTypeDropdownSelectedFieldId = dropdown.options[0].field_id;
        this.viewTypeDropdownSelectedFieldType = dropdown.options[0].field_type;
        this.viewTypeDropdownSelectedDataType = dropdown.options[0].data_type;
        this.viewTypeDropdownProcessedChild = dropdown.options[0].child;
      } else if (type === 'performerType') {
        this.performerTypeDropdownSelectedName = dropdown.options[0].name;
        this.performerTypeDropdownSelectedFieldId = dropdown.options[0].field_id;
        this.performerTypeDropdownSelectedFieldType = dropdown.options[0].field_type;
        this.performerTypeDropdownSelectedDataType = dropdown.options[0].data_type;
        this.performerTypeDropdownProcessedChild = dropdown.options[0].child;
      }
    } else {
      dropdown.config.isDisabled = true;
    }
  }

  saveHierarchyTableRow() {
    this.hierarchyTableCache.row = [];
    const keys = this.cohortsFilter.map(item => item.key);
    const firstRow = this.findRowByKey(this.hierarchyTable.row, keys[0]);
    if (!firstRow) {
      if (_.size(this.updateChartEvent) > 0) {
        this.saveClickedTableRow();
      }
      return;
    }
    const nested = this.buildNestedHierarchy(firstRow);
    const resetTableRow = this.setRatingToNA(nested);
    this.hierarchyTableCache.row.push(resetTableRow);
    if (_.size(this.updateChartEvent) > 0) {
      this.saveClickedTableRow();
    }
  }

  findRowByKey(rows, key) {
    for (const row of rows) {
      if (row.key === key) return row;
      if (Array.isArray(row.drillDown)) {
        const found = this.findRowByKey(row.drillDown, key);
        if (found) return found;
      }
    }
    return null;
  }

  saveClickedTableRow() {
    const targetKey = this.updateChartEvent?.key;
    const data = this.hierarchyTable.row;
    const nested = this.findPath(data, targetKey);
    if (nested && nested.length > 0) {
      const resetTableRow = [this.setRatingToNA(nested[0])];
      let mergedRowData = _.cloneDeep(this.mergeMissingDrillDown(resetTableRow, this.hierarchyTableCache.row));
      this.hierarchyTable.row = mergedRowData;
    }
  }

  findPath(data, targetKey) {
    for (const item of data) {
      if (item.key === targetKey) {
        return [{ ...item }];
      }
      if (item.drillDown && Array.isArray(item.drillDown)) {
        const path = this.findPath(item.drillDown, targetKey);
        if (path) {
          return [{
            ...item,
            drillDown: path
          }];
        }
      }
    }
    return null;
  }

  setRatingToNA(obj: any): any {
    if ('mid' in obj) {
      obj.mid = "0 (0.0%)";
    }
    if ('rating' in obj) {
      obj.top = "0 (0.0%)";
      obj.bottom = "0 (0.0%)";
      obj.responses = 0;
      obj.rating = 'N/A';
      if (Array.isArray(obj.drillDown)) {
        obj.drillDown = obj.drillDown.map(child => this.setRatingToNA(child));
      }
    }
    return obj;
  }

  mergeMissingDrillDown(source, target) {
    const targetMap = new Map(target.map(item => [item.key, item]));
    source.forEach(sourceItem => {
      const targetItem: any = targetMap.get(sourceItem.key);
      if (!targetItem) {
        target.push(JSON.parse(JSON.stringify(sourceItem)));
      } else if (Array.isArray(sourceItem.drillDown)) {
        const targetHasData = Array.isArray(targetItem.drillDown) && targetItem.drillDown.length > 0;
        if (!targetHasData) {
          targetItem.drillDown = JSON.parse(JSON.stringify(sourceItem.drillDown));
        } else {
          this.mergeMissingDrillDown(sourceItem.drillDown, targetItem.drillDown);
        }
      }
    });
    return target;
  }

  buildNestedHierarchy(row) {
    const next = this.extractDrilldownRow(row);
    if (!next) {
      return row;
    }
    if (Array.isArray(next)) {
      return {
        ...row,
        drillDown: next.map(child => this.buildNestedHierarchy(child))
      };
    } else {
      return {
        ...row,
        drillDown: [this.buildNestedHierarchy(next)]
      };
    }
  }

  extractDrilldownRow(row) {
    if (Array.isArray(row?.drillDown) && row.drillDown.length > 0) {
      for (const child of row.drillDown) {
        if (Array.isArray(child?.drillDown) && child.drillDown.length > 0) {
          return child;
        }
      }
      return [...row.drillDown];
    }
    return null;
  }

  callApiForOverallTab() {
    this.lhsBoxLoader = true;
    this.resetOverallTable();
    let checkLastAppiledUniversalFilter = this.checkUniversalFilter();
    if (checkLastAppiledUniversalFilter === false) {
      this.perfomerChartLoader = true;
      this.drilldownChartCache = [];
      this.perfomerChartLoader = true;
      this.cohortsFilterChart = [];
    }
    if (this.isAccountLevel) {
      let payload = {
        "account_id": _.get(this.helpersResponse, 'accountDetails._id', null),
        "from": _.get(this.helpersResponse, 'datePicker.startDate', null),
        "to": _.get(this.helpersResponse, 'datePicker.endDate', null),
        "rater_type": this.scalerRaterType,
        "view_type": "summary",
        "is_custom_date_range_selected": _.get(this.helpersResponse, 'datePicker.isCustomDateRangeSelected', null),
        "project_type": _.get(this.helpersResponse, 'projectType.project_type', null),
        "date_filter_type": _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        "universal_filter": _.get(this.helpersResponse, 'universalFilter', null),
        "use_es": true
      };
      this.callGetAccountScoresSummaryApi(payload, 'overallTable');
    } else if (this.isAccountLevel === false) {
      let payload: any = this.buildProjectComparisonBasePayload({
        view_type: 'overall',
        field_id: 'overall',
        field_type: 'overall',
      });
      this.callGetComparisonV2DataApi(payload, 'overallTable');
    }
  }

  resetOverallTable() {
    this.overallTable.header = [];
    this.overallTable.row = [];
    this.overallTableDataCache = {};
  }

  callGetAccountScoresSummaryApi(payload, tableType) {
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response?.message == "Success") {
        if (tableType === 'overallTable') {
          this.prepareOverallTableData(response?.data?.overall_summary_details?.summary);
        } else if (tableType === 'hierarchyTable') {
          if (this.viewTypeDropdownSelectedFieldId === 'project') {
            this.prepareSubAccountTable(response?.data?.overall_summary_details);
          }
          this.prepareHierarchyTable(response?.data?.overall_summary_details);
        }
      } else {
        if (tableType === 'overallTable') {
          this.lhsBoxLoader = false;
          this.lhsBoxError = true;
        } else if (tableType === 'hierarchyTable') {
          this.hierarchyTableLoader = false;
          this.hierarchyTableError = true;
        }
      }
    })
  }

  callGetComparisonV2DataApi(payload, tableType) {
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getcomparisonV2Data(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response?.message == "Success") {
        if (tableType === 'overallTable') {
          this.overallPayload = payload;
          this.prepareOverallTableData(response?.data?.feed_details);
        } else if (tableType === 'hierarchyTable') {
          this.hierarchyPayload = payload;
          this.prepareHierarchyTable(response);
        }
      } else {
        if (tableType === 'overallTable') {
          this.lhsBoxLoader = false;
          this.lhsBoxError = true;
        } else if (tableType === 'hierarchyTable') {
          this.hierarchyTableLoader = false;
          this.hierarchyTableError = true;
        }
      }
    })
  }

  prepareOverallTableData(feedDetailsOrCurrent: any) {
    feedDetailsOrCurrent = this.normalizeComparisonEntry(feedDetailsOrCurrent);
    let data = feedDetailsOrCurrent;
    let previousData: any = null;
    if (feedDetailsOrCurrent && (feedDetailsOrCurrent.current !== undefined || feedDetailsOrCurrent.previous !== undefined)) {
      previousData = feedDetailsOrCurrent.previous;
      const wrappedCurrent = feedDetailsOrCurrent.current;
      if (wrappedCurrent && wrappedCurrent.primary_rating_distribution) {
        data = wrappedCurrent;
      } else if (feedDetailsOrCurrent.primary_rating_distribution) {
        data = feedDetailsOrCurrent;
      } else {
        data = wrappedCurrent;
      }
    }
    this.overallTableDataCache = data;
    if (this.isAccountLevel) {
      this.overallTable.header = [
        { uniqueId: 'name', header: 'Account', width: '180px', isClickable: true, isSorting: true },
        ...this.prepareTableHeader('')
      ];
      this.overallTable.header = this.disableTableSorting(this.overallTable.header);
      this.overallTable.row = [];
      const calculatedData: any = this.prepareDataForAccount(data);
      this.overallTable.row = [
        {
          name: _.get(Helpers, 'accountDetails.display_name', ''),
          responses: this.responseAnalyticsService.formatNumber(calculatedData?.response),
          rating: calculatedData?.rating,
          top: `${calculatedData?.topFormat} (${calculatedData?.topPercent})`,
          mid: `${calculatedData?.midFormat} (${calculatedData?.midPercent})`,
          bottom: `${calculatedData?.bottomFormat} (${calculatedData?.bottomPercent})`,
          key: 'overallTable',
          topAbs: calculatedData?.topFormat,
          midAbs: calculatedData?.midFormat,
          bottomAbs: calculatedData?.bottomFormat,
          topPer: calculatedData?.topPercent,
          midPer: calculatedData?.midPercent,
          bottomPer: calculatedData?.bottomPercent,
        }
      ];
      this.chartName = _.get(Helpers, 'accountDetails.display_name', '');
      this.attachAccountRowDeviations(this.overallTable.row[0], data, previousData, feedDetailsOrCurrent);
    } else if (this.isAccountLevel === false) {
      let headerName: string = '';
      let tableRowName: string = '';
      const hierarchyStack = _.get(Helpers, 'hierarchyStack', null);
      const hierarchyMapping = Helpers?.hierarchyMapping;
      const groupAliasKey = this.getGroupAliasKey();
      const keys = Object.keys(hierarchyMapping || {});
      const index = keys.indexOf(groupAliasKey);
      if (!hierarchyStack || hierarchyStack.length === 0) {
        headerName = 'Project';
        tableRowName = _.get(Helpers, 'brandDetails.name', '');
      } else {
        const currentLevelKey = (index === -1 || !groupAliasKey) ? keys[keys.length - 1] : keys[index - 1];
        headerName = _.get(hierarchyMapping, currentLevelKey, '');
        const lastHierarchy = hierarchyStack[hierarchyStack.length - 1];
        tableRowName = lastHierarchy?.group_key?.[0] || _.get(hierarchyMapping, currentLevelKey, '');
      }
      this.overallTable.header = [
        { uniqueId: 'name', header: headerName, width: '180px', isClickable: true, isSorting: true },
        ...this.prepareTableHeader('projectOverallTableHeader')
      ];
      this.overallTable.header = this.disableTableSorting(this.overallTable.header);
      this.overallTable.row = [];
      const comparisonEntry =
        feedDetailsOrCurrent?.current !== undefined || feedDetailsOrCurrent?.previous !== undefined
          ? feedDetailsOrCurrent
          : { current: data, previous: previousData };
      const calculatedData = this.calculateProjectRowMetricsFromComparisonEntry(comparisonEntry);
      this.overallTable.row = [{
        name: tableRowName,
        responses: calculatedData?.response,
        rating: calculatedData?.rating,
        top: `${calculatedData?.top} (${calculatedData?.topPercent})`,
        mid: `${calculatedData?.mid} (${calculatedData?.midPercent})`,
        bottom: `${calculatedData?.bottom} (${calculatedData?.bottomPercent})`,
        key: 'overallTable',
        topAbs: calculatedData?.top,
        midAbs: calculatedData?.mid,
        bottomAbs: calculatedData?.bottom,
        topPer: calculatedData?.topPercent,
        midPer: calculatedData?.midPercent,
        bottomPer: calculatedData?.bottomPercent,
      }];
      this.attachComparisonRowDeviations(this.overallTable.row[0], data, previousData, feedDetailsOrCurrent);
      this.chartName = tableRowName;
    }

    if (this.overallTable.row.length > 0) {
      this.lhsBoxLoader = false;
      this.lhsBoxError = false;
    } else {
      this.lhsBoxLoader = false;
      this.lhsBoxError = true;
    }
    this.callApiForPerformerChart();
    if (this.cohortsFilterChart.length > 0) {
      this.callApiForChartDrilldown();
    }
  }

  callApiForHierarchyTable() {
    this.hierarchyTableLoader = true;
    this.resetHierarchyTable();
    if (this.isAccountLevel) {
      let payload: any = {
        "account_id": _.get(this.helpersResponse, 'accountDetails._id', null),
        "from": _.get(this.helpersResponse, 'datePicker.startDate', null),
        "to": _.get(this.helpersResponse, 'datePicker.endDate', null),
        "rater_type": this.scalerRaterType,
        "view_type": "list",
        "field_id": this.viewTypeDropdownSelectedFieldId,
        "field_type": this.viewTypeDropdownSelectedFieldType,
        "project_type": _.get(this.helpersResponse, 'projectType.project_type', null),
        "is_custom_date_range_selected": _.get(this.helpersResponse, 'datePicker.isCustomDateRangeSelected', null),
        "date_filter_type": _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        "universal_filter": _.get(this.helpersResponse, 'universalFilter', null)
      }
      this.callGetAccountScoresSummaryApi(payload, 'hierarchyTable')
    } else if (this.isAccountLevel === false) {
      let payload: any = this.buildProjectComparisonBasePayload({
        view_type: 'list',
        field_id: this.viewTypeDropdownSelectedFieldId,
        field_type:
          this.viewTypeDropdownSelectedFieldType === 'response'
            ? 'response'
            : this.viewTypeDropdownSelectedFieldType === 'hierarchy'
              ? 'hierarchy'
              : 'tag',
        size: 100,
      });
      if (this.viewTypeDropdownSelectedDataType) {
        payload['field_data_type'] = this.viewTypeDropdownSelectedDataType;
      }
      if (this.viewTypeDropdownSelectedFieldType === 'response') {
        const detailedFeedbackItems = _.get(Helpers, 'brandDetails.detailed_feedback_items', []);
        const detailedFeedbackItem = detailedFeedbackItems.find(
          item => item.field_id === this.viewTypeDropdownSelectedFieldId
        );
        if (detailedFeedbackItem) {
          const { type, possible_values } = detailedFeedbackItem;
          if (type === 'text') {
            this.hierarchyTableLoader = false;
            this.hierarchyTableError = true;
          } else if (['rating', 'single-select'].includes(type)) {
            payload['field_sub_type'] = type;
            payload['possible_values'] = possible_values;
          } else if (type === 'multi-select') {
            payload['field_sub_type'] = type;
            payload['possible_values'] = detailedFeedbackItems
              .filter(item => item?.group_id === this.viewTypeDropdownSelectedFieldId)
              .map(item => ({ field_id: item?.field_id, value: item?.value }));
          }
        }
      }
      this.callGetComparisonV2DataApi(payload, 'hierarchyTable')
    }
  }

  resetHierarchyTable() {
    this.hierarchyTable.header = [];
    this.hierarchyTable.row = [];
    this.subAccountTable.header = [];
    this.subAccountTable.row = [];
  }

  prepareSubAccountTable(data: any) {
    this.subAccountTable.header = [
      { uniqueId: 'name', header: 'Sub Accounts', width: '180px', isClickable: true, isSorting: true, isDrilldown: true, isProject: true },
      ...this.prepareTableHeader(''),
    ];
    const subAccounts = _.get(data, 'sub_accounts', {});
    const overallSummary = _.get(data, 'overall_summary', {});
    const tableRow: any[] = [];
    if (!_.isEmpty(subAccounts)) {
      for (const subAccountId in subAccounts) {
        const subAccountInfo = subAccounts[subAccountId];
        const brandIds: string[] = subAccountInfo.brand_ids || [];
        let totalData = { top: 0, mid: 0, bottom: 0, response: 0, ratingSum: 0 };
        let totalPrevious = { top: 0, mid: 0, bottom: 0, response: 0, ratingSum: 0 };
        brandIds.forEach((brandId) => {
          const currentData = overallSummary[brandId]?.summary?.current;
          const previousData = overallSummary[brandId]?.summary?.previous;
          if (currentData) {
            const prepared = this.prepareDataForAccount(currentData);
            totalData.top += prepared.top;
            totalData.mid += prepared.mid;
            totalData.bottom += prepared.bottom;
            totalData.response += prepared.response;
            if (!this.isAccountNpsScale() && typeof currentData?.average_rating === 'number') {
              totalData.ratingSum += currentData.average_rating * prepared.response;
            }
          }
          if (previousData) {
            const preparedPrevious = this.prepareDataForAccount(previousData);
            totalPrevious.top += preparedPrevious.top;
            totalPrevious.mid += preparedPrevious.mid;
            totalPrevious.bottom += preparedPrevious.bottom;
            totalPrevious.response += preparedPrevious.response;
            if (!this.isAccountNpsScale() && typeof previousData?.average_rating === 'number') {
              totalPrevious.ratingSum += previousData.average_rating * preparedPrevious.response;
            }
          }
        });
        const aggregated = this.prepareDataForAccount({
          promoters: totalData.top,
          passives: totalData.mid,
          detractors: totalData.bottom,
          users_rater_primary_rating: totalData.response,
          average_rating: !this.isAccountNpsScale() && totalData.response > 0 ? totalData.ratingSum / totalData.response : undefined,
        });
        const currentSummary = {
          promoters: totalData.top,
          passives: totalData.mid,
          detractors: totalData.bottom,
          users_rater_primary_rating: totalData.response,
          average_rating: !this.isAccountNpsScale() && totalData.response > 0 ? totalData.ratingSum / totalData.response : undefined,
        };
        const previousSummary = {
          promoters: totalPrevious.top,
          passives: totalPrevious.mid,
          detractors: totalPrevious.bottom,
          users_rater_primary_rating: totalPrevious.response,
          average_rating: !this.isAccountNpsScale() && totalPrevious.response > 0 ? totalPrevious.ratingSum / totalPrevious.response : undefined,
        };
        const rowData: any = {
          name: subAccountInfo?.name || '',
          sub_account_id: subAccountId,
          key: `sub-account-id-${subAccountId}`,
          drillDown: [],
          rating: aggregated.rating,
          responses: this.responseAnalyticsService.formatNumber(aggregated.response),
          top: `${aggregated.topFormat} (${aggregated.topPercent})`,
          mid: `${aggregated.midFormat} (${aggregated.midPercent})`,
          bottom: `${aggregated.bottomFormat} (${aggregated.bottomPercent})`,
          topAbs: aggregated?.topFormat,
          midAbs: aggregated?.midFormat,
          bottomAbs: aggregated?.bottomFormat,
          topPer: aggregated?.topPercent,
          midPer: aggregated?.midPercent,
          bottomPer: aggregated?.bottomPercent,
        };
        this.attachAccountRowDeviations(rowData, currentSummary, previousSummary);
        tableRow.push(rowData);
      }
    }
    if (tableRow.length === 1) {
      this.subAccountTable.header = this.disableTableSorting(this.subAccountTable.header);
    }
    this.subAccountTable.row = tableRow;
    if (this.subAccountFilter.length > 0) {
      this.callApiForSubAccount();
    }
  }

  callApiForSubAccount() {
    const subAccountId = this.subAccountFilter[0]?.subAccountId;
    if (!subAccountId) return;
    const payload = {
      account_id: _.get(this.helpersResponse, 'accountDetails._id', null),
      date_filter_type: _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
      from: _.get(this.helpersResponse, 'datePicker.startDate', null),
      to: _.get(this.helpersResponse, 'datePicker.endDate', null),
      is_custom_date_range_selected: _.get(this.helpersResponse, 'datePicker.isCustomDateRangeSelected', null),
      project_type: _.get(this.helpersResponse, 'projectType.project_type', null),
      rater_type: this.scalerRaterType,
      sub_account_id: subAccountId,
      field_id: 'project',
      field_type: 'project',
      view_type: 'list',
      universal_filter: _.get(this.helpersResponse, 'universalFilter', null)
    };
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response?.message !== 'Success') return;
      const summaryDetails = response?.data?.overall_summary_details || {};
      const brands = summaryDetails.brands || {};
      const overallSummary = summaryDetails.overall_summary || {};
      const tableHeader = [
        { uniqueId: 'name', header: 'Sub-account Projects', width: '180px', isClickable: true, isSorting: true, isProject: true },
        ...this.prepareTableHeader('')
      ];
      const rowData = Object.keys(brands).map(brandId => {
        const brand = brands[brandId] || {};
        const currentData = overallSummary[brandId]?.summary?.current || {};
        const previousData = overallSummary[brandId]?.summary?.previous || {};
        const metrics = this.prepareDataForAccount(currentData);
        const row = {
          name: brand.name || '',
          projectId: brandId,
          rating: metrics.rating,
          responses: this.responseAnalyticsService.formatNumber(metrics.response),
          top: `${metrics.topFormat} (${metrics.topPercent})`,
          mid: `${metrics.midFormat} (${metrics.midPercent})`,
          bottom: `${metrics.bottomFormat} (${metrics.bottomPercent})`,
          topAbs: metrics?.topFormat,
          midAbs: metrics?.midFormat,
          bottomAbs: metrics?.bottomFormat,
          topPer: metrics?.topPercent,
          midPer: metrics?.midPercent,
          bottomPer: metrics?.bottomPercent,
          field_id: payload.field_id,
          field_type: payload.field_type,
          key: `project-id-${brandId}`,
        };
        this.attachAccountRowDeviations(row, currentData, previousData);
        return row;
      });
      const matchingRow = this.subAccountTable.row.find(item => item.key === this.subAccountFilter[0]?.key);
      if (matchingRow) {
        matchingRow.isExpanded = true;
        matchingRow.columns = tableHeader;
        matchingRow.drillDown = rowData;
      }
    });
  }

  prepareHierarchyTable(data) {
    this.setTableHeaders();
    if (this.isAccountLevel) {
      if (this.viewTypeDropdownSelectedFieldId === 'project') {
        this.buildProjectRows(data);
      } else {
        this.buildGenericRows(data);
      }
    } else if (this.isAccountLevel === false) {
      const ratingSummary = data.data.RatingsSummary || {};
      const hasData = Object.keys(ratingSummary).length > 0;
      if (hasData) {
        if (this.viewTypeDropdownSelectedFieldType === 'response') {
          const feedbackItems = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', []);
          const selectedItem = feedbackItems.find(item => item.field_id === this.viewTypeDropdownSelectedFieldId);
          if (selectedItem && selectedItem.type && selectedItem.type === 'multi-select') {
            const groupItems = feedbackItems.filter(item => item.group_id === this.viewTypeDropdownSelectedFieldId);
            const multiSelectObj = { field_sub_type: 'multi-select', possible_values: groupItems.map(item => ({ field_id: item.field_id, value: item.value })) };
            this.projectUserHierarchyData(ratingSummary, multiSelectObj);
          } else if (selectedItem && selectedItem.type && (selectedItem.type === 'rating' || selectedItem.type === 'single-select')) {
            const ratingObj = { field_sub_type: selectedItem.type, possible_values: selectedItem.possible_values };
            this.projectUserHierarchyData(ratingSummary, ratingObj)
          } else {
            this.hierarchyTableLoader = false;
            this.hierarchyTableError = true;
          }
        } else {
          this.projectUserHierarchyData(ratingSummary, {});
        }
      } else {
        this.handleFallbackFromCache();
      }
    }
  }

  handleFallbackFromCache() {
    if (this.hierarchyTableCache.row.length > 0) {
      this.hierarchyTableLoader = false;
      this.hierarchyTableError = false;
      this.hierarchyTable.header = this.hierarchyTableCache.header;
      this.hierarchyTable.row = this.hierarchyTableCache.row;
    } else {
      this.hierarchyTableLoader = false;
      this.hierarchyTableError = true;
    }
  }

  projectUserHierarchyData(data, obj) {
    const index = _.findIndex(this.viewTypeDropdownProcessedChild, { field_id: this.viewTypeDropdownSelectedFieldId });
    let props: any = {};
    const detailedFeedbackItems: any = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', null);
    let detailedFeedbackItem: any = {};
    if (detailedFeedbackItems && detailedFeedbackItems.length > 0) {
      detailedFeedbackItem = detailedFeedbackItems.filter(item => item.field_id === this.viewTypeDropdownSelectedFieldId)[0];
      if (detailedFeedbackItem && (detailedFeedbackItem?.type === 'rating' || detailedFeedbackItem?.type === 'single-select')) {
        props = detailedFeedbackItem?.prop;
      } else if (detailedFeedbackItem && detailedFeedbackItem?.type === 'multi-select') {
        let brandGroupId: any = _.filter(detailedFeedbackItems, (item: any) => item?.group_id === this.viewTypeDropdownSelectedFieldId);
        _.forEach(brandGroupId, (item: any) => {
          props[item?.value] = item?.question || item?.text;
        });
      }
    }
    for (let key in data) {
      const ratingEntry = data[key];
      let calculatedData: any = this.calculateProjectRowMetricsFromComparisonEntry(ratingEntry);
      const detailedFeedbackItemKey = detailedFeedbackItems.filter(item => item?.field_id === key)[0];
      if (calculatedData?.rawResponse > 0) {
        let rowObj: any = {
          name: detailedFeedbackItemKey?.question || detailedFeedbackItemKey?.text || props[key]?.label || props[key] || key || '',
          field_id: this.viewTypeDropdownSelectedFieldId,
          field_type: this.viewTypeDropdownSelectedFieldType,
          filters: [],
          key: this.viewTypeDropdownSelectedFieldId + key + this.viewTypeDropdownSelectedFieldType,
          responses: calculatedData?.response,
          rating: calculatedData?.rating,
          top: `${calculatedData?.top} (${calculatedData?.topPercent})`,
          mid: `${calculatedData?.mid} (${calculatedData?.midPercent})`,
          bottom: `${calculatedData?.bottom} (${calculatedData?.bottomPercent})`,
          topAbs: calculatedData?.top,
          midAbs: calculatedData?.mid,
          bottomAbs: calculatedData?.bottom,
          topPer: calculatedData?.topPercent,
          midPer: calculatedData?.midPercent,
          bottomPer: calculatedData?.bottomPercent,
        };

        if (this.viewTypeDropdownSelectedFieldType === 'hierarchy') {
          const hierarchyList = _.keys(_.get(Helpers, 'hierarchyMapping', null));
          const currentIndex = _.indexOf(hierarchyList, this.viewTypeDropdownSelectedFieldId);
          if (currentIndex !== -1 && currentIndex < hierarchyList.length - 1) {
            rowObj.drillDown = [];
          }
        }

        if (this.viewTypeDropdownSelectedFieldType === 'tag') {
          rowObj.field_data_type = this.viewTypeDropdownSelectedDataType;
          if (detailedFeedbackItem && detailedFeedbackItem.type === 'multi-select') {
            const groupItems = detailedFeedbackItems.filter(item => item.group_id === this.viewTypeDropdownSelectedFieldId);
            const matchedGroupItem = groupItems.find(item => item.field_id === key || item.value == key);
            rowObj.field_sub_type = 'multi-select';
            rowObj.field_value = matchedGroupItem?.value ?? Number(key);
            rowObj.possible_values = groupItems.map(item => ({ field_id: item.field_id, value: item.value }));
          }
          if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
            rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
          }
          if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
            rowObj.drillDown = [];
          }
        }

        if (this.viewTypeDropdownSelectedFieldType === 'interaction') {
          rowObj.field_data_type = this.viewTypeDropdownSelectedDataType;
          rowObj.field_value = key;
          if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
            rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
          }
          if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
            rowObj.drillDown = [];
          }
        }

        if (this.viewTypeDropdownSelectedFieldType === 'response') {
          if (detailedFeedbackItem && (detailedFeedbackItem?.type === 'rating' || detailedFeedbackItem?.type === 'single-select')) {
            rowObj.field_sub_type = obj?.field_sub_type;
            rowObj.field_value = Number(key);
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
            }
            rowObj.possible_values = obj?.possible_values;
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.drillDown = [];
            }
          } else if (detailedFeedbackItem && detailedFeedbackItem?.type === 'multi-select') {

            rowObj.field_sub_type = obj?.field_sub_type;
            rowObj.field_value = Number(key);
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
            }
            rowObj.possible_values = obj?.possible_values;
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.drillDown = [];
            }
          }
        }

        this.attachComparisonEntryDeviations(rowObj, ratingEntry);

        /**
         * Ticket ID: 70684
         * 
         * Description:
         * The trends table data was getting duplicated.
         * 
         * Root Cause:
         * When the user navigates to the "Trends" tab from the "Inbox" or "Action" tabs, 
         * the datePicker component was triggering multiple helper function calls.
         * This caused duplicate entries to be inserted into the drilldown table.
         * 
         * Fix:
         * To prevent row duplication, we now check if a row with the same key already exists in the table.
         * If it does, we replace the existing row with the new `rowObj` instead of pushing a duplicate.
        */

        const rowsIndexes = this.hierarchyTable.row.findIndex(row => row.key === rowObj.key);
        if (rowsIndexes !== -1) {
          this.hierarchyTable.row[rowsIndexes] = rowObj;
        } else {
          this.hierarchyTable.row.push(rowObj);
        }
      }
    }
    if (this.hierarchyTable.row.length == 100) {
      this.downloadTableDataFromJob = true;
      this.hierarchyTable.header = this.disableTableSorting(this.hierarchyTable.header);
      Helpers.smallAlertBox("Warning", 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', "warn", 5000);
    } else {
      this.downloadTableDataFromJob = false;
    }
    if (this.hierarchyTable.row.length > 0) {
      this.hierarchyTableLoader = false;
      this.hierarchyTableError = false;
    } else if (_.size(this.updateChartEvent) > 0 && (this.viewTypeDropdownSelectedFieldType === 'rating' || this.viewTypeDropdownSelectedFieldType === 'single-select')) {
      this.hierarchyTableLoader = false;
      this.hierarchyTableError = false;
      this.hierarchyTable.header = this.hierarchyTableCache.header;
      this.hierarchyTable.row = this.hierarchyTableCache.row;
    } else {
      this.hierarchyTableLoader = false;
      this.hierarchyTableError = true;
    }
    if (this.cohortsFilter.length > 0) {
      this.callApiForFilterQuery();
    }
  }

  private setTableHeaders() {
    const headerBase = { uniqueId: 'name', header: this.viewTypeDropdownSelectedName, width: '180px', isClickable: true, isSorting: true, isProject: true, isDrilldown: true };
    const tableHeader = [headerBase, ...this.prepareTableHeader('')];
    this.hierarchyTable.header = tableHeader;
    this.hierarchyTableCache.header = tableHeader;
  }

  private setTableState(rows: any[]) {
    this.hierarchyTable.row = rows;
    this.hierarchyTableLoader = false;
    this.hierarchyTableError = rows.length === 0;
  }

  private buildProjectRows(data: any) {
    const subAccounts = _.get(data, 'sub_accounts', {});
    const coveredBrandIds = Object.values(subAccounts)
      .flatMap((account: any) => account.brand_ids || []);
    const brands = _.get(data, 'brands', {});
    const overallSummary = _.get(data, 'overall_summary', {});
    const tableRows: any[] = [];
    for (const brandId in brands) {
      if (!coveredBrandIds.includes(brandId)) {
        const currentData = overallSummary[brandId]?.summary?.current;
        const previousData = overallSummary[brandId]?.summary?.previous;
        const brandDetail = brands[brandId];
        const calculatedData = this.prepareDataForAccount(currentData);
        const rowData = {
          name: brandDetail?.name || '',
          projectId: brandId,
          rating: calculatedData?.rating,
          responses: this.responseAnalyticsService.formatNumber(calculatedData?.response),
          top: `${calculatedData?.topFormat} (${calculatedData?.topPercent})`,
          mid: `${calculatedData?.midFormat} (${calculatedData?.midPercent})`,
          bottom: `${calculatedData?.bottomFormat} (${calculatedData?.bottomPercent})`,
          key: `project-id-${brandId}`,
          topAbs: calculatedData?.topFormat,
          midAbs: calculatedData?.midFormat,
          bottomAbs: calculatedData?.bottomFormat,
          topPer: calculatedData?.topPercent,
          midPer: calculatedData?.midPercent,
          bottomPer: calculatedData?.bottomPercent,
        };
        this.attachAccountRowDeviations(rowData, currentData, previousData);
        tableRows.push(rowData);
      }
    }
    if (tableRows.length === 1) {
      this.hierarchyTable.header = this.disableTableSorting(this.hierarchyTable.header);
    }
    this.setTableState(tableRows);
  }

  private buildGenericRows(data: any) {
    const overallSummary = data?.overall_summary;
    const tableRows: any[] = [];
    if (!_.isEmpty(overallSummary)) {
      for (const key in overallSummary) {
        const currentData = overallSummary[key]?.summary?.current;
        const previousData = overallSummary[key]?.summary?.previous;
        if (currentData?.users_rater_primary_rating > 0) {
          const calculatedData = this.prepareDataForAccount(currentData);
          if (calculatedData?.response > 0) {
            const rowObj = {
              name: key,
              rating: calculatedData?.rating,
              responses: this.responseAnalyticsService.formatNumber(calculatedData?.response),
              top: `${calculatedData?.topFormat} (${calculatedData?.topPercent})`,
              mid: `${calculatedData?.midFormat} (${calculatedData?.midPercent})`,
              bottom: `${calculatedData?.bottomFormat} (${calculatedData?.bottomPercent})`,
              topAbs: calculatedData?.topFormat,
              midAbs: calculatedData?.midFormat,
              bottomAbs: calculatedData?.bottomFormat,
              topPer: calculatedData?.topPercent,
              midPer: calculatedData?.midPercent,
              bottomPer: calculatedData?.bottomPercent,
              field_id: this.viewTypeDropdownSelectedFieldId,
              field_type: this.viewTypeDropdownSelectedFieldType || 'tag',
              field_value: this.viewTypeDropdownSelectedName,
              cohorts_filter: [],
              filters: [],
              key: `accountCohort-${this.viewTypeDropdownSelectedFieldId}-${key}`,
              componentName: 'accountCohort',
              ...(this.viewTypeDropdownProcessedChild && { drillDown: [] })
            };
            this.attachAccountRowDeviations(rowObj, currentData, previousData);
            tableRows.push(rowObj);
          }
        }
      }
      this.setTableState(tableRows);
      if (this.cohortsFilter.length > 0) {
        this.callApiForFilterQuery();
      }
    } else if (this.hierarchyTableCache.row.length > 0) {
      this.hierarchyTable.row = this.hierarchyTableCache.row;
      this.hierarchyTable.header = this.hierarchyTableCache.header;
      this.hierarchyTableLoader = false;
      this.hierarchyTableError = false;
    } else {
      this.setTableState([]);
    }
  }

  callApiForDrilldownTable() {
    if (this.isAccountLevel) {
      const lastCohort = this.cohortsFilter[this.cohortsFilter.length - 1];
      const payload: any = {
        account_id: _.get(this.helpersResponse, 'accountDetails._id', null),
        from: _.get(this.helpersResponse, 'datePicker.startDate', null),
        to: _.get(this.helpersResponse, 'datePicker.endDate', null),
        rater_type: this.scalerRaterType,
        view_type: "list",
        field_id: lastCohort?.nextFieldId,
        field_type: "tag",
        project_type: _.get(this.helpersResponse, 'projectType.project_type', null),
        is_custom_date_range_selected: _.get(this.helpersResponse, 'datePicker.isCustomDateRangeSelected', null),
        date_filter_type: _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        universal_filter: _.get(this.helpersResponse, 'universalFilter', null),
        cohorts_filter: lastCohort?.cohorts_filter,
      };
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message !== 'Success') return;
        const listData = _.get(response, 'data.overall_summary_details.overall_summary', {});
        const tableHeader = [
          { uniqueId: 'name', header: lastCohort?.nextValueName, width: '180px', isClickable: true, isSorting: true, isProject: true, isDrilldown: true },
          ...this.prepareTableHeader('')
        ];
        const tableRow = Object.entries(listData).map(([key, val]: any) => {
          const currentData = val?.summary?.current;
          const previousData = val?.summary?.previous;
          const calculatedData = this.prepareDataForAccount(currentData);
          const row: any = {
            name: key,
            key: `tagDrilldownTable-${payload.field_id}-${key}`,
            componentName: 'tagDrilldownTable',
            cohorts_filter: payload.cohorts_filter,
            field_id: payload.field_id,
            field_type: payload.field_type,
            field_value: lastCohort?.nextValueName,
            rating: calculatedData?.rating,
            responses: this.responseAnalyticsService.formatNumber(calculatedData?.response),
            top: `${calculatedData?.topFormat} (${calculatedData?.topPercent})`,
            mid: `${calculatedData?.midFormat} (${calculatedData?.midPercent})`,
            bottom: `${calculatedData?.bottomFormat} (${calculatedData?.bottomPercent})`,
            topAbs: calculatedData?.topFormat,
            midAbs: calculatedData?.midFormat,
            bottomAbs: calculatedData?.bottomFormat,
            topPer: calculatedData?.topPercent,
            midPer: calculatedData?.midPercent,
            bottomPer: calculatedData?.bottomPercent,
          };
          if (lastCohort?.isNextDrilldownAvailable) {
            row.drillDown = [];
          }
          this.attachAccountRowDeviations(row, currentData, previousData);
          return row;
        }).filter(row => row.responses !== '0');
        this.updateHierarchyTableWithDrilldown(lastCohort.key, tableHeader, tableRow);
      });
    } else if (this.isAccountLevel === false) {
      let payload: any = this.buildProjectComparisonBasePayload({
        view_type: 'list',
        field_id: this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldId,
        field_type:
          this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldType === 'response'
            ? 'response'
            : this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldType === 'hierarchy'
              ? 'hierarchy'
              : 'tag',
        size: 100,
        filters: this.cohortsFilter[this.cohortsFilter.length - 1]?.cohorts_filter,
      });
      if (payload?.field_type === 'response') {
        payload['field_sub_type'] = this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldSubType;
        payload['possible_values'] = this.cohortsFilter[this.cohortsFilter.length - 1]?.nextPossibleValue;
      }
      const index = _.findIndex(this.viewTypeDropdownProcessedChild, { field_id: payload['field_id'] });
      let props: any = {};
      const detailedFeedbackItems: any = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', null);
      let detailedFeedbackItem: any = {};
      if (detailedFeedbackItems && detailedFeedbackItems.length > 0) {
        detailedFeedbackItem = detailedFeedbackItems.filter(item => item.field_id === payload['field_id'])[0];
        if (detailedFeedbackItem && (detailedFeedbackItem?.type === 'rating' || detailedFeedbackItem?.type === 'single-select')) {
          props = detailedFeedbackItem?.prop;
        } else if (detailedFeedbackItem && detailedFeedbackItem?.type === 'multi-select') {
          let brandGroupId: any = _.filter(detailedFeedbackItems, (item: any) => item?.group_id === payload['field_id']);
          _.forEach(brandGroupId, (item: any) => {
            props[item?.value] = item?.question || item?.text;
          });
        }
      }
      this.hierarchyPayload = payload;
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getcomparisonV2Data(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response && response.message === "Success") {
          if (response.data.RatingsSummary) {
            let tableHeader: any = [
              { uniqueId: 'name', header: this.cohortsFilter[this.cohortsFilter.length - 1]?.nextValueName || '', width: '180px', isClickable: true, isSorting: true, isProject: true, isDrilldown: true },
              ...this.prepareTableHeader('')
            ];
            // Check L1 & L2 driver mapping
            let l1andl2DriverMapping = this.checkDriverMapping(payload, detailedFeedbackItems);
            let rowData: any = [];
            for (let key in response.data.RatingsSummary) {
              if (l1andl2DriverMapping.length > 0 && l1andl2DriverMapping.indexOf(key) == -1) {
                continue;
              }
              const detailedFeedbackItemKey = detailedFeedbackItems.filter(item => item?.field_id === key)[0];
              const ratingEntry = response.data.RatingsSummary[key];
              let calculatedData: any = this.calculateProjectRowMetricsFromComparisonEntry(ratingEntry);
              if (calculatedData?.rawResponse > 0) {
                let rowObj: any = {};
                rowObj.name = detailedFeedbackItemKey?.question || detailedFeedbackItemKey?.text || props[key]?.label || props[key] || key || '',
                  rowObj.field_id = payload['field_id'];
                rowObj.field_type = this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldType;
                rowObj.filters = payload['filters'];
                rowObj.key = payload['field_id'] + key + this.viewTypeDropdownSelectedFieldType;
                rowObj.responses = calculatedData?.response;
                rowObj.rating = calculatedData?.rating;
                rowObj.top = `${calculatedData?.top} (${calculatedData?.topPercent})`;
                rowObj.mid = `${calculatedData?.mid} (${calculatedData?.midPercent})`;
                rowObj.bottom = `${calculatedData?.bottom} (${calculatedData?.bottomPercent})`;
                rowObj.topAbs = calculatedData?.top;
                rowObj.midAbs = calculatedData?.mid;
                rowObj.bottomAbs = calculatedData?.bottom;
                rowObj.topPer = calculatedData?.topPercent;
                rowObj.midPer = calculatedData?.midPercent;
                rowObj.bottomPer = calculatedData?.bottomPercent;
                if (this.cohortsFilter[this.cohortsFilter.length - 1]?.isNextDrilldownAvailable) {
                  rowObj.drillDown = [];
                }

                if (this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldType === 'tag') {
                  rowObj.field_data_type = payload['field_data_type'];
                  if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
                    rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
                  }
                }

                if (this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldType === 'interaction') {
                  rowObj.field_data_type = payload['field_data_type'];
                  rowObj.field_value = key;
                  if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
                    rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
                  }
                }

                if (this.cohortsFilter[this.cohortsFilter.length - 1]?.nextFieldType === 'response') {
                  rowObj.field_sub_type = payload['field_sub_type'];
                  rowObj.field_value = Number(key);
                  rowObj.possible_values = payload['possible_values'];
                  if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
                    rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
                  }
                }
                this.attachComparisonEntryDeviations(rowObj, ratingEntry);
                rowData.push(rowObj);
              }
            }
            let keys = this.cohortsFilter.map(k => k.key);
            let currentData = this.hierarchyTable.row;
            for (let i = 0; i < keys.length; i++) {
              let found = false;
              for (let j = 0; j < currentData.length; j++) {
                if (currentData[j].key == keys[i]) {
                  if (i == keys.length - 1) {
                    currentData[j].isExpanded = true;
                    currentData[j].isLoading = false;
                    currentData[j].columns = tableHeader;
                    currentData[j].drillDown = [...rowData];
                  } else if (currentData[j].drillDown) {
                    currentData = currentData[j].drillDown;
                  }
                  found = true;
                  break;
                }
              }
              if (!found) {
                break;
              }
            }
          }
        }
      })
    }
  }

  updateHierarchyTableWithDrilldown(key: string, columns: any[], drillDownData: any[]) {
    let current = this.hierarchyTable.row;
    const keys = this.cohortsFilter.map(k => k.key);
    for (let i = 0; i < keys.length; i++) {
      const row = current.find(r => r.key === keys[i]);
      if (!row) break;
      if (i === keys.length - 1) {
        row.isExpanded = true;
        row.isLoading = false;
        row.columns = columns;
        row.drillDown = drillDownData;
      } else {
        current = row.drillDown || [];
      }
    }
  }

  async callApiForFilterQuery(): Promise<void> {
    this.hierarchyTableLoader = true;
    this.hierarchyTableError = false;
    if (!this.cohortsFilter.length) {
      this.hierarchyTableLoader = false;
      return;
    }

    for (const filter of this.cohortsFilter) {
      const payload = this.buildPayload(filter);
      try {
        this.applyComparisonApiDateRange(payload);
        const response = this.isAccountLevel ?
          await this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).toPromise() :
          await this.responseAnalyticsService.getcomparisonV2Data(payload).pipe(takeUntil(this.destroy$)).toPromise();
        const listData = this.isAccountLevel ?
          response?.data?.overall_summary_details?.overall_summary :
          response?.data?.RatingsSummary;
        const tableHeader = this.buildTableHeader(filter);
        const tableRow = this.buildTableRows(listData, filter, payload);
        this.updateHierarchyTable(filter, tableHeader, tableRow);
      } catch (error) {
        this.hierarchyTableError = true;
        console.error("Error fetching account scores summary:", error);
      }
    }
    this.hierarchyTableLoader = false;
  }

  private buildPayload(filter: any): any {
    if (this.isAccountLevel) {
      return {
        account_id: _.get(this.helpersResponse, 'accountDetails._id', null),
        from: _.get(this.helpersResponse, 'datePicker.startDate', null),
        to: _.get(this.helpersResponse, 'datePicker.endDate', null),
        rater_type: this.scalerRaterType,
        view_type: "list",
        field_id: filter?.nextFieldId,
        field_type: "tag",
        project_type: _.get(this.helpersResponse, 'projectType.project_type', null),
        is_custom_date_range_selected: _.get(this.helpersResponse, 'datePicker.isCustomDateRangeSelected', null),
        date_filter_type: _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        universal_filter: _.get(this.helpersResponse, 'universalFilter', null),
        cohorts_filter: filter.cohorts_filter
      };
    } else if (this.isAccountLevel === false) {
      let payloadObj: any = this.buildProjectComparisonBasePayload({
        view_type: 'list',
        field_id: filter?.nextFieldId,
        field_type:
          filter?.nextFieldType === 'response'
            ? 'response'
            : filter?.nextFieldType === 'hierarchy'
              ? 'hierarchy'
              : 'tag',
        size: 100,
        filters: filter?.cohorts_filter,
      });
      if (payloadObj?.field_type === 'response') {
        payloadObj['field_sub_type'] = filter?.nextFieldSubType;
        payloadObj['possible_values'] = filter?.nextPossibleValue;
      }
      return payloadObj;
    }
  }

  private buildTableHeader(filter: any): any[] {
    return [
      { uniqueId: 'name', header: filter.nextValueName, width: '180px', isClickable: true, isSorting: true, isProject: true, isDrilldown: true },
      ...this.prepareTableHeader('')
    ];
  }

  private buildTableRows(listData: any, filter: any, payload: any): any[] {
    const tableRows: any[] = [];
    if (this.isAccountLevel) {
      for (const key in listData) {
        const currentData = listData[key]?.summary?.current;
        const previousData = listData[key]?.summary?.previous;
        const calculatedData = this.prepareDataForAccount(currentData);
        if (calculatedData?.response > 0) {
          const rowObj: any = {
            name: key,
            key: `tagDrilldownTable-${payload.field_id}-${key}`,
            componentName: 'tagDrilldownTable',
            cohorts_filter: filter?.cohorts_filter,
            field_id: payload.field_id,
            field_type: payload.field_type,
            rating: calculatedData?.rating,
            responses: calculatedData?.response,
            top: `${calculatedData?.topFormat} (${calculatedData?.topPercent})`,
            mid: `${calculatedData?.midFormat} (${calculatedData?.midPercent})`,
            bottom: `${calculatedData?.bottomFormat} (${calculatedData?.bottomPercent})`,
            topAbs: calculatedData?.topFormat,
            midAbs: calculatedData?.midFormat,
            bottomAbs: calculatedData?.bottomFormat,
            topPer: calculatedData?.topPercent,
            midPer: calculatedData?.midPercent,
            bottomPer: calculatedData?.bottomPercent,
            drillDown: filter.isNextDrilldownAvailable ? [] : undefined
          };
          this.attachAccountRowDeviations(rowObj, currentData, previousData);
          tableRows.push(rowObj);
        }
      }
    } else if (this.isAccountLevel === false) {
      const index = _.findIndex(this.viewTypeDropdownProcessedChild, { field_id: payload['field_id'] });
      let props: any = {};
      const detailedFeedbackItems: any = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', null);
      let detailedFeedbackItem: any = {};
      if (detailedFeedbackItems && detailedFeedbackItems.length > 0) {
        detailedFeedbackItem = detailedFeedbackItems.filter(item => item.field_id === payload['field_id'])[0];
        if (detailedFeedbackItem && (detailedFeedbackItem?.type === 'rating' || detailedFeedbackItem?.type === 'single-select')) {
          props = detailedFeedbackItem?.prop;
        } else if (detailedFeedbackItem && detailedFeedbackItem?.type === 'multi-select') {
          let brandGroupId: any = _.filter(detailedFeedbackItems, (item: any) => item?.group_id === payload['field_id']);
          _.forEach(brandGroupId, (item: any) => {
            props[item?.value] = item?.question || item?.text;
          });
        }
      }
      // L1 and L2 mapping
      let l1andl2DriverMapping = this.checkDriverMapping(payload, detailedFeedbackItems);
      for (const key in listData) {
        if (l1andl2DriverMapping.length > 0 && l1andl2DriverMapping.indexOf(key) == -1) {
          continue;
        }
        const detailedFeedbackItemKey = detailedFeedbackItems.filter(item => item?.field_id === key)[0];
        const ratingEntry = listData[key];
        const calculatedData: any = this.calculateProjectRowMetricsFromComparisonEntry(ratingEntry);
        if (calculatedData?.rawResponse > 0) {
          const rowObj: any = {
            name: detailedFeedbackItemKey?.question || detailedFeedbackItemKey?.text || props[key]?.label || props[key] || key || '',
            key: payload.field_id + key + this.viewTypeDropdownSelectedFieldType,
            componentName: 'tagDrilldownTable',
            filters: payload.filters,
            field_id: payload.field_id,
            field_type: payload.field_type,
            rating: calculatedData?.rating,
            responses: calculatedData?.response,
            top: `${calculatedData?.top} (${calculatedData?.topPercent})`,
            mid: `${calculatedData?.mid} (${calculatedData?.midPercent})`,
            bottom: `${calculatedData?.bottom} (${calculatedData?.bottomPercent})`,
            topAbs: calculatedData?.top,
            midAbs: calculatedData?.mid,
            bottomAbs: calculatedData?.bottom,
            topPer: calculatedData?.topPercent,
            midPer: calculatedData?.midPercent,
            bottomPer: calculatedData?.bottomPercent,
            drillDown: filter.isNextDrilldownAvailable ? [] : undefined
          };

          if (l1andl2DriverMapping.indexOf(key) > -1) {
            rowObj.field_data_type = payload['field_data_type'];
            rowObj.field_value = key;
            rowObj.field_type = 'interaction';
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
            }
          }

          if (payload['field_type'] === 'tag') {
            rowObj.field_data_type = payload['field_data_type'];
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
            }
          }

          if (payload['field_type'] === 'interaction') {
            rowObj.field_data_type = payload['field_data_type'];
            rowObj.field_value = key;
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
            }
          }

          if (payload['field_type'] === 'response') {
            rowObj.field_sub_type = payload['field_sub_type'];
            rowObj.field_value = Number(key);
            rowObj.possible_values = payload['possible_values'];
            if (this.viewTypeDropdownProcessedChild && this.viewTypeDropdownProcessedChild.length > 0) {
              rowObj.upComingFieldType = this.viewTypeDropdownProcessedChild[index + 1]?.field_type;
            }
          }
          this.attachComparisonEntryDeviations(rowObj, ratingEntry);
          tableRows.push(rowObj);
        }
      }
    }

    return tableRows;
  }

  private updateHierarchyTable(filter: any, tableHeader: any[], tableRow: any[]): void {
    const keys = this.cohortsFilter.map(k => k.key).slice(0, this.cohortsFilter.findIndex(k => k.key === filter.key) + 1);
    let currentData = this.hierarchyTable.row;
    for (let i = 0; i < keys.length; i++) {
      let found = false;
      for (let j = 0; j < currentData.length; j++) {
        if (currentData[j].key === keys[i]) {
          if (i === keys.length - 1) {
            currentData[j].isExpanded = true;
            currentData[j].isLoading = false;
            currentData[j].columns = tableHeader;
            currentData[j].drillDown = [...tableRow];
          } else if (currentData[j].drillDown) {
            currentData = currentData[j].drillDown;
          }
          found = true;
          break;
        }
      }
      if (!found) break;
    }
    let mergedRowData = _.cloneDeep(this.mergeMissingDrillDown(this.hierarchyTableCache.row, this.hierarchyTable.row));
    this.hierarchyTable.row = mergedRowData;
    if (this.hierarchyTable.row.length === 0) {
      this.hierarchyTable = _.cloneDeep(this.hierarchyTableCache);
    }
    this.hierarchyTableError = false;
  }

  callApiForLineChart() {
    this.lineChartLoader = true;
    if (this.isAccountLevel) {
      this.lineChartDisplayName = this.creatingLabels().display;
      this.chartName = _.get(this.helpersResponse, 'accountDetails.name', null);
      let payload: any = {
        "account_id": _.get(this.helpersResponse, 'accountDetails._id', null),
        "from": _.get(this.helpersResponse, 'datePicker.startDate', null),
        "to": _.get(this.helpersResponse, 'datePicker.endDate', null),
        "rater_type": this.scalerRaterType,
        "view_type": "trend",
        "field_id": "project",
        "field_type": "project",
        "trend_type": this.lineChartTrendType,
        "date_filter_type": _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        "universal_filter": _.get(this.helpersResponse, 'universalFilter', null),
        "project_type": _.get(this.helpersResponse, 'projectType.project_type', null),
        "cohorts_filter": []
      };
      if (_.size(this.updateChartEvent) > 0) {
        if (this.updateChartEvent?.projectId) {
          this.chartName = this.updateChartEvent?.name;
          payload['brand_id'] = this.updateChartEvent?.projectId;
        } else if (this.updateChartEvent?.subAccountId) {
          this.chartName = this.updateChartEvent?.name;
          payload['sub_account_id'] = this.updateChartEvent?.subAccountId;
        } else if (this.updateChartEvent?.cohorts_filter && this.updateChartEvent?.cohorts_filter.length > 0 && this.updateChartEvent?.cohorts_filter[0]?.field_id) {
          this.chartName = this.updateChartEvent?.currentValueName;
          payload['cohorts_filter'].push(...this.updateChartEvent?.cohorts_filter);
        }
      }
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message === 'Success') {
          let overallSummaryDetails = response.data?.overall_summary_details;
          if (_.size(overallSummaryDetails) > 0) {
            this.lineChartDataCache = overallSummaryDetails?.trends;
            this.prepareLineChartData(overallSummaryDetails?.trends);
          } else {
            this.lineChartLoader = false;
            this.lineChartError = true;
          }
        } else {
          this.lineChartLoader = false;
          this.lineChartError = true;
        }
      })
    } else if (this.isAccountLevel === false) {
      this.lineChartDisplayName = this.creatingLabels().display;
      this.chartName = this.updateChartEvent?.currentValueName ? this.updateChartEvent?.currentValueName : _.get(this.helpersResponse, 'brandDetails.name', null);
      let payload: any = {
        ...this.buildProjectComparisonBasePayload(),
        group_id: null,
        shop_id: null,
        trend_type: this.lineChartTrendType,
        caller: 1,
        use_es: true,
        questions: null,
        filters: this.updateChartEvent?.cohorts_filter && this.updateChartEvent?.cohorts_filter.length > 0 ? this.updateChartEvent?.cohorts_filter : [],
      };
      delete payload.view_type;
      delete payload.field_id;
      delete payload.field_type;
      delete payload.size;
      delete payload.question_aggs;
      if (!this.isSelectedTrendsSummaryRatingQuestion()) {
        this.lineChartLoader = false;
        this.lineChartError = true;
        return;
      }
      this.applyTrendLineChartScaleFromSelectedQuestion();
      this.responseAnalyticsService.getTrendDataRatingSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message === 'Success') {
          let data: any = response?.data?.response;
          if (data.length > 0) {
            this.lineChartDataCache = data;
            this.prepareLineChartData(data);
          } else {
            this.lineChartLoader = false;
            this.lineChartError = true;
          }
        } else {
          this.lineChartLoader = false;
          this.lineChartError = true;
        }
      })
    }
  }

  private prepareLineChartData(data: any): void {
    if (this.isAccountLevel) {
      let obj: any = {
        labels: this.prepareLabelsForChart(data, this.lineChartTrendType),
        xText: this.lineChartDisplay,
        yText: this.lineChartDisplayName,
        data: [],
        responses: []
      };
      if (this.creatingLabels().rating == 'NPS') {
        for (let date in data) {
          if (data[date]?.users_rater_primary_rating > 0) {
            let top: any = data[date]?.promoters || 0;
            let bottom: any = data[date]?.detractors || 0;
            let response: any = data[date]?.users_rater_primary_rating || 0;
            let rating: any = 'N/A';
            let beforeRating: any = response > 0 ? (((top - bottom) / response) * 100) : 'N/A';
            if (beforeRating !== 'N/A') {
              if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
                rating = Math.floor(beforeRating);
              } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
                rating = Math.ceil(beforeRating);
              } else {
                rating = Math.round(beforeRating);
              }
            }
            obj.data.push(rating);
            obj.responses.push(this.responseAnalyticsService.formatNumber(response));
          }
        }
      } else {
        for (let date in data) {
          if (data[date]?.users_rater_primary_rating > 0) {
            let rating: any = data[date]?.users_rater_primary_rating > 0 ? data[date]?.average_rating.toFixed(2) : 'N/A';
            obj.data.push(rating);
            obj.responses.push(this.responseAnalyticsService.formatNumber(data[date]?.users_rater_primary_rating || 0));
          }
        }
      }
      this.lineChartData = obj;
    } else if (this.isAccountLevel === false) {
      if (!this.isSelectedTrendsSummaryRatingQuestion()) {
        this.lineChartData = { labels: [], xText: this.lineChartDisplay, yText: this.lineChartDisplayName, data: [] };
        this.lineChartLoader = false;
        this.lineChartError = true;
        return;
      }
      this.applyTrendLineChartScaleFromSelectedQuestion();
      const headerLabels = this.creatingLabels();
      const labels: string[] = [];
      const chartData: number[] = [];
      const responses: any[] = [];
      data.forEach((item: any) => {
        if (this.hasTrendChartDataForSelectedQuestion(item)) {
          const details = this.getTrendChartRatingDetails(item);
          const rating = this.calculateTrendLineChartRating(details);
          if (rating == null || Number.isNaN(Number(rating))) {
            return;
          }
          labels.push(this.formatSingleTrendChartLabel(item?.time, this.lineChartTrendType));
          chartData.push(Number(rating));
          responses.push(this.responseAnalyticsService.formatNumber(this.getTrendChartItemResponseCount(item)));
        }
      });
      this.lineChartData = {
        labels,
        xText: this.lineChartDisplay,
        yText: headerLabels?.display === 'Rating' ? 'Rating' : headerLabels?.display,
        data: chartData,
        responses,
      };
    }
    if (_.size(this.lineChartData.data) > 0) {
      this.lineChartLoader = false;
      this.lineChartError = false;
    } else {
      this.lineChartLoader = false;
      this.lineChartError = true;
    }
  }

  private calculateDataForProjectChart(data: any, scaleOverride?: string) {
    let response: any = 0;
    let rating: any = 0;
    let sumOfPrimaryRating: any = 0;
    let top: any = 0;
    let mid: any = 0;
    let bottom: any = 0;
    let topPercent: any = 0;
    let midPercent: any = 0;
    let bottomPercent: any = 0;
    const scalerRaterType = scaleOverride || this.getProjectPrimaryRatingScaleType();
    const category = this.responseAnalyticsService.getRatingBandsByRaterType(scalerRaterType);
    if (!category || !data) {
      return {
        response: '0',
        rating: 'N/A',
        top: '0',
        mid: '0',
        bottom: '0',
        topPercent: '0%',
        midPercent: '0%',
        bottomPercent: '0%',
        rawResponse: 0,
        rawTop: 0,
        rawMid: 0,
        rawBottom: 0,
        sumOfPrimaryRating: 0,
      };
    }
    for (let key in data) {
      const entry = data[key];
      if (entry == null || typeof entry !== 'object') {
        continue;
      }
      const ratingVal = Number(entry.rating ?? entry.key ?? 0);
      const numberOfUsersRated = Number(
        entry.number_of_users_rated ?? entry.number_of_user_rated ?? entry.doc_count ?? 0
      );
      if (!numberOfUsersRated) {
        continue;
      }
      if (category.bottom.includes(ratingVal)) {
        bottom = bottom + numberOfUsersRated;
        sumOfPrimaryRating = sumOfPrimaryRating + numberOfUsersRated * ratingVal;
      } else if (category?.mid && category?.mid.includes(ratingVal)) {
        mid = mid + numberOfUsersRated;
        sumOfPrimaryRating = sumOfPrimaryRating + numberOfUsersRated * ratingVal;
      } else if (category.top.includes(ratingVal)) {
        top = top + numberOfUsersRated;
        sumOfPrimaryRating = sumOfPrimaryRating + numberOfUsersRated * ratingVal;
      }
    }
    response = top + mid + bottom;
    if (scalerRaterType == '0-10' || scalerRaterType == '1-5') {
      rating = response > 0 ? ((top - bottom) / response) * 100 : 'N/A';
      if (rating !== 'N/A') {
        if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
          rating = Math.floor(rating);
        } else if (rating > 0 && rating % 1 === 0.5) {
          rating = Math.ceil(rating);
        } else {
          rating = Math.round(rating);
        }
      }
    } else {
      rating = response > 0 ? (sumOfPrimaryRating / response).toFixed(2) : 'N/A';
    }
    topPercent = response > 0 ? ((top / response) * 100).toFixed(1).endsWith('.0') ? Math.floor((top / response) * 100) + '%' : ((top / response) * 100).toFixed(1) + '%' : '0%';
    midPercent = response > 0 ? ((mid / response) * 100).toFixed(1).endsWith('.0') ? Math.floor((mid / response) * 100) + '%' : ((mid / response) * 100).toFixed(1) + '%' : '0%';
    bottomPercent = response > 0 ? ((bottom / response) * 100).toFixed(1).endsWith('.0') ? Math.floor((bottom / response) * 100) + '%' : ((bottom / response) * 100).toFixed(1) + '%' : '0%';
    return {
      response: this.responseAnalyticsService.formatNumber(response),
      rating,
      top: this.responseAnalyticsService.formatNumber(top),
      mid: this.responseAnalyticsService.formatNumber(mid),
      bottom: this.responseAnalyticsService.formatNumber(bottom),
      topPercent,
      midPercent,
      bottomPercent,
      rawResponse: response,
      rawTop: top,
      rawMid: mid,
      rawBottom: bottom,
      sumOfPrimaryRating: sumOfPrimaryRating
    };
  }

  callApiForBarChart(): void {
    this.barChartLoader = true;
    if (this.isAccountLevel) {
      const payload: any = {
        account_id: _.get(this.helpersResponse, 'accountDetails._id', null),
        from: _.get(this.helpersResponse, 'datePicker.startDate', null),
        to: _.get(this.helpersResponse, 'datePicker.endDate', null),
        rater_type: this.scalerRaterType,
        view_type: "trend",
        field_id: "project",
        field_type: "project",
        trend_type: this.barChartTrendType,
        date_filter_type: _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        universal_filter: _.get(this.helpersResponse, 'universalFilter', null),
        project_type: _.get(this.helpersResponse, 'projectType.project_type', null),
        cohorts_filter: []
      };
      if (_.size(this.updateChartEvent) > 0) {
        if (this.updateChartEvent.projectId) {
          payload.brand_id = this.updateChartEvent.projectId;
        } else if (this.updateChartEvent.subAccountId) {
          payload.sub_account_id = this.updateChartEvent.subAccountId;
        } else if (this.updateChartEvent.cohorts_filter?.length > 0 && this.updateChartEvent.cohorts_filter[0]?.field_id) {
          payload.cohorts_filter.push(...this.updateChartEvent.cohorts_filter);
        }
      }
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getAccountScoresSummary(payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(response => {
          if (response?.message === 'Success') {
            const trends = response.data?.overall_summary_details?.trends || [];
            this.barChartDataCache = trends;
            this.prepareBarChartData(trends);
          } else {
            this.handleBarChartError();
          }
        });
    } else if (this.isAccountLevel === false) {
      let payload: any = {
        ...this.buildProjectComparisonBasePayload(),
        group_id: null,
        shop_id: null,
        trend_type: this.barChartTrendType,
        caller: 1,
        use_es: true,
        questions: null,
        filters: this.updateChartEvent?.cohorts_filter && this.updateChartEvent?.cohorts_filter.length > 0 ? this.updateChartEvent?.cohorts_filter : [],
      };
      delete payload.view_type;
      delete payload.field_id;
      delete payload.field_type;
      delete payload.size;
      delete payload.question_aggs;
      this.responseAnalyticsService.getTrendDataRatingSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message === 'Success') {
          let data: any = response?.data?.response;
          if (data.length > 0) {
            this.barChartDataCache = data;
            this.prepareBarChartData(data);
          } else {
            this.barChartLoader = false;
            this.barChartError = true;
          }
        } else {
          this.barChartLoader = false;
          this.barChartError = true;
        }
      })
    }
  }

  private prepareBarChartData(data: any): void {
    if (_.size(data) === 0) return this.handleBarChartError();
    this.barChartLoader = false;
    this.barChartError = false;
    this.barChartData = this.generateBarChartConfig(data);
  }

  private changeBarChart(): void {
    this.barChartLoader = true;
    const data = this.barChartDataCache;
    if (_.size(data) === 0) return this.handleBarChartError();
    this.barChartLoader = false;
    this.barChartError = false;
    this.barChartData = this.generateBarChartConfig(data);
  }

  private generateBarChartConfig(data: any): any {
    const labels = this.prepareLabelsForChart(data, this.barChartTrendType);
    const headersLabel = this.creatingLabels();
    const isPercentage = this.isBarChartTypePercentage;
    const responses: any[] = [];
    const dataset: any = ['top', 'mid', 'bottom'].map(level => {
      return {
        label: headersLabel?.[level],
        data: [],
        backgroundColor: this.getColorByLevel(level),
        maxBarThickness: 60
      };
    });
    if (this.isAccountLevel) {
      for (let date in data) {
        const entry = data[date];
        const total = entry?.users_rater_primary_rating || 0;
        if (total > 0) {
          dataset[0].data.push(this.computeValue(entry.top || entry.promoters || entry.positives, total, isPercentage));
          dataset[1].data.push(this.computeValue(entry.mid || entry.passives, total, isPercentage));
          dataset[2].data.push(this.computeValue(entry.bottom || entry.detractors || entry.negatives, total, isPercentage));
          responses.push(this.responseAnalyticsService.formatNumber(total));
        }
      }
    } else if (this.isAccountLevel === false) {
      data.forEach(item => {
        if (this.hasTrendChartDataForSelectedQuestion(item)) {
          let calculatedData: any = this.calculateDataForProjectChart(this.getTrendChartRatingDetails(item));
          if (calculatedData?.rawResponse > 0) {
            dataset[0].data.push(this.computeValue(calculatedData?.rawTop, calculatedData?.rawResponse, isPercentage));
            dataset[1].data.push(this.computeValue(calculatedData?.rawMid, calculatedData?.rawResponse, isPercentage));
            dataset[2].data.push(this.computeValue(calculatedData?.rawBottom, calculatedData?.rawResponse, isPercentage));
            responses.push(this.responseAnalyticsService.formatNumber(this.getTrendChartItemResponseCount(item) || calculatedData.rawResponse));
          }
        }
      })
    }
    return {
      labels,
      xText: this.barChartDisplay,
      dataset: dataset.filter(d => d.label),
      showPercentage: isPercentage,
      responses
    };
  }

  private computeValue(value: number, total: number, percentage: boolean): number | string {
    if (!percentage) return value || 0;
    return total > 0 ? ((value / total) * 100).toFixed(1) : '0';
  }

  private getColorByLevel(level: string): string {
    const colors: any = {
      top: '#0B7139',
      mid: '#FAB416',
      bottom: '#ED2424'
    };
    return colors[level] || '#000000';
  }

  private handleBarChartError(): void {
    this.barChartLoader = false;
    this.barChartError = true;
  }

  prepareLabelsForChart(data: any, type: number): string[] {
    const trendType = type;
    const labels: string[] = [];
    if (!this.isAccountLevel) {
      data.forEach((item: any) => {
        if (this.hasTrendChartDataForSelectedQuestion(item)) {
          labels.push(this.formatSingleTrendChartLabel(item?.time, trendType));
        }
      });
    } else {
      for (const key in data) {
        if (data[key]?.users_rater_primary_rating > 0) {
          labels.push(this.formatSingleTrendChartLabel(key, trendType));
        }
      }
    }
    return labels;
  }

  private formatSingleTrendChartLabel(time: string | number, trendType: number): string {
    const momentTime = moment.utc(time);
    switch (trendType) {
      case 0:
        return momentTime.format('hh:mm A');
      case 1:
      case 2:
        return momentTime.format("DD MMM 'YY");
      case 3:
        return momentTime.format("MMM 'YY");
      case 4:
        return `${momentTime.format('MMM')}-${momentTime.endOf('quarter').format('MMM')} ${momentTime.format('YYYY')}`;
      case 5:
        return momentTime.format('YYYY');
      default:
        return '';
    }
  }

  onShowComparisonChange(checked: boolean): void {
    this.showComparisonFlag = checked;
    setShowComparisonFlag(checked);
  }

  private refreshComparisonLabels(): void {
    this.dateType =
      _.get(this.helpersResponse, 'datePicker.trendType') ||
      _.get(this.helpersResponse, 'datePicker.selectedTrend') ||
      _.get(Helpers, 'datePicker.trendType') ||
      _.get(Helpers, 'datePicker.selectedTrend') ||
      'period';
    this.comparisonPeriodLabel = getComparisonPeriodLabel();
    this.isComparisonAvailable = isComparisonAvailable();
    if (!this.isComparisonAvailable) {
      this.showComparisonFlag = false;
      setShowComparisonFlag(false);
    } else {
      this.showComparisonFlag = getShowComparisonFlag();
    }
  }

  private getProjectPrimaryRatingScaleType(): string | undefined {
    const selectedQuestion = this.getSelectedTrendsSummaryQuestion();
    if (selectedQuestion?.scale_rater_type) {
      return selectedQuestion.scale_rater_type;
    }
    const items =
      _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items') ??
      _.get(Helpers, 'brandDetails.detailed_feedback_items');
    return items?.find((item: any) => item?.is_primary_rating)?.scale_rater_type;
  }

  private getNumericRatingAndResponsesForDeviation(distribution: Record<string, number> | null | undefined): { rating: number; responses: number } | null {
    if (!distribution || typeof distribution !== 'object') {
      return { rating: 0, responses: 0 };
    }
    const calc = this.calculateDataForProject(distribution);
    if (!calc || !calc.rawResponse) {
      return { rating: 0, responses: 0 };
    }
    if (calc.rating === 'N/A') {
      return { rating: 0, responses: calc.rawResponse };
    }
    const ratingNum = typeof calc.rating === 'number' ? calc.rating : parseFloat(String(calc.rating));
    if (isNaN(ratingNum)) {
      return { rating: 0, responses: calc.rawResponse };
    }
    return { rating: ratingNum, responses: calc.rawResponse };
  }

  private isAccountNpsScale(): boolean {
    return this.scalerRaterType == 3 || this.scalerRaterType === '3';
  }

  private isProjectNpsScale(): boolean {
    const scaleType = this.getProjectPrimaryRatingScaleType();
    return scaleType === '0-10' || scaleType === '1-5' || _.get(Helpers, 'brandDetails.main_rater_type', 2) == 3;
  }

  private normalizeComparisonEntry(entry: any): any {
    if (!entry) {
      return entry;
    }
    if (!entry.previous && entry.current?.previous) {
      return { ...entry, previous: entry.current.previous };
    }
    return entry;
  }

  private getSegregatedComparisonMetrics(summaryNode: any, isNpsCard: boolean): { rating: number; responses: number } | null {
    if (!summaryNode) {
      return null;
    }
    const segregated = this.responseAnalyticsService.segregateData(summaryNode);
    const responses = segregated.responses || 0;
    let rating: number;
    if (isNpsCard) {
      let nps = parseFloat(this.responseAnalyticsService.calculateNPS(responses, segregated.top, segregated.bottom));
      if (isNaN(nps)) {
        nps = 0;
      } else if (nps % 1 === 0.5 || nps % 1 === -0.5) {
        nps = nps < 0 ? Math.floor(nps) : Math.ceil(nps);
      } else {
        nps = Math.round(nps);
      }
      rating = nps;
    } else {
      rating = parseFloat(Number(segregated.rating || 0).toFixed(2));
    }
    return { rating: isNaN(rating) ? 0 : rating, responses };
  }

  private getAccountComparisonMetrics(summaryNode: any, isNps: boolean): { rating: number; responses: number } | null {
    if (!summaryNode) {
      return null;
    }
    const responses =
      summaryNode?.number_of_users_rated_primary_rating ??
      summaryNode?.users_rater_primary_rating ??
      summaryNode?.doc_count ??
      0;
    if (isNps) {
      const top = summaryNode?.promoters ?? summaryNode?.top ?? summaryNode?.positives ?? 0;
      const bottom = summaryNode?.detractors ?? summaryNode?.bottom ?? summaryNode?.negatives ?? 0;
      if (!responses) {
        return { rating: 0, responses: 0 };
      }
      const rating = parseFloat(this.responseAnalyticsService.calculateNPS(responses, top, bottom));
      return { rating: isNaN(rating) ? 0 : rating, responses };
    }
    if (summaryNode?.average_rating != null && summaryNode?.average_rating !== 'N/A') {
      return {
        rating: parseFloat(Number(summaryNode.average_rating).toFixed(2)),
        responses,
      };
    }
    return { rating: 0, responses };
  }

  private applyComparisonApiDateRange(payload: any): void {
    if (!payload) {
      return;
    }
    applyComparisonApiDateRange(
      payload,
      _.get(this.helpersResponse, 'datePicker', null) ?? Helpers?.datePicker
    );
  }

  private attachAccountRowDeviations(
    row: any,
    currentSummary: any,
    previousSummary: any,
    comparisonEntry?: any
  ): void {
    if (!row) {
      return;
    }
    const entry = this.normalizeComparisonEntry(comparisonEntry ?? { current: currentSummary, previous: previousSummary });
    const isNps = this.isAccountNpsScale();
    const currentNode = entry?.current ?? currentSummary;
    const previousNode = entry?.previous ?? previousSummary;
    const current =
      getAccountSummaryMetrics(currentNode, isNps) ??
      this.getAccountComparisonMetrics(currentNode, isNps) ??
      { rating: 0, responses: 0 };
    const previous =
      getAccountSummaryMetrics(previousNode, isNps) ??
      this.getAccountComparisonMetrics(previousNode, isNps) ??
      { rating: 0, responses: 0 };
    attachMetricDeviations(row, current, previous);
  }

  private attachComparisonRowDeviations(
    row: any,
    currentSummary: any,
    previousSummary: any,
    comparisonEntry?: any
  ): void {
    if (!row || this.isAccountLevel) {
      return;
    }
    const entry = this.normalizeComparisonEntry(comparisonEntry ?? { current: currentSummary, previous: previousSummary });
    this.attachComparisonEntryDeviations(row, entry);
    if (row.deviations?.rating != null) {
      return;
    }
    const currentNode = entry?.current ?? currentSummary;
    const previousNode = entry?.previous ?? previousSummary;
    const isNps = this.isProjectNpsScale();
    const currentMetrics =
      this.getSegregatedComparisonMetrics(currentNode, isNps) ??
      { rating: 0, responses: 0 };
    const previousMetrics =
      this.getSegregatedComparisonMetrics(previousNode, isNps) ??
      { rating: 0, responses: 0 };
    attachMetricDeviations(row, currentMetrics, previousMetrics);
  }

  private attachComparisonEntryDeviations(row: any, entry: any): void {
    if (!row || this.isAccountLevel) {
      return;
    }
    const question = this.getSelectedTrendsSummaryQuestion();
    const fieldId = this.resolveTrendsSummaryFieldIdForCurrentBrand();
    const isPrimaryQuestion =
      !fieldId || fieldId === 'primary_rating' || question?.is_primary_rating;

    if (question?.type === 'rating' && !isPrimaryQuestion) {
      const { current, previous } = getComparisonDetailedRatingResult(entry, fieldId);
      const scalerRaterType =
        question?.scale_rater_type || this.getEffectiveScaleRaterTypeForProject();
      const getBands = (type: string) => this.responseAnalyticsService.getRatingBandsByRaterType(type);
      attachMetricDeviations(
        row,
        getNumericMetricsFromRatingResult(current, scalerRaterType, getBands),
        getNumericMetricsFromRatingResult(previous, scalerRaterType, getBands)
      );
      return;
    }

    const { current: curDist, previous: prevDist } = extractComparisonDistributionsFromRatingEntry(entry);
    attachRatingResponseDeviations(
      row,
      curDist,
      prevDist,
      (dist) => this.getNumericRatingAndResponsesForDeviation(dist)
    );
  }

  prepareTableHeader(type: string): any {
    const baseHeader: any[] = [];
    const headerLabels = this.creatingLabels();
    const isAccount = this.isAccountLevel;
    const metricColumnWidth = this.isComparisonAvailable ? '150px' : '130px';
    const responsesColumn = { uniqueId: 'responses', header: 'Responses', width: metricColumnWidth, style: { header: 'flex-end', row: 'flex-end' }, isSorting: true };
    const columns: any[] = [];
    if (headerLabels.top) {
      columns.push({ uniqueId: 'rating', header: headerLabels.display, width: metricColumnWidth, style: { header: 'flex-end', row: 'flex-end' }, isSorting: true });
    }
    columns.push(responsesColumn);
    const addDefaultTopMidBottomColumns = () => {
      ['top', 'mid', 'bottom'].forEach((label) => {
        if (headerLabels[label]) {
          columns.push({ uniqueId: label, header: headerLabels[label], width: '150px', style: { header: 'flex-end', row: 'flex-end' }, isSorting: true });
        }
      });
    };
    const addPromoterStyleColumns = () => {
      columns.push(
        { uniqueId: 'top', header: 'Promoters', width: '150px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/promoters.svg', style: { header: 'center', row: 'center' } },
        { uniqueId: 'mid', header: 'Passives', width: '150px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/passive.svg', style: { header: 'center', row: 'center' } },
        { uniqueId: 'bottom', header: 'Detractors', width: '150px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/detractors.svg', style: { header: 'center', row: 'center' } }
      );
    };
    if (isAccount) {
      if (this.scalerRaterType === 3) {
        addPromoterStyleColumns();
      } else {
        addDefaultTopMidBottomColumns();
      }
    } else {
      const scalerRaterType = this.getProjectPrimaryRatingScaleType();
      if (scalerRaterType === '0-10') {
        addPromoterStyleColumns();
      } else if (type !== '' && scalerRaterType === '8') {
        columns.push(
          { uniqueId: 'top', header: 'Positives', width: '150px', isSorting: true, isHeaderTextHide: false, style: { header: 'flex-end', row: 'flex-end' } },
          { uniqueId: 'bottom', header: 'Negatives', width: '150px', isSorting: true, isHeaderTextHide: false, style: { header: 'flex-end', row: 'flex-end' } }
        );
      } else {
        addDefaultTopMidBottomColumns();
      }
    }
    baseHeader.push(...columns);
    return baseHeader;
  }

  creatingLabels() {
    const isAccount = this.isAccountLevel;
    const defaultLabels = { top: '', mid: '', bottom: '', rating: 'Rating', display: 'Rating' };
    let scalerRaterType: any;
    let labelConfigsPath: string;
    let raterTypeKey: string | null = null;
    if (isAccount) {
      scalerRaterType = this.scalerRaterType;
      labelConfigsPath = 'accountDetails.label_configs.NPS.value';
    } else {
      scalerRaterType =
        this.getSelectedTrendsSummaryQuestion()?.scale_rater_type ??
        _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', [])?.find((item: any) => item?.is_primary_rating)?.scale_rater_type ??
        Helpers?.brandDetails?.detailed_feedback_items?.find((item: any) => item?.is_primary_rating)?.scale_rater_type;
      labelConfigsPath = 'brandDetails.label_configs.NPS.value';
    }
    const npsDisplayName = _.get(Helpers, labelConfigsPath, 'NPS') || 'NPS';
    const accountLabelMap = {
      '3': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', topImg: 'promoters', midImg: 'passive', bottomImg: 'detractors', rating: 'NPS', display: npsDisplayName },
      '6': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
      '4': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '1': { top: 'Positives', mid: '', bottom: 'Negatives' }
    };
    const brandLabelMap = {
      '0-10': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
      '1-5': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
      '1-10': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
      '7': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '5': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '9': { top: 'TB', mid: 'MB', bottom: 'BB' },
      '-5 to 5': { top: 'Positives', bottom: 'Negatives' },
      '-5 to +5': { top: 'Positives', bottom: 'Negatives' },
      '8': { overalltop: 'Positives', overallbottom: 'Negatives', top: 'T3B', mid: 'MB', bottom: 'B3B' }
    };
    raterTypeKey = scalerRaterType !== undefined ? scalerRaterType.toString() : null;
    const labelMap = isAccount ? accountLabelMap : brandLabelMap;
    const labels = raterTypeKey && labelMap[raterTypeKey];
    return labels ? { ...defaultLabels, ...labels } : defaultLabels;
  }

  disableTableSorting(tableHeader) {
    const updatedHeader = tableHeader.map((column: any) => ({
      ...column,
      isSorting: false
    }));
    return updatedHeader;
  }

  callApiForPerformerChart() {
    let checkLastAppiledUniversalFilter = this.checkUniversalFilter();
    if (checkLastAppiledUniversalFilter) {
      return;
    }
    this.perfomerChartLoader = true;
    this.performerChartDataForDownload = [];
    if (this.isAccountLevel) {
      let payload: any = {
        "account_id": _.get(this.helpersResponse, 'accountDetails._id', null),
        "from": _.get(this.helpersResponse, 'datePicker.startDate', null),
        "to": _.get(this.helpersResponse, 'datePicker.endDate', null),
        "rater_type": this.scalerRaterType,
        "view_type": "list",
        "field_id": this.performerTypeDropdownSelectedFieldId,
        "field_type": "tag",
        "project_type": _.get(this.helpersResponse, 'projectType.project_type', null),
        "is_custom_date_range_selected": false,
        "date_filter_type": _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        "universal_filter": this.filterUniversalFilter()
      }
      if (_.size(this.updateChartEvent) > 0) {
        if (this.updateChartEvent?.projectId) {
          payload['brand_id'] = this.updateChartEvent?.projectId;
        } else if (this.updateChartEvent?.subAccountId) {
          payload['sub_account_id'] = this.updateChartEvent?.subAccountId;
        } else if (this.updateChartEvent?.cohorts_filter && this.updateChartEvent?.cohorts_filter.length > 0 && this.updateChartEvent?.cohorts_filter[0]?.field_id) {
          payload['cohorts_filter'] = this.updateChartEvent?.cohorts_filter;
        }
      }
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message === 'Success') {
          this.performerChartDataCache = response?.data?.overall_summary_details?.overall_summary;
          if (_.size(this.performerChartDataCache) > 0) {
            this.preparePerformerChart();
          } else {
            this.perfomerChartLoader = false;
            this.perfomerChartError = true;
          }
        } else {
          this.perfomerChartLoader = false;
          this.perfomerChartError = true;
        }
      })
    } else if (this.isAccountLevel === false) {
      let payload: any = this.buildProjectComparisonBasePayload({
        view_type: 'list',
        field_id: this.performerTypeDropdownSelectedFieldId,
        field_type: this.performerTypeDropdownSelectedFieldType === 'response' ? 'response' : 'tag',
        size: 101,
        universal_filter: this.filterUniversalFilter(),
        filters: [],
      });
      payload['is_custom_date_range_selected'] = true;
      if (this.updateChartEvent?.cohorts_filter && this.updateChartEvent?.cohorts_filter.length > 0 && this.updateChartEvent?.cohorts_filter[0]?.field_id) {
        payload['filters'].push(...this.updateChartEvent?.cohorts_filter);
      }
      if (this.performerTypeDropdownSelectedDataType) {
        payload['field_data_type'] = this.performerTypeDropdownSelectedDataType;
      }
      if (this.performerTypeDropdownSelectedFieldType === 'response') {
        const detailedFeedbackItems = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', []);
        const detailedFeedbackItem = detailedFeedbackItems.find(
          item => item.field_id === this.performerTypeDropdownSelectedFieldId
        );
        if (detailedFeedbackItem) {
          const { type, possible_values } = detailedFeedbackItem;
          if (type === 'text') {
            this.hierarchyTableLoader = false;
            this.hierarchyTableError = true;
          } else if (['rating', 'single-select'].includes(type)) {
            payload['field_sub_type'] = type;
            payload['possible_values'] = possible_values;
          } else if (type === 'multi-select') {
            payload['field_sub_type'] = type;
            payload['possible_values'] = detailedFeedbackItems
              .filter(item => item?.group_id === this.performerTypeDropdownSelectedFieldId)
              .map(item => ({ field_id: item?.field_id, value: item?.value }));
          }
        }
      }

      this.performerPayload = payload;
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getcomparisonV2Data(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message === 'Success') {
          this.performerChartDataCache = response?.data?.RatingsSummary;
          this.downloadPerformerDataFromJob = Object.keys(this.performerChartDataCache || {}).length >= 100;
          if (_.size(this.performerChartDataCache) > 0) {
            this.preparePerformerChart();
          } else {
            this.perfomerChartLoader = false;
            this.perfomerChartError = true;
          }
        } else {
          this.perfomerChartLoader = false;
          this.perfomerChartError = true;
        }
      })
    }
  }

  private preparePerformerChart(): void {
    this.performerChartData = [];
    let impactScoreData: any = {};
    if (this.isAccountLevel) {
      impactScoreData = this.prepareImpactScoreForAccount(this.performerChartDataCache);
    } else if (this.isAccountLevel === false) {
      impactScoreData = this.prepareImpactScoreForProject(this.performerChartDataCache, this.performerTypeDropdownSelectedFieldId);
    }
    this.topandbottomperformersortedData = [];
    if (this.isBottomPerformers) {
      this.topandbottomperformersortedData = (_.sortBy(impactScoreData, 'impactScore'));
    } else if (this.isTopPerformers) {
      this.topandbottomperformersortedData = (_.sortBy(impactScoreData, 'impactScore')).reverse();
    }
    if (_.size(this.topandbottomperformersortedData) > 0) {
      this.performerChartDataForDownload.push(this.topandbottomperformersortedData);
      let viewTypeFromFieldDefinition: any = {};
      if (this.isAccountLevel) {
        viewTypeFromFieldDefinition = Helpers?.accountDetails?.field_definitions.filter(item => item.field_id === this.performerTypeDropdownSelectedFieldId)[0];
      } else if (this.isAccountLevel == false) {
        viewTypeFromFieldDefinition = Helpers?.brandDetails?.field_definitions.filter(item => item.field_id === this.performerTypeDropdownSelectedFieldId)[0];
      }
      if (viewTypeFromFieldDefinition?.view_type === 'importance' || viewTypeFromFieldDefinition?.view_type == undefined) {
        let headersLabel: any = this.creatingLabels();
        let obj: any = {
          labels: [],
          values: [],
          ratingName: headersLabel?.display,
          responses: [],
          rating: [],
          xText: viewTypeFromFieldDefinition?.name || '',
          fieldId: this.performerTypeDropdownSelectedFieldId,
          fieldType: this.performerTypeDropdownSelectedFieldType,
          fieldDataType: this.performerTypeDropdownSelectedDataType,
          datasets: [{
            label: 'Weightage',
            data: [],
            backgroundColor: '#007B7F',
            barThickness: 120,
            borderWidth: 0.1
          }],
        };
        this.topandbottomperformersortedData.forEach((data, index) => {
          if (index < 15) {
            obj.labels.push(data?.name);
            obj.datasets[0].data.push(data?.weightage);
            obj.rating.push(data?.rating);
            obj.responses.push(data?.response);
            obj.values.push(data?.value);
          }
        })
        this.performerChartData = obj;
      } else if (viewTypeFromFieldDefinition?.view_type === 'distribution') {
        let headersLabel: any = this.creatingLabels();
        let obj: any = {
          labels: [],
          values: [],
          ratingName: headersLabel?.display,
          responses: [],
          rating: [],
          fieldId: this.performerTypeDropdownSelectedFieldId,
          fieldType: this.performerTypeDropdownSelectedFieldType,
          fieldDataType: this.performerTypeDropdownSelectedDataType,
          xText: viewTypeFromFieldDefinition?.name || '',
          datasets: [],
        };
        let top: any = {
          label: headersLabel?.top,
          data: [],
          backgroundColor: '#0B7139',
          barThickness: 120,
          borderWidth: 0.1
        };
        let mid: any = {
          label: headersLabel?.mid,
          data: [],
          backgroundColor: '#FAB416',
          barThickness: 120,
          borderWidth: 0.1
        };
        let bottom: any = {
          label: headersLabel?.bottom,
          data: [],
          backgroundColor: '#ED2424',
          barThickness: 120,
          borderWidth: 0.1
        };
        this.topandbottomperformersortedData.forEach((data, index) => {
          if (index < 15) {
            obj.labels.push(data?.name);
            top.data.push(data?.topPercent);
            mid.data.push(data?.midPercent);
            bottom.data.push(data?.bottomPercent);
            obj.rating.push(data?.rating);
            obj.responses.push(data?.response);
            obj.values.push(data?.value);
          }
        })
        obj.datasets.push(top);
        if (headersLabel?.mid) {
          obj.datasets.push(mid);
        }
        obj.datasets.push(bottom);
        this.performerChartData = obj;
      }
    } else {
      this.perfomerChartLoader = false;
      this.perfomerChartError = true;
    }
    if (this.performerChartData?.labels && this.performerChartData?.labels.length > 0) {
      this.perfomerChartLoader = false;
      this.perfomerChartError = false;
    } else {
      this.perfomerChartLoader = false;
      this.perfomerChartError = true;
    }
  }

  callApiForChartDrilldown() {
    if (!this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldId) {
      return;
    }
    if (this.isAccountLevel) {
      let payload: any = {
        "account_id": _.get(this.helpersResponse, 'accountDetails._id', null),
        "from": _.get(this.helpersResponse, 'datePicker.startDate', null),
        "to": _.get(this.helpersResponse, 'datePicker.endDate', null),
        "rater_type": this.scalerRaterType,
        "view_type": "list",
        "field_id": this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldId,
        "field_type": "tag",
        "project_type": _.get(this.helpersResponse, 'projectType.project_type', null),
        "is_custom_date_range_selected": true,
        "date_filter_type": _.get(this.helpersResponse, 'datePicker.dateFilterType', null),
        "universal_filter": this.filterUniversalFilter(),
        "cohorts_filter": []
      };
      if (this.cohortsFilterChart.length > 0) {
        payload['cohorts_filter'].push(...this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.cohorts_filter);
      }
      if (_.size(this.updateChartEvent) > 0) {
        if (this.updateChartEvent?.projectId) {
          payload['brand_id'] = this.updateChartEvent?.projectId;
        } else if (this.updateChartEvent?.subAccountId) {
          payload['sub_account_id'] = this.updateChartEvent?.subAccountId;
        } else if (this.updateChartEvent?.cohorts_filter && this.updateChartEvent?.cohorts_filter.length > 0 && this.updateChartEvent?.cohorts_filter[0]?.field_id) {
          payload['cohorts_filter'].push(...this.updateChartEvent?.cohorts_filter);
        }
      }
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message === 'Success') {
          let responses: any = response?.data?.overall_summary_details?.overall_summary;
          this.preparePerformerDrilldownChart(responses);
        }
      })
    } else if (this.isAccountLevel === false) {
      let payload: any = this.buildProjectComparisonBasePayload({
        view_type: 'list',
        field_id: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldId,
        field_type:
          this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldType === 'response' ? 'response' : 'tag',
        size: 100,
        universal_filter: this.filterUniversalFilter(),
        filters: [],
      });
      if (this.updateChartEvent?.cohorts_filter && this.updateChartEvent?.cohorts_filter.length > 0 && this.updateChartEvent?.cohorts_filter[0]?.field_id) {
        payload['filters'].push(...this.updateChartEvent?.cohorts_filter);
      }
      if (this.cohortsFilterChart.length > 0) {
        payload['filters'].push(...this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.cohorts_filter);
      }
      if (this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldType === 'response') {
        const detailedFeedbackItems = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', []);
        const detailedFeedbackItem = detailedFeedbackItems.find(
          item => item.field_id === this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldId
        );
        if (detailedFeedbackItem) {
          const { type, possible_values } = detailedFeedbackItem;
          if (type === 'text') {
            this.hierarchyTableLoader = false;
            this.hierarchyTableError = true;
          } else if (['rating', 'single-select'].includes(type)) {
            payload['field_sub_type'] = type;
            payload['possible_values'] = possible_values;
          } else if (type === 'multi-select') {
            payload['field_sub_type'] = type;
            payload['possible_values'] = detailedFeedbackItems
              .filter(item => item?.group_id === this.performerTypeDropdownSelectedFieldId)
              .map(item => ({ field_id: item?.field_id, value: item?.value }));
          }
        }
      }
      this.performerDrilldownPayloads.push(payload);
      this.applyComparisonApiDateRange(payload);
      this.responseAnalyticsService.getcomparisonV2Data(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response?.message === 'Success') {
          let responses: any = response?.data?.RatingsSummary;
          this.downloadPerformerDataFromJob = this.downloadPerformerDataFromJob || Object.keys(responses || {}).length >= 100;
          this.preparePerformerDrilldownChart(responses);
        }
      })
    }
  }

  private preparePerformerDrilldownChart(data) {
    let impactScoreData: any = {};
    if (this.isAccountLevel) {
      impactScoreData = this.prepareImpactScoreForAccount(data);
    } else if (this.isAccountLevel == false) {
      impactScoreData = this.prepareImpactScoreForProject(data, this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldId);
    }
    let sortedData: any = [];
    if (this.isBottomPerformers) {
      sortedData = impactScoreData.sort((a, b) => a.impactScore - b.impactScore);
    } else if (this.isTopPerformers) {
      sortedData = impactScoreData.sort((a, b) => b.impactScore - a.impactScore);
    }
    if (_.size(sortedData) > 0) {
      this.performerChartDataForDownload.push(sortedData);
      let headersLabel: any = this.creatingLabels();
      let obj: any = {
        labels: [],
        values: [],
        ratingName: headersLabel?.display,
        responses: [],
        rating: [],
        fieldId: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldId,
        fieldType: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextFieldType,
        fieldDataType: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextDataType,
        xText: this.cohortsFilterChart[this.cohortsFilterChart.length - 1]?.nextName,
        datasets: [{
          label: 'Weightage',
          data: [],
          backgroundColor: this.isTopPerformers ? '#007B7F' : '#FF6F61',
          barThickness: 120,
          borderWidth: 0.1
        }],
      };
      sortedData.forEach((data, index) => {
        if (index < 15) {
          obj.labels.push(data?.name);
          obj.datasets[0].data.push(data?.weightage);
          obj.rating.push(data?.rating);
          obj.responses.push(data?.response);
          obj.values.push(data?.value);
        }
      })
      this.drilldownChartCache.push(obj);
    } else {
      // Error in perforemer chart and loading true
    }
  }

  prepareImpactScoreForAccount(data: any): any {
    let overallRating: number = Number(this.overallTableDataCache?.average_rating);
    if (this.scalerRaterType == 3) {
      overallRating = ((this.overallTableDataCache?.promoters - this.overallTableDataCache?.detractors) / this.overallTableDataCache?.users_rater_primary_rating) * 100;
    }
    // Use total project responses for selected date range
    let totalResponses: any = this.overallTableDataCache?.users_rater_primary_rating || 0;
    let result: any = [];
    for (let key in data) {
      let resultObj: any = {};
      resultObj.name = key;
      let currentData: any = data[key]?.summary?.current;
      let response: any = currentData?.users_rater_primary_rating || 0;
      let top: any = currentData?.top || currentData?.promoters || currentData?.positives || 0;
      let mid: any = currentData?.mid || currentData?.passives || 0;
      let bottom: any = currentData?.bottom || currentData?.detractors || currentData?.negatives || 0;
      let topPercent: any = response > 0 ? ((top / response) * 100).toFixed(1) : 0;
      let midPercent: any = response > 0 ? ((mid / response) * 100).toFixed(1) : 0;
      let bottomPercent: any = response > 0 ? ((bottom / response) * 100).toFixed(1) : 0;
      let rating: any = 'N/A';
      let ratingWithOutRoundOff: any = 0;
      if (this.scalerRaterType == 3) {
        let beforeRating: any = response > 0 ? (((top - bottom) / response) * 100) : 'N/A';
        ratingWithOutRoundOff = response > 0 ? (((top - bottom) / response) * 100) : 'N/A';
        if (beforeRating !== 'N/A') {
          if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
            rating = Math.floor(beforeRating);
          } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
            rating = Math.ceil(beforeRating);
          } else {
            rating = Math.round(beforeRating);
          }
        }
      } else {
        rating = currentData?.users_rater_primary_rating > 0 ? currentData?.average_rating.toFixed(2) : 'N/A';
        ratingWithOutRoundOff = currentData?.users_rater_primary_rating > 0 ? currentData?.average_rating : 'N/A';
      }
      resultObj.response = this.responseAnalyticsService.formatNumber(response);
      resultObj.top = top;
      resultObj.mid = mid;
      resultObj.bottom = bottom;
      resultObj.topPercent = topPercent;
      resultObj.midPercent = midPercent;
      resultObj.bottomPercent = bottomPercent;
      resultObj.rating = rating;
      resultObj.weightage = totalResponses ? ((response / totalResponses) * 100).toFixed(1).endsWith('.0') ? Math.floor(((response / totalResponses) * 100)) : ((response / totalResponses) * 100).toFixed(1) : 0;
      resultObj.impactScore = (ratingWithOutRoundOff - overallRating) * response;
      if (response > 0) {
        result.push(resultObj);
      }
    }
    const filteredData = result.filter(item => typeof item.impactScore === 'number' && !isNaN(item.impactScore));
    return filteredData;
  }

  prepareImpactScoreForProject(data, fieldId): any {
    const overallMetrics = this.calculateProjectRowMetricsFromComparisonEntry({
      current: this.overallTableDataCache,
    });
    let overallRating: number =
      overallMetrics?.rating != null && overallMetrics.rating !== 'N/A'
        ? Number(overallMetrics.rating)
        : 0;
    if (isNaN(overallRating)) {
      overallRating = 0;
    } else {
      overallRating = Math.round(overallRating);
    }
    
    // Use total project responses for selected date range
    let totalResponses: any = 0;
    const overallDist = this.getOverviewDistributionForTrendsQuestion(this.overallTableDataCache);
    if (overallDist) {
      totalResponses = Object.values(overallDist)
        .reduce((sum: number, val: any) => sum + (typeof val === 'number' ? val : 0), 0);
    }
    let props: any = {};
    const detailedFeedbackItems: any = _.get(this.helpersResponse, 'brandDetails.detailed_feedback_items', null);
    let detailedFeedbackItem: any = {};
    if (detailedFeedbackItems && detailedFeedbackItems.length > 0) {
      detailedFeedbackItem = detailedFeedbackItems.filter(item => item.field_id === fieldId)[0];
      if (detailedFeedbackItem && (detailedFeedbackItem?.type === 'rating' || detailedFeedbackItem?.type === 'single-select')) {
        props = detailedFeedbackItem?.prop;
      } else if (detailedFeedbackItem && detailedFeedbackItem?.type === 'multi-select') {
        let brandGroupId: any = _.filter(detailedFeedbackItems, (item: any) => item?.group_id === fieldId);
        _.forEach(brandGroupId, (item: any) => {
          props[item?.value] = item?.question || item?.text;
        });
      }
    }
    let result: any = [];
    for (let key in data) {
      const detailedFeedbackItemKey = detailedFeedbackItems.filter(item => item?.field_id === key)[0];
      const calculatedData: any = this.calculateProjectRowMetricsFromComparisonEntry(data[key]);
      const rowObj: any = {
        name: detailedFeedbackItemKey?.question || detailedFeedbackItemKey?.text || props[key]?.label || props[key] || key || '',
        value: key,
        rating: calculatedData?.rating,
        doc_count: data[key]?.doc_count,
        response: calculatedData?.response,
        top: calculatedData?.rawTop,
        mid: calculatedData?.rawMid,
        bottom: calculatedData?.rawBottom,
        topPercent: calculatedData?.topPercent.replace('%', ''),
        midPercent: calculatedData?.midPercent.replace('%', ''),
        bottomPercent: calculatedData?.bottomPercent.replace('%', ''),
        weightage: totalResponses ? ((calculatedData?.rawResponse / totalResponses) * 100).toFixed(1).endsWith('.0') ? Math.floor(((calculatedData?.rawResponse / totalResponses) * 100)) : ((calculatedData?.rawResponse / totalResponses) * 100).toFixed(1) : 0,
        impactScore: (calculatedData?.rating - overallRating) * calculatedData?.rawResponse
      };
      if (calculatedData?.rawResponse > 0) {
        result.push(rowObj);
      }
    }
    result = result.filter( (resp:any) =>{
      return resp.doc_count;
    })
    const filteredData = result.filter(item => typeof item.impactScore === 'number' && !isNaN(item.impactScore));
    return filteredData;
  }

  prepareDataForAccount(data: any) {
    const response = data?.users_rater_primary_rating ?? 0;
    const top = data?.promoters ?? data?.top ?? data?.positives ?? 0;
    const mid = data?.passives ?? data?.mid ?? 0;
    const bottom = data?.detractors ?? data?.negatives ?? data?.bottom ?? 0;
    const format = this.responseAnalyticsService.formatNumber;
    const topFormat = format(top);
    const midFormat = format(mid);
    const bottomFormat = format(bottom);
    const calculatePercent = (count: number): string => response > 0 ? `${((count / response) * 100).toFixed(1)}%` : '0%';
    const topPercent = calculatePercent(top);
    const midPercent = calculatePercent(mid);
    const bottomPercent = calculatePercent(bottom);
    let rating: string | number = 'N/A';
    if (this.scalerRaterType === 3) {
      if (response > 0) {
        const nps = ((top - bottom) / response) * 100;
        rating = (nps < 0 && nps % 1 === -0.5) || (nps > 0 && nps % 1 === 0.5) ? nps > 0 ? Math.ceil(nps) : Math.floor(nps) : Math.round(nps);
      }
    } else if (response > 0 && typeof data?.average_rating === 'number') {
      rating = data.average_rating.toFixed(2);
    }
    return { top, mid, bottom, topFormat, midFormat, bottomFormat, topPercent, midPercent, bottomPercent, response, rating };
  }

  calculateDataForProject(data?: Record<string, number> | null) {
    const dist = data ?? {};
    let response = 0;
    let sumWeightedRatings = 0;
    let top = 0, mid = 0, bottom = 0;
    const scaleType = this.getEffectiveScaleRaterTypeForProject();
    const category = this.getRatingCategoryByScale(scaleType);
    Object.entries(dist).forEach(([score, count]) => {
      const numericScore = Number(score);
      const ratingCount = count || 0;
      if (category.bottom?.includes(numericScore)) {
        bottom += ratingCount;
      } else if (category.mid?.includes(numericScore)) {
        mid += ratingCount;
      } else if (category.top?.includes(numericScore)) {
        top += ratingCount;
      }
      if (category.bottom?.includes(numericScore) || category.mid?.includes(numericScore) || category.top?.includes(numericScore)) {
        sumWeightedRatings += ratingCount * numericScore;
      }
    });
    response = top + mid + bottom;
    const rating = this.calculateAggregateRating(scaleType, response, top, bottom, sumWeightedRatings);
    const [topPercent, midPercent, bottomPercent] = this.calculatePercentages(response, top, mid, bottom);
    return {
      response: this.responseAnalyticsService.formatNumber(response),
      rating,
      top: this.responseAnalyticsService.formatNumber(top),
      mid: this.responseAnalyticsService.formatNumber(mid),
      bottom: this.responseAnalyticsService.formatNumber(bottom),
      topPercent,
      midPercent,
      bottomPercent,
      rawResponse: response,
      rawTop: top,
      rawMid: mid,
      rawBottom: bottom,
      sumOfPrimaryRating: sumWeightedRatings
    };
  }

  getRatingCategoryByScale(scaleType: string) {
    const scaleMap = {
      '-5 to 5': { bottom: [-5, -4, -3, -2, -1], mid: [0], top: [1, 2, 3, 4, 5] },
      '-5 to +5': { bottom: [-5, -4, -3, -2, -1], mid: [0], top: [1, 2, 3, 4, 5] },
      '1': { bottom: [-5, -4, -3, -2, -1], mid: [0], top: [1, 2, 3, 4, 5] },
      '0-10': { bottom: [0, 1, 2, 3, 4, 5, 6], mid: [7, 8], top: [9, 10] },
      '3': { bottom: [0, 1, 2, 3, 4, 5, 6], mid: [7, 8], top: [9, 10] },
      '1-5': { bottom: [0, 1, 2, 3, 4, 5, 6], mid: [7, 8], top: [9, 10] },
      '5': { bottom: [1, 2], mid: [3], top: [4, 5] },
      '4': { bottom: [1, 2], mid: [3], top: [4, 5] },
      '1-10': { bottom: [1, 2, 3], mid: [4, 5, 6, 7], top: [8, 9, 10] },
      '6': { bottom: [1, 2, 3], mid: [4, 5, 6, 7], top: [8, 9, 10] },
      '7': { bottom: [1, 2], mid: [3, 4], top: [5, 6] },
      '8': { bottom: [-3, -2, -1], mid: [], top: [1, 2, 3] },
      '9': { bottom: [1], mid: [2, 3], top: [4] }
    };
    return scaleMap[scaleType] || { bottom: [], mid: [], top: [] };
  }

  calculateAggregateRating(scaleType: string, totalResponses: number, top: number, bottom: number, sumWeightedRatings: number) {
    if (totalResponses === 0) return 'N/A';
    if (scaleType === '0-10') {
      let netScore = ((top - bottom) / totalResponses) * 100;
      if (netScore % 1 === 0.5 || netScore % 1 === -0.5) {
        netScore = netScore < 0 ? Math.floor(netScore) : Math.ceil(netScore);
      } else {
        netScore = Math.round(netScore);
      }
      return netScore;
    }
    return (sumWeightedRatings / totalResponses).toFixed(2);
  }

  calculatePercentages(total: number, top: number, mid: number, bottom: number) {
    const formatPercent = (value: number) => {
      if (total === 0) return '0%';
      const percent = (value / total) * 100;
      return percent.toFixed(1).endsWith('.0') ? `${Math.round(percent)}%` : `${percent.toFixed(1)}%`;
    };
    return [
      formatPercent(top),
      formatPercent(mid),
      formatPercent(bottom)
    ];
  }

  generateDrilldownReport() {
    if (this.downloadTableDataFromJob === false) {
      let downloadConfig: any = {
        dataKey: 'uniqueId',
        headerKey: 'header',
        data: []
      };
      const overallTableHeader = this.addAdditionalColumn(this.overallTable.header);
      const subAccountTableHeader = this.addAdditionalColumn(this.subAccountTable.header);
      const hierarchyTableHeader = this.addAdditionalColumn(this.hierarchyTable.header);
      const subAccountTableRow = this.processHierarchyWithColumnUpdate(JSON.parse(JSON.stringify(this.subAccountTable.row)));
      const hierarchyTableRow = this.processHierarchyWithColumnUpdate(JSON.parse(JSON.stringify(this.hierarchyTable.row)));
      if (this.overallTable.row.length > 0) {
        downloadConfig.data.push({ columns: overallTableHeader, rows: this.overallTable.row });
      }
      if (this.subAccountTable.row.length > 0) {
        downloadConfig.data.push({ columns: subAccountTableHeader, rows: subAccountTableRow });
      }
      if (this.hierarchyTable.row.length > 0 && this.isHierarchyTableVisible) {
        downloadConfig.data.push({ columns: hierarchyTableHeader, rows: hierarchyTableRow });
      }
      downloadConfig.fileDetails = {
        title: `Score Trends Table - By ${this.viewTypeDropdownSelectedName}`,
        fileName: `Score Trends Table - By ${this.viewTypeDropdownSelectedName}`,
        accountName: Helpers?.accountDetails.display_name || Helpers?.accountDetails.name,
        ...(this.isAccountLevel === false ? { brandName: Helpers?.brandDetails?.name } : {}),
        interaction: this.getSelectedInteractionForDownload(),
      }
      if (downloadConfig.data.length) {
        this.responseAnalyticsService.prepareAndDownloadData(downloadConfig);
      }
    } else {
      this.responseAnalyticsService.createDashboardReportingJob({
        "api_url": environment.host + '/v1/litmus_analytics/comparison',
        "brand_id": Helpers.brandDetails._id,
        "field_id": this.viewTypeDropdownSelectedFieldId,
        "field_type": this.viewTypeDropdownSelectedFieldType,
        "question_id": this.trendsSummarySelectedFieldId || 'primary_rating',
        "parameters": [this.overallPayload, this.hierarchyPayload],
        "search_possible_values": true,
        "report_name": `Score Summary - By ${this.viewTypeDropdownSelectedName}`
      });
    }
  }

  // Modified drilldown (Nested Table / Children) table header
  processHierarchyWithColumnUpdate(data) {
    const dfs = (node) => {
      // Modify the columns if they exist
      if (Array.isArray(node.columns) && node.columns.length > 0) {
        node.columns = this.addAdditionalColumn(node.columns);
      }
      if (Array.isArray(node.drillDown) && node.drillDown.length > 0) {
        for (const child of node.drillDown) {
          dfs(child);
        }
      }
    };
    // Continue recursion into drillDown
    for (const item of data) {
      dfs(item);
    }
    return data;
  }

  // Add aditional columns to the report.
  addAdditionalColumn(column) {
    const keysToClone = ["top", "mid", "bottom"];
    const newColumn = JSON.parse(JSON.stringify(column));
    let index = newColumn.length;
    for (let i = 0; i < newColumn.length; i++) {
      const item = newColumn[i];
      if (keysToClone.includes(item.uniqueId)) {
        // Step 1: Change original uniqueId to Abs version
        item.uniqueId = item.uniqueId + "Abs";
        // Step 2: Create a new percentage column
        const copy = JSON.parse(JSON.stringify(item));
        copy.uniqueId = copy.uniqueId.replace("Abs", "Per");
        copy.header = copy.header + " %";
        // Step 3: Add percentage column to array
        newColumn[index++] = copy;
      }
    }
    return newColumn;
  }

  /**
   * Generates a downloadable report for chart data (Bar or Line chart) based on the selected card.
   * 
   * Process:
   * 1. Determines the chart type (bar or line) and retrieves relevant data and labels.
   * 2. Sorts and formats chart data for report generation.
   * 3. Prepares headers and rows including rating metrics (top/mid/bottom) with percentages.
   * 4. Calculates rating values (e.g., NPS or average rating).
   * 5. Creates a configuration object for the download and triggers the report generation.
   *
   * @param {string} cardName - The name of the chart to generate the report for ("barChart" or "lineChart").
   */
  generateChartReport(cardName: string) {
    // Step 1: Chart type, data, and trend
    const isBarChart = cardName === 'barChart';
    const chartDataObj = isBarChart ? this.barChartDataCache : this.lineChartDataCache;
    const trendType = isBarChart ? this.barChartTrendType : this.lineChartTrendType;
    // Step 2: Sort and transform chart data
    const chartData = Object.keys(chartDataObj)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      .map(dateKey => ({ dateKey, ...chartDataObj[dateKey] }));
    // Step 3: Prepare labels and headers
    const labels = this.prepareLabelsForChart(chartDataObj, trendType);
    const { display, top, mid, bottom, rating: ratingLabel } = this.creatingLabels();
    let scaleBasedHeadersAbs: any = [];
    let scaleBasedHeadersPer: any = [];
    if (this.isAccountLevel) {
      // For Account
      const ratingScaleCategories = this.getRatingCategoryByScale(this.scalerRaterType);
      const allScaleValues = [
        ...(ratingScaleCategories.bottom || []),
        ...(ratingScaleCategories.mid || []),
        ...(ratingScaleCategories.top || [])
      ];
      allScaleValues.sort((a, b) => b - a);
      scaleBasedHeadersAbs = allScaleValues.map(value => ({
        uniqueId: `#${value}`,
        header: `#${value}`
      }));
      scaleBasedHeadersPer = allScaleValues.map(value => ({
        uniqueId: `${value}%`,
        header: `${value}%`
      }));
    } else {
      // For Project — use selected question prop/scale, not always primary_rating
      const scaleHeaders = this.getChartDownloadScaleHeaders();
      scaleBasedHeadersAbs = scaleHeaders.abs;
      scaleBasedHeadersPer = scaleHeaders.per;
    }
    // Construct headers
    const header = [
      { uniqueId: "date", header: "Date" },
      { uniqueId: "response", header: "Responses" },
      { uniqueId: "rating", header: display },
      { uniqueId: "top", header: top },
      ...(mid ? [{ uniqueId: "mid", header: mid }] : []),
      { uniqueId: "bottom", header: bottom },
      ...scaleBasedHeadersAbs,
      { uniqueId: "toppercentage", header: `${top} %` },
      ...(mid ? [{ uniqueId: "midpercentage", header: `${mid} %` }] : []),
      { uniqueId: "bottompercentage", header: `${bottom} %` },
      ...scaleBasedHeadersPer
    ];
    // Step 4: Construct rows
    const rows: any = [];
    let chartFilteredData: any = {};
    if (this.isAccountLevel) {
      chartFilteredData = chartData.filter(item => item?.users_rater_primary_rating !== 0);
    } else {
      chartFilteredData = chartData.filter(item => this.hasTrendChartDataForSelectedQuestion(item));
    }
    chartFilteredData.forEach((entry, index) => {
      let total = 0;
      let topValue = 0;
      let midValue = 0;
      let bottomValue = 0;
      let absData: Record<string, any> = {};
      let perData: Record<string, any> = {};
      let ratingValue: any = 'N/A';

      if (this.isAccountLevel) {
        total = entry.users_rater_primary_rating || entry.number_of_users_rated_primary_rating || 0;
        topValue = entry.top || entry.promoters || entry.positives || 0;
        midValue = entry.mid || entry.passives || 0;
        bottomValue = entry.bottom || entry.detractors || entry.negatives || 0;
        const totalResponses = total || 1;
        const distributions = entry?.primary_rating_distributions || {};
        const expectedValues = [
          ...(this.getRatingCategoryByScale(this.scalerRaterType).bottom || []),
          ...(this.getRatingCategoryByScale(this.scalerRaterType).mid || []),
          ...(this.getRatingCategoryByScale(this.scalerRaterType).top || [])
        ].map(String);
        expectedValues.forEach(value => {
          const count = distributions[value];
          absData[`#${value}`] = typeof count === 'number' ? count : 'N/A';
          perData[`${value}%`] = typeof count === 'number'
            ? `${this.computeValue(count, totalResponses, true)}%`
            : 'N/A';
        });
        if (total > 0) {
          if (ratingLabel === 'NPS') {
            topValue = topValue > 0 || Number.isNaN(topValue) ? topValue : 0;
            bottomValue = bottomValue > 0 || Number.isNaN(bottomValue) ? bottomValue : 0;
            const rawNPS = ((topValue - bottomValue) / total) * 100;
            ratingValue = rawNPS % 1 === 0.5 || rawNPS % 1 === -0.5
              ? (rawNPS < 0 ? Math.floor(rawNPS) : Math.ceil(rawNPS))
              : Math.round(rawNPS);
          } else {
            ratingValue = entry.average_rating?.toFixed(2) || 'N/A';
          }
        }
      } else {
        const calculatedData = this.calculateChartDownloadMetrics(entry);
        total = calculatedData.rawResponse || 0;
        topValue = calculatedData.rawTop || 0;
        midValue = calculatedData.rawMid || 0;
        bottomValue = calculatedData.rawBottom || 0;
        const distribution = this.getChartDownloadDistributionCounts(entry);
        const totalResponses = total || 1;
        scaleBasedHeadersAbs.forEach((col) => {
          const ratingKey = col.uniqueId.replace('#', '');
          const count = distribution[ratingKey] ?? 0;
          absData[col.uniqueId] = count;
          perData[`${ratingKey}%`] = `${this.computeValue(count, totalResponses, true)}%`;
        });
        if (total > 0) {
          ratingValue = calculatedData.rating ?? 'N/A';
        }
      }

      const topStr = this.computeValue(topValue, total, false);
      const midStr = this.computeValue(midValue, total, false);
      const bottomStr = this.computeValue(bottomValue, total, false);
      const topPercent = this.computeValue(topValue, total, true) + '%' === 'NaN%' ? 'N/A' : this.computeValue(topValue, total, true) + '%';
      const midPercent = this.computeValue(midValue, total, true) + '%' === 'NaN%' ? 'N/A' : this.computeValue(midValue, total, true) + '%';
      const bottomPercent = this.computeValue(bottomValue, total, true) + '%' === 'NaN%' ? 'N/A' : this.computeValue(bottomValue, total, true) + '%';
      const row: any = {
        date: labels[index],
        response: total,
        rating: ratingValue,
        top: topStr,
        ...(mid ? { mid: midStr } : {}),
        bottom: bottomStr,
        ...absData,
        toppercentage: topPercent,
        ...(mid ? { midpercentage: midPercent } : {}),
        bottompercentage: bottomPercent,
        ...perData
      };
      // Fill in any missing columns with N/A
      header.forEach(col => {
        if (!(col.uniqueId in row)) {
          row[col.uniqueId] = this.isAccountLevel ? 'N/A' : col.uniqueId.includes('%') ? '0.00%' : '0';
        }
      });
      rows.push(row);
    });
    // Step 4.5: Add Total Row
    const totalRow: any = {};
    const numericColumns = new Set<string>();
    const percentColumns = new Set<string>();
    let totalResponses = 0;
    let weightedRatingSum = 0;
    let totalTop = 0;
    let totalMid = 0;
    let totalBottom = 0;
    rows.forEach(row => {
      Object.keys(row).forEach(key => {
        const value = row[key];
        if (typeof value === 'number' || (!isNaN(value) && !value.includes('%'))) {
          const numVal = Number(value);
          if (!isNaN(numVal)) {
            if (!totalRow[key]) totalRow[key] = 0;
            totalRow[key] += numVal;
            numericColumns.add(key);
          }
        }
        if (key === 'response') {
          const response = Number(row[key]);
          totalResponses += response;
        }
        if (key === 'rating' && !isNaN(row[key])) {
          weightedRatingSum += Number(row[key]) * Number(row['response']);
        }
        if (key === 'top' && !isNaN(row[key])) {
          totalTop += Number(row[key]);
        }
        if (key === 'mid' && !isNaN(row[key])) {
          totalMid += Number(row[key]);
        }
        if (key === 'bottom' && !isNaN(row[key])) {
          totalBottom += Number(row[key]);
        }
      });
    });
    // Handle rating
    if (ratingLabel === 'NPS') {
      const rawNPS = ((totalTop - totalBottom) / totalResponses) * 100;
      totalRow['rating'] = Math.round(rawNPS);
    } else {
      totalRow['rating'] = totalResponses > 0 ? (weightedRatingSum / totalResponses).toFixed(2) : 'N/A';
    }
    // Handle percentages
    totalRow['toppercentage'] = this.computeValue(totalTop, totalResponses, true) + '%';
    if (mid) {
      totalRow['midpercentage'] = this.computeValue(totalMid, totalResponses, true) + '%';
    }
    totalRow['bottompercentage'] = this.computeValue(totalBottom, totalResponses, true) + '%';
    // Set label and fill missing
    totalRow['date'] = 'Total';
    header.forEach(col => {
      if (!(col.uniqueId in totalRow)) {
        totalRow[col.uniqueId] = this.isAccountLevel ? 'N/A' : col.uniqueId.includes('%') ? '0.00%' : '0';
      }
    });
    // Find index of the object with uniqueId "bottompercentage"
    const index = header.findIndex(item => item.uniqueId === "bottompercentage");
    // Get all objects after that index
    const afterBottomPercentage = header.slice(index + 1);
    // Step: Calculate total percentage for each rating after bottompercentage in header
    const ratingKeys = afterBottomPercentage.map(item => {
      const num = item.uniqueId.replace('%', ''); // remove '%'
      return `#${num}`; // add '#'
    });
    // Calculate grand total for these ratings using totalRow absolute counts
    const grandTotal = ratingKeys.reduce((acc, key) => {
      const val = totalRow[key];
      if (typeof val === 'number') return acc + val;
      if (typeof val === 'string' && val !== 'N/A') {
        const n = Number(val);
        return acc + (isNaN(n) ? 0 : n);
      }
      return acc;
    }, 0);
    // Calculate and fill total percentage for each rating key in totalRow
    ratingKeys.forEach(key => {
      const percentKey = key.replace('#', '') + '%'; // e.g. "1%"
      const absVal = totalRow[key];
      let absNum = 0;
      if (typeof absVal === 'number') {
        absNum = absVal;
      } else if (typeof absVal === 'string' && absVal !== 'N/A') {
        const n = Number(absVal);
        if (!isNaN(n)) absNum = n;
      }
      if (grandTotal > 0) {
        totalRow[percentKey] = ((absNum / grandTotal) * 100).toFixed(2) + '%' != '0.00%' ? ((absNum / grandTotal) * 100).toFixed(2) + '%' : this.isAccountLevel ? 'N/A' : '0.00%';
      } else {
        totalRow[percentKey] = '0%';
      }
    });
    rows.push(totalRow);
    // Step 5: Download the data
    const downloadConfig = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      fileDetails: {
        title: `Score ${isBarChart ? 'Response' : 'Trends'} Chart - By ${this.chartName}`,
        fileName: `Score ${isBarChart ? 'Response' : 'Trends'} Chart - By ${this.chartName}`,
        accountName: Helpers?.accountDetails.display_name || Helpers?.accountDetails.name,
        ...(this.isAccountLevel === false ? { brandName: Helpers?.brandDetails?.name } : {}),
        interaction: this.getSelectedInteractionForDownload(),
      },
      data: [{ columns: header, rows }]
    };

    this.responseAnalyticsService.prepareAndDownloadData(downloadConfig);
  }

  /**
   * Generates a report for the Top and Bottom Performer chart in tabular format.
   * 
   * Workflow:
   * 1. Prepares the configuration for file download including file name, account name, etc.
   * 2. Loops through `performerChartDataForDownload` to extract chart data.
   * 3. Constructs headers and rows for each dataset using performance metrics.
   * 4. Compiles all data into a final structure and sends it to the download service.
   * 
   */
  generatePerformerChartReport() {
    if (this.isAccountLevel === false && this.downloadPerformerDataFromJob) {
      this.responseAnalyticsService.createDashboardReportingJob({
        "api_url": environment.host + '/v1/litmus_analytics/comparison',
        "brand_id": Helpers.brandDetails._id,
        "field_id": this.performerTypeDropdownSelectedFieldId,
        "field_type": this.performerTypeDropdownSelectedFieldType === 'response' ? 'response' : 'tag',
        "question_id": this.trendsSummarySelectedFieldId || 'primary_rating',
        "parameters": [this.performerPayload, ...this.performerDrilldownPayloads],
        "search_possible_values": true,
        "report_name": `Cohort - By ${this.performerTypeDropdownSelectedName}`
      });
      return;
    }
    // Step 1: Setup download configuration and file details
    let downloadConfig: any = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      fileDetails: {
        title: `Cohort - By ${this.performerTypeDropdownSelectedName}`,
        fileName: `Cohort - By ${this.performerTypeDropdownSelectedName}`,
        accountName: Helpers?.accountDetails.display_name || Helpers?.accountDetails.name,
        ...(this.isAccountLevel === false ? { brandName: Helpers?.brandDetails?.name } : {}),
        interaction: this.getSelectedInteractionForDownload(),
      },
      data: []
    }
    // Step 2: Retrieve label text for rating categories
    const { display, top, mid, bottom } = this.creatingLabels();
    // Step 3: Loop through each chart data set and build headers and rows
    this.performerChartDataForDownload.forEach((table, index) => {
      // Define the table headers for the current chart
      const header = [
        { uniqueId: "name", header: this.performerTypeDropdownProcessedChild ? this.performerTypeDropdownProcessedChild[index]?.name : this.performerTypeDropdownSelectedName },
        { uniqueId: "rating", header: display },
        { uniqueId: "response", header: "Responses" },
        { uniqueId: "weightage", header: "Weightage" },
        { uniqueId: "top", header: top },
        ...(mid ? [{ uniqueId: "mid", header: mid }] : []),
        { uniqueId: "bottom", header: bottom },
        { uniqueId: "toppercentage", header: `${top} %` },
        ...(mid ? [{ uniqueId: "midpercentage", header: `${mid} %` }] : []),
        { uniqueId: "bottompercentage", header: `${bottom} %` },
      ];
      let row: any = [];
      // Populate table rows with chart data
      table.forEach(rows => {
        row.push({
          name: rows?.name,
          rating: rows?.rating,
          response: rows?.response,
          weightage: rows?.weightage,
          top: `${rows?.top}`,
          mid: `${rows?.mid}`,
          bottom: `${rows?.bottom}`,
          toppercentage: `${rows?.topPercent} %`,
          midpercentage: `${rows?.midPercent} %`,
          bottompercentage: `${rows?.bottomPercent} %`,
        })
      })
      // Add processed table data to the config
      downloadConfig.data.push({ columns: header, rows: row });
    })
    // Step 4: Send data to the service to prepare and initiate the download
    this.responseAnalyticsService.prepareAndDownloadData(downloadConfig);
  }

  resolveMultiSelectFieldId(field_id: string, field_value: any, possible_values: any[]): string {
    if (!Array.isArray(possible_values)) {
      return field_id;
    }
    const matched = possible_values.find(
      (pv) => pv.value == field_value || pv.field_id == field_value
    );
    return matched?.field_id ?? field_id;
  }

  // L1 and L2 driver mapping
  checkDriverMapping(payload, detailedFeedbackItems): any[] {
    const l2DriversId: any = [];
    const filters = _.get(payload, 'filters', []);
    const lastFilter = _.last(filters);
    const isValidMultiSelect = _.get(lastFilter, 'field_sub_type') === 'multi-select';
    let fieldId = _.get(lastFilter, 'field_id');
    const fieldValue = _.get(lastFilter, 'field_value');
    if (!isValidMultiSelect || !fieldId || !Array.isArray(detailedFeedbackItems)) {
      return [];
    }
    const l1Option = detailedFeedbackItems.find(item =>
      item?.group_id === fieldId && fieldValue != null && item.value == fieldValue
    );
    if (l1Option?.field_id) {
      fieldId = l1Option.field_id;
    }
    detailedFeedbackItems.forEach(item => {
      const linkedFieldId = item?.linked_field_id;
      if (!linkedFieldId) {
        return;
      }
      const linkedIds = Array.isArray(linkedFieldId) ? linkedFieldId : [linkedFieldId];
      if (linkedIds.includes(fieldId)) {
        l2DriversId.push(item.field_id);
      }
    });
    return l2DriversId;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}